<template>

  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-md-8">
        <div class="card mb-2">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <p class="mb-0">Crear Produccion de Modelo</p>
              <div class="ms-auto d-flex align-items-center gap-2 flex-wrap justify-content-end">
                <argon-button color="success" size="sm" @click="save" :disabled="isSaving">Guardar</argon-button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Información</p>
            <div class="row">
              <div class="col-md-8">
                <label for="production-model-select" class="form-control-label">Modelo</label>
                <select id="production-model-select" ref="modelSelect" class="form-control select2" style="width:100%;" :disabled="isEditingProduction" required>
                  <option :value="null">Seleccione un modelo</option>
                  <option v-for="model in models" :key="model.id" :value="model.id">
                    {{ model.name }} ({{ model.ref }})
                  </option>
                </select>
              </div>

              <div class="col-md-4">
                <label for="purchase-number-input" class="form-control-label">Número de compra</label>
                <argon-input id="purchase-number-input" type="text" v-model="form.purchase_number" placeholder="Ej: OC-0001" />
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Observaciones - Responsable tendido</label>
                <ArgonTextarea type="text" v-model="form.description" />
              </div>

              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Fecha de corte</label>
                <argon-input type="date" v-model="form.delivery_date" />
              </div>

              <div class="col-md-6" v-if="form.id != 0">
                <label for="example-text-input" class="form-control-label">Estado</label>
                <select name="" id="" class="form-select" v-model="form.status" @change="handleStatusChange">>
                  <option value="0">Pendiente</option>
                  <option value="1">Producción</option>
                  <option value="2">Terminado</option>
                  <option value="3">Cancelado</option>
                </select>
              </div>

              <div class="col-md-6" v-if="false && form.id != 0">
                <label for="oficio-select" class="form-control-label">Oficio</label>
                <select id="oficio-select" class="form-select" v-model="form.oficio_id" @change="handleOficioChange">
                  <option :value="null">Seleccionar oficio</option>
                  <option v-for="oficio in processes" :key="oficio.id" :value="oficio.id">
                    {{ oficio.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6" v-if="form.id != 0">
                <label for="bodega-select" class="form-control-label">Bodega</label>
                <select id="bodega-select" class="form-select" v-model="form.bodega_id" @change="handleBodegaChange">
                  <option :value="null">Seleccionar bodega</option>
                  <option v-for="bodega in bodegas" :key="bodega.id" :value="bodega.id">
                    {{ bodega.name }}
                  </option>
                </select>
              </div>

              <div class="col-md-6" v-if="form.id != 0">
                <label for="etapa-select" class="form-control-label">Etapa</label>
                <select ref="etapaSelect" id="etapa-select" class="form-select select2" style="width:100%;" v-model="form.etapa" @change="handleEtapaChange">
                  <option value="">Seleccionar etapa</option>
                  <option v-for="etapa in etapaOptions" :key="etapa" :value="etapa">{{ etapa }}</option>
                </select>
              </div>

              <div class="col-md-6">
                <label for="is-maquila-check" class="form-control-label">Producción de maquila</label>
                <div class="form-check form-switch mt-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="is-maquila-check"
                    v-model="form.is_maquila"
                    @change="handleMaquilaChange"
                  />
                  <label class="form-check-label" for="is-maquila-check">
                    <small class="text-muted">El cliente trajo sus propios insumos</small>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4" v-if="form.id != 0">

        <div class="card mb-2" v-if="hasImages">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Imagenes</p>
            </div>
          </div>
          <div class="card-body">


            <div class="carousel-container">
              <div class="carousel-wrapper">
                <transition name="carousel-fade" mode="out-in">
                  <div class="carousel-image" :key="currentImage" v-if="insumos[currentImage] && insumos[currentImage].model && insumos[currentImage].model.first_image && insumos[currentImage].model.first_image.file_path">
                    <div class="text-center">
                      <img :src="apiUrl + insumos[currentImage].model.first_image.file_path" alt="Imagen principal"
                        class="img-fluid mb-2 w-50">
                      <br>
                      {{ insumos[currentImage].model.name }}
                    </div>
                  </div>
                </transition>
              </div>
              <button @click="prevImage" class="carousel-control-prev"><i class="fa fa-chevron-left"
                  aria-hidden="true"></i></button>
              <button @click="nextImage" class="carousel-control-next"><i class="fa fa-chevron-right"
                  aria-hidden="true"></i></button>
            </div>

          </div>
        </div>

        <div class="card mb-2">
          <div class="card-header">
            <div class="d-flex align-items-center">
              <p class="mb-0">Costo Fijo</p>

              <argon-button color="success" size="sm" class="ms-auto" @click="openModalNovelty">Agregar</argon-button>
            </div>

          </div>
          <div class="card-body pt-0">
            <div v-if="loadingNovelties" class="text-center p-4">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="mt-2 text-sm text-secondary">Cargando...</p>
            </div>
            <div class="table-responsive p-0" v-if="!loadingNovelties">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Detalle</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Total
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Opciones
                    </th>

                  </tr>
                </thead>

                <tbody>
                  <tr v-for="value in novelties.data" :key="value.id">
                    <td
                      style="width: 70%; word-wrap: break-word; white-space: normal; vertical-align: top; text-align: center;">
                      <span class="text-secondary text-xs font-weight-bold">
                        <a @click="viewObservation(value.observation)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                          data-original-title="Registro">
                          <i class="fa fa-comment"></i>
                        </a>
                      </span>

                    </td>
                    <td class="text-center">
                      <h6 class="mb-0 text-sm">{{ parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                        minimumFractionDigits: 2, maximumFractionDigits: 2
                      }) }}</h6>
                    </td>

                    <td class="text-center">
                      <a @click="editRegisterNovelty(value)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                        data-original-title="Eliminar registro">
                        <i class="fa fa-pencil-alt"></i>
                      </a>

                      <a @click="deleteRegisterNovelty(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                        data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>


                  </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Tarjeta de defecto -->
        <!--  v-if="form.status != 0" -->
        <div class="card mb-2" hidden>
          <div class="card-header">
            <div class="d-flex align-items-center">
              <p class="mb-0">Registro defectuosos</p>

              <!-- <argon-button color="success" size="sm" class="ms-auto" @click="openModalDefects">Agregar</argon-button> -->
            </div>

          </div>
          <div class="card-body pt-0">

            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Detalle</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Total
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Opciones
                    </th>

                  </tr>
                </thead>

                <tbody>
                  <tr v-for="value in novelties.data" :key="value.id">
                    <td
                      style="width: 70%; word-wrap: break-word; white-space: normal; vertical-align: top;text-align: center;">
                      <span class="text-secondary text-xs font-weight-bold">
                        <a @click="viewObservation(value.observation)"
                          class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                          data-original-title="Registro">
                          <i class="fa fa-comment"></i>
                        </a>
                      </span>
                    </td>
                    <td class="text-center">
                      <h6 class="mb-0 text-sm">{{ parseFloat(value.total ?? 0).toLocaleString('es-ES', {
                        minimumFractionDigits: 2, maximumFractionDigits: 2
                      }) }}</h6>
                    </td>

                    <td class="text-center">
                      <a @click="editRegisterDefects(value)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                        data-original-title="Eliminar registro">
                        <i class="fa fa-pencil-alt"></i>
                      </a>

                      <a @click="deleteRegisterDefects(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                        data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">

        

        <!-- Tabla modelos e insumos -->
        <div class="card mb-2" v-if="form.id != 0">
          <div class="card-header" :class="collapsedCards.modelos ? 'pb-3' : 'pb-0'">
            <div class="d-flex align-items-center">
              <p class="text-uppercase mb-0 collapsible-title" @click="toggleCard('modelos')">
                <i class="fas me-2" :class="collapsedCards.modelos ? 'fa-chevron-right' : 'fa-chevron-down'"></i>Lista de modelos e insumos
              </p>
              <div class="ms-auto d-flex gap-2">
                <argon-button variant="outline" color="secondary" size="sm" type="button"
                  @click="copyInsumosForExcel" title="Copiar código y cantidad de los insumos utilizados (formato Excel)">
                  <i class="fas fa-copy" aria-hidden="true"></i>
                </argon-button>
                <argon-button v-if="insumos && insumos.length > 0" color="info" size="sm" @click="toggleAllAccordions">
                  {{ todosExpanded ? 'Minimizar todos' : 'Desplegar todos' }}
                </argon-button>
                <argon-button v-if="form.status == 0" color="success" size="sm" @click="openModalModel">
                  Asignar Modelo
                </argon-button>
              </div>
            </div>
          </div>

          <div class="card-body" v-show="!collapsedCards.modelos">
            <div v-if="loadingInsumos" class="text-center p-4">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="mt-2 text-sm text-secondary">Cargando modelos e insumos...</p>
            </div>
            <div class="accordion" id="accordionGrupos" v-if="insumos && insumos.length > 0 && !loadingInsumos">
              <template v-for="(group, index) in insumos" :key="index">
                <div class="accordion-item mb-3">
                  <h2 class="accordion-header" :id="'heading' + index">
                    <button 
                      class="accordion-button bg-primary btn-primary" 
                      :class="{ 'collapsed': index !== 0 }"
                      type="button" 
                      :data-bs-toggle="'collapse'" 
                      :data-bs-target="'#collapse' + index"
                      :aria-expanded="index === 0 ? 'true' : 'false'"
                      :aria-controls="'collapse' + index"
                    >
                      <div class="d-flex justify-content-between align-items-center w-100 me-3">
                        <div class="d-flex align-items-center gap-2" style="flex: 1;">
                          <p style="font-size:14px;font-weight:bold;margin:0">
                            Modelo: {{ group?.model?.name }} - Talla: {{ group?.size?.size }} - Color: {{
                              group?.size?.color?.name }} ({{ group?.size?.color?.ref }}) - Cantidad: {{
                              group?.quantity_to_produce }}
                          </p>
                        </div>
                        <div class="d-flex align-items-center gap-2" @click.stop style="z-index: 10; margin-left: 10px;">
                          <a v-if="form.status == 0" @click="openModalEditModel(group)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Editar modelo">
                            <i class="fa fa-pencil-alt"></i>
                          </a>
                          <a v-if="form.status == 0" @click="duplicateProductionModel(group)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Duplicar modelo e insumos">
                            <i class="fa fa-copy"></i>
                          </a>
                          <a @click="openModalInsumoProduccion(group)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Agregar insumo">
                            <i class="fa fa-plus"></i>
                          </a>
                          <a v-if="form.status == 0" @click="deleteRegister(group.id)"
                            class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                            data-original-title="Eliminar registro">
                            <i class="fa fa-trash"></i>
                          </a>
                        </div>
                      </div>
                    </button>
                  </h2>
                  <div 
                    :id="'collapse' + index" 
                    class="accordion-collapse collapse border border-primary rounded-bottom" 
                    :class="{ 'show': index === 0 }"
                    :aria-labelledby="'heading' + index"
                    data-bs-parent="#accordionGrupos"
                  >
                    <div class="accordion-body p-0">
                      <div class="mb-2 ml-3" style="margin-left: 10px;">
                        <span v-for="(oficio, oIndex) in group.oficios" :key="oIndex"
                          :class="['badge', 'badge-sm', 'bg-gradient-' + (oficio.status === 2 ? 'success' : (oficio.status === 1 ? 'warning' : 'primary'))]"
                          style="margin-right: 5px; cursor: pointer;"
                          title="Filtrar usuarios asignados"
                          @click="applyAssignedUserFiltersFromOficio(group, oficio)">
                          {{ oficio.name }}
                        </span>
                      </div>

                      <div class="table-responsive p-0">
                        <table class="table align-items-center mb-0 rounded-bottom">
                          <thead>
                            <tr>
                              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Insumo</th>
                              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Cant<span> / Stock</span>
                              </th>
                              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Precio</th>
                              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Total</th>
                              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Fecha</th>
                              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Opciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            <!-- Detalles del grupo, agrupados por insumo general -->
                            <template v-for="item in agruparDetallesPorInsumo(group)" :key="item.key">
                              <tr v-if="item.isGroup" class="cursor-pointer" :class="{ 'table-success': item.allDiscounted }"
                                title="Ver inventarios seleccionados" @click="toggleInsumoGroup(item.key)">
                                <td>
                                  <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                      <h6 class="mb-0 text-sm">
                                        <i v-if="item.children.length" class="fa me-1" :class="isInsumoGroupExpanded(item.key) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                                        {{ item.name }}
                                      </h6>
                                      <div class="mt-1">
                                        <span v-if="item.children.length" class="badge bg-secondary">{{ item.children.length }} seleccionados</span>
                                        <span v-if="item.pending > 0" class="badge bg-warning ms-1">
                                          {{ formatQty(item.pending) }} sin inventario seleccionado
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td class="align-middle text-center text-sm font-weight-bold">{{ formatQty(item.quantity) }}</td>
                                <td></td>
                                <td class="align-middle text-center text-sm font-weight-bold">
                                  {{ item.total_price.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                </td>
                                <td></td>
                                <td class="align-middle text-center">
                                  <a @click.stop="openSeleccionInventarioGrupo(item)"
                                    class="font-weight-bold text-xs cursor-pointer"
                                    :class="item.pending > 0 ? 'text-warning' : 'text-primary'"
                                    :title="item.pending > 0 ? 'Seleccionar inventario pendiente' : 'Agregar más inventario'">
                                    <i class="fa fa-check-square"></i>
                                  </a>
                                  <a v-if="item.pendingDetail" @click.stop="deleteRegisterDetail(item.pendingDetail.id)"
                                    class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                                    title="Descartar la cantidad sin inventario seleccionado">
                                    <i class="fa fa-trash"></i>
                                  </a>
                                </td>
                              </tr>
                              <template v-if="!item.isGroup || isInsumoGroupExpanded(item.key)">
                                <tr v-for="detail in (item.isGroup ? item.children : item.details)" :key="detail.id"
                                    :class="{ 'table-success': detail.discounted, 'bg-gray-100': item.isGroup && !detail.discounted }">
                                  <td>
                                    <div class="d-flex px-2 py-1" :class="{ 'ps-5': item.isGroup }">
                                      <div class="d-flex flex-column justify-content-center">
                                        <h6 class="mb-0 text-sm">
                                          {{ detail.inventory?.name || detail.inventory_name }}
                                          <span v-if="detail.inventory">({{ detail.inventory.ref }})</span>
                                          <span v-if="detail.discounted" class="badge bg-success ms-2">Descontado</span>
                                          <span v-else-if="!detail.inventory_id" class="badge bg-warning ms-2 cursor-pointer"
                                            title="Seleccionar qué inventario se usará" @click="openModalSeleccionInventario(detail)">
                                            Sin inventario seleccionado
                                          </span>
                                        </h6>
                                      </div>
                                    </div>
                                  </td>
                                  <td class="align-middle text-center text-sm">
                                    <div v-if="form.status == 0 || form.status == 1" class="d-flex align-items-center justify-content-center gap-1">
                                      <input 
                                        type="number" 
                                        step="0.01"
                                        min="0.01"
                                        :value="detail.quantity" 
                                        @blur="updateQuantity(detail, $event)"
                                        @keyup.enter="updateQuantity(detail, $event)"
                                        class="form-control form-control-sm text-center" 
                                        style="width: 80px; display: inline-block;"
                                      />
                                      <span> / </span>
                                      <span v-if="detail.inventory_id" class="badge" :class="{
                                        'bg-danger': Number(detail.inventory?.quantity || 0) < Number(detail.totalRequired || 0),
                                        'bg-secondary': Number(detail.inventory?.quantity || 0) >= Number(detail.totalRequired || 0)
                                      }" title="Stock del inventario seleccionado">
                                        {{ Number(detail.inventory?.quantity || 0).toFixed(2) }}
                                      </span>
                                      <span v-else class="badge" :class="{
                                        'bg-danger': Number(detail.stockByName || 0) < Number(detail.totalRequiredByName || 0),
                                        'bg-info': Number(detail.stockByName || 0) >= Number(detail.totalRequiredByName || 0)
                                      }" title="Stock total disponible con este nombre">
                                        {{ Number(detail.stockByName || 0).toFixed(2) }}
                                      </span>
                                    </div>
                                    <div v-else>
                                      {{ detail.quantity }}
                                    </div>
                                  </td>
                                  <td class="align-middle text-center text-sm">
                                    <input
                                      v-if="form.status == 0 || form.status == 1"
                                      type="number"
                                      step="0.01"
                                      min="0"
                                      :value="detail.price"
                                      @blur="updatePrice(detail, $event)"
                                      @keyup.enter="updatePrice(detail, $event)"
                                      class="form-control form-control-sm text-center mx-auto"
                                      style="width: 100px; display: inline-block;"
                                    />
                                    <span v-else>
                                      {{ parseFloat(detail.price).toLocaleString('es-ES', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      }) }}
                                    </span>
                                  </td>
                                  <td class="align-middle text-center text-sm">
                                    {{ parseFloat(detail.total_price).toLocaleString('es-ES', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2
                                    }) }}
                                  </td>
                                  <td class="align-middle text-center">
                                    <span class="text-secondary text-xs font-weight-bold">
                                      {{ new Date(detail.updated_at).toLocaleDateString('es-ES') }}
                                    </span>
                                  </td>
                                  <td class="align-middle text-center">
                                    <a @click="editModal(detail)" class="text-secondary font-weight-bold text-xs cursor-pointer"
                                      data-toggle="tooltip" data-original-title="Editar registro">
                                      <i class="fa fa-pencil-alt"></i>
                                    </a>
                                    <a @click="deleteRegisterDetail(detail.id)"
                                      class="text-secondary font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                      style="margin-left: 15px;" data-original-title="Eliminar registro">
                                      <i class="fa fa-trash"></i>
                                    </a>
                                    <a v-if="!item.isGroup" @click="openModalSeleccionInventario(detail)"
                                      class="font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                      style="margin-left: 15px;"
                                      :class="detail.inventory_id ? 'text-primary' : 'text-warning'"
                                      :data-original-title="detail.discounted ? 'Agregar más inventario' : 'Seleccionar inventario a usar'"
                                      :title="detail.discounted ? 'Agregar más inventario' : 'Seleccionar inventario a usar'">
                                      <i class="fa fa-check-square"></i>
                                    </a>
                                    <a @click="toggleDiscount(detail)"
                                      class="font-weight-bold text-xs cursor-pointer" data-toggle="tooltip"
                                      style="margin-left: 15px;" 
                                      :class="detail.discounted ? 'text-success' : 'text-secondary'"
                                      :data-original-title="detail.discounted ? 'Desmarcar como descontado' : 'Marcar como descontado'">
                                      <i :class="detail.discounted ? 'fa fa-check-circle' : 'fa fa-circle'"></i>
                                    </a>
                                  </td>
                                </tr>
                              </template>
                            </template>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div v-else-if="!loadingInsumos" class="text-center text-secondary text-sm p-4">
              No hay registros disponibles
            </div>
          </div>
        </div>

        <!-- Card: Insumos Utilizados -->
        <div class="card mb-2" v-if="form.id != 0">
          <div class="card-header collapsible-title" :class="{ 'pb-3': collapsedCards.insumos }" @click="toggleCard('insumos')">
            <p class="text-uppercase mb-0">
              <i class="fas me-2" :class="collapsedCards.insumos ? 'fa-chevron-right' : 'fa-chevron-down'"></i>Insumos Utilizados
            </p>
          </div>
          <div class="card-body pt-0" v-show="!collapsedCards.insumos">
            <div v-if="loadingInsumos" class="text-center p-4">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="mt-2 text-sm text-secondary">Cargando insumos utilizados...</p>
            </div>
            <div v-if="!loadingInsumos && insumosUtilizadosAgrupados.length > 0">
              <div class="table-responsive">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Insumo</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cantidad</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio Unitario</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                        Acciones
                        <div v-if="form.status == 0 || form.status == 1" class="mt-1">
                          <button class="btn btn-success btn-sm" @click="markAllInsumosAsUtilized">
                            <i class="fas fa-check-circle me-1"></i> Marcar todos
                          </button>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="insumo in insumosUtilizadosAgrupados" :key="insumo.key" :class="{ 'table-success': insumo.allDiscounted }">
                      <td style="white-space: normal; min-width: 180px; max-width: 260px;">
                        <div class="d-flex px-2 py-1">
                          <div class="d-flex flex-column justify-content-center">
                            <h6 class="mb-0 text-sm" style="white-space: normal; word-break: break-word;">
                              {{ insumo.inventory_name }}
                              <span v-if="insumo.refs.length">({{ insumo.refs.join(', ') }})</span>
                            </h6>
                            <span v-if="insumo.pendingSelection > 0" class="badge bg-warning mt-1 cursor-pointer align-self-start"
                              title="Seleccionar qué inventario se usará" @click="openModalSeleccionInventario(insumo.firstPendingDetail)">
                              {{ formatQty(insumo.pendingSelection) }} sin inventario seleccionado
                            </span>
                            <span v-else-if="insumo.someDiscounted && !insumo.allDiscounted" class="badge bg-info mt-1 align-self-start">
                              {{ formatQty(insumo.discountedQuantity) }} de {{ formatQty(insumo.quantity) }} utilizados
                            </span>
                          </div>
                        </div>
                      </td>
                      <td class="align-middle text-center text-sm">
                        <div class="d-flex align-items-center justify-content-center gap-1">
                          <input
                            v-if="(form.status == 0 || form.status == 1) && !insumo.someDiscounted"
                            type="number"
                            step="0.01"
                            min="0.01"
                            :value="insumo.quantity"
                            @blur="updateInsumoTotalQuantity(insumo, $event)"
                            @keyup.enter="updateInsumoTotalQuantity(insumo, $event)"
                            class="form-control form-control-sm text-center"
                            style="width: 80px; display: inline-block;"
                          />
                          <span v-else>
                            {{ formatQty(insumo.quantity) }}
                          </span>
                          <span> / </span>
                          <span class="badge" :class="{
                            'bg-danger': !insumo.allDiscounted && Number(insumo.stock || 0) < Number(insumo.quantity - insumo.discountedQuantity || 0),
                            'bg-secondary': insumo.allDiscounted || Number(insumo.stock || 0) >= Number(insumo.quantity - insumo.discountedQuantity || 0)
                          }" :title="insumo.pendingSelection > 0 ? 'Stock total disponible con este nombre' : 'Stock de los inventarios seleccionados'">
                            {{ Number(insumo.stock || 0).toFixed(2) }}
                          </span>
                        </div>
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ parseFloat(insumo.price).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) }}
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ parseFloat(insumo.total_price).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        }) }}
                      </td>
                      <td class="align-middle text-center">
                        <a
                          @click="markAllInsumoAsDiscounted(insumo)"
                          class="font-weight-bold text-xs cursor-pointer"
                          :class="insumo.allDiscounted ? 'text-danger' : 'text-secondary'"
                          :title="insumo.allDiscounted
                            ? 'Los insumos ya fueron descontados del stock. Click para revertir y volver a sumar al inventario.'
                            : 'Marcar todos los modelos que usan este insumo como utilizados (descontar del stock)'"
                        >
                          <i v-if="insumo.allDiscounted" class="fa fa-undo"></i>
                          <i v-else class="fa fa-check-circle"></i>
                          {{ insumo.allDiscounted ? 'Revertir uso' : 'Marcar como utilizado' }}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4" class="text-end"><strong>Total:</strong></td>
                      <td class="text-center"><strong>{{
                        parseFloat(totalInsumosUtilizados).toLocaleString('es-ES', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })
                      }}</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else-if="!loadingInsumos" class="text-center text-secondary text-sm p-4">
              <p class="mb-0">No hay insumos agregados a la producción.</p>
              <p class="mb-0 text-xs mt-2">Agrega insumos en la sección "Lista de modelos e insumos" para que aparezcan aquí.</p>
            </div>
          </div>
        </div>

        <!-- Usuarios asignados -->
        <div class="card mb-2" v-if="form.id != 0 && form.status > 0" ref="assignedUsersSection">
          <div class="card-header" :class="collapsedCards.usuarios ? 'pb-3' : 'pb-0'">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <p class="text-uppercase mb-0 collapsible-title" @click="toggleCard('usuarios')">
                <i class="fas me-2" :class="collapsedCards.usuarios ? 'fa-chevron-right' : 'fa-chevron-down'"></i>Usuarios asignados
              </p>
              <div class="ms-auto d-flex align-items-center gap-2 flex-wrap justify-content-end">
                <argon-button
                  v-if="form.status > 0"
                  variant="outline"
                  color="secondary"
                  size="sm"
                  type="button"
                  @click="openModalEditQuantities"
                  title="Editar cantidades entregadas"
                >
                  <i class="fas fa-edit" aria-hidden="true"></i>
                  Editar cantidades
                </argon-button>
                <argon-button color="success" v-if="form.status == 1" size="sm" @click="openModal">Asignar
                  usuario</argon-button>
              </div>
            </div>
          </div>

          <div class="card-body" v-show="!collapsedCards.usuarios">
            <div v-if="loadingUsers" class="text-center p-4">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="mt-2 text-sm text-secondary">Cargando usuarios asignados...</p>
            </div>
            <div class="row" v-if="!loadingUsers">
              <!-- Botones de acción masiva -->
              <div class="col-12 mb-3" v-if="selectedItems.length > 0">
                <div class="d-flex gap-2 align-items-center">
                  <span class="text-sm font-weight-bold">{{ selectedItems.length }} elemento(s) seleccionado(s)</span>
                  <argon-button 
                    v-if="canBulkMarkAsReceived"
                    color="info" 
                    size="sm" 
                    @click="bulkMarkAsReceived">
                    Marcar como Recibido
                  </argon-button>
                  <argon-button 
                    v-if="canBulkMarkAsDelivered"
                    color="warning" 
                    size="sm" 
                    @click="bulkMarkAsDelivered">
                    Marcar como Entregado
                  </argon-button>
                  <argon-button 
                    v-if="canBulkMarkAsValidated"
                    color="success" 
                    size="sm" 
                    @click="bulkMarkAsValidated">
                    Marcar como Validado
                  </argon-button>
                  <argon-button 
                    color="secondary" 
                    size="sm" 
                    @click="clearSelection">
                    Limpiar selección
                  </argon-button>
                </div>
              </div>

              <div class="col-12 mb-3">
                <div class="row g-2">
                  <div class="col-md-4">
                    <label class="form-label text-xs mb-1">Buscar usuario</label>
                    <input
                      v-model.trim="assignedUserSearch"
                      type="text"
                      class="form-control form-control-sm"
                      placeholder="Nombre del usuario"
                    />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label text-xs mb-1">Filtrar por modelo</label>
                    <select v-model="assignedModelFilter" class="form-select form-select-sm">
                      <option value="">Todos los modelos</option>
                      <option v-for="model in assignedModelOptions" :key="model.id" :value="String(model.id)">
                        {{ model.label }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label text-xs mb-1">Filtrar por oficio</label>
                    <div class="dropdown" ref="oficioFilterDropdown">
                      <button type="button" class="form-select form-select-sm text-start text-truncate"
                        :aria-expanded="oficioFilterOpen" @click="oficioFilterOpen = !oficioFilterOpen">
                        {{ assignedOficioFilterLabel }}
                      </button>
                      <ul class="dropdown-menu w-100 p-2 oficio-filter-menu" :class="{ show: oficioFilterOpen }">
                        <li class="d-flex justify-content-between mb-1 px-1">
                          <a class="text-xs cursor-pointer" @click="assignedOficioFilter = assignedOficioOptions.map(o => String(o.id))">Todos</a>
                          <a class="text-xs cursor-pointer" @click="assignedOficioFilter = []">Limpiar</a>
                        </li>
                        <li v-for="oficio in assignedOficioOptions" :key="oficio.id" class="px-1">
                          <input type="checkbox" :id="'oficio-filter-' + oficio.id" :value="String(oficio.id)" v-model="assignedOficioFilter">
                          <label class="text-sm ms-1 mb-0" :for="'oficio-filter-' + oficio.id">{{ oficio.name }}</label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 mb-2 d-flex align-items-center gap-2 flex-wrap">
                <template v-if="selectableItemsCount > 0">
                  <input id="assigned-select-all" type="checkbox" @change="toggleSelectAll" :checked="isAllSelected">
                  <label for="assigned-select-all" class="text-xs mb-0">Seleccionar todas las tareas pendientes</label>
                </template>
                <argon-button v-if="baskets.length > 0" variant="outline" color="secondary" size="sm" class="ms-auto mb-0"
                  type="button" @click="openBasketHistory(null)">
                  <i class="fa fa-history me-1"></i> Historial de movimientos
                </argon-button>
              </div>

              <div v-if="oficioCards.length === 0" class="col-12 text-center text-secondary text-sm p-4">
                Los modelos de esta producción no tienen oficios activos. Actívelos en la ficha del modelo.
              </div>

              <!-- Una card por oficio del recorrido del modelo: pendientes y canastas -->
              <div class="col-md-4 mb-3" v-for="card in oficioCards" :key="card.key">
                <div class="card border shadow-none h-100 position-relative" style="max-height: 500px;">
                  <div v-if="refreshingCards[card.key]"
                    class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center rounded"
                    style="background: rgba(255, 255, 255, 0.6); z-index: 2;">
                    <div class="spinner-border text-primary" role="status"></div>
                  </div>
                  <div class="card-header py-2 px-3 bg-gray-100">
                    <div class="d-flex align-items-center flex-wrap gap-1">
                      <h6 class="mb-0 text-sm text-uppercase me-1">{{ card.name }}</h6>
                      <span v-if="card.id" class="badge badge-sm"
                        :class="card.pending === 0 && card.total > 0 ? 'bg-gradient-success' : 'bg-gradient-warning'">
                        {{ card.assigned }} / {{ card.total }}
                      </span>
                      <span class="badge badge-sm bg-gradient-secondary" title="Canastas en este oficio · validadas">
                        {{ card.openCount }} activa(s) · {{ card.validated }} validada(s)
                      </span>
                      <span v-if="card.totalValue > 0" class="badge badge-sm bg-gradient-info">
                        {{ formatMoneyShort(card.totalValue) }}
                      </span>
                      <argon-button v-if="form.status == 1" color="success" size="sm"
                        class="ms-auto mb-0" type="button" @click="openModal({ oficioId: card.id })">
                        <i class="fa fa-user-plus me-1"></i> Asignar
                      </argon-button>
                    </div>
                  </div>
                  <div class="card-body px-3 pt-2 pb-2" style="overflow-y: auto;">
                    <div v-if="card.models.length > 0" class="d-flex flex-wrap align-items-center gap-1 mb-2">
                      <span class="text-xs font-weight-bold me-1">Pendiente:</span>
                      <span v-for="m in card.models" :key="m.id" class="badge bg-light text-dark"
                        :class="{ 'cursor-pointer': form.status == 1 }"
                        :title="form.status == 1 ? 'Asignar este modelo' : ''"
                        @click="form.status == 1 && openModal({ oficioId: card.id, productionModelId: m.id })">
                        {{ m.label }}: {{ m.pending }}
                      </span>
                    </div>

                    <div v-if="cardSelectableTasks(card).length > 0 && form.status == 1" class="d-flex align-items-center gap-2 mb-2">
                      <input :id="'card-select-all-' + card.key" type="checkbox"
                        :checked="isCardAllSelected(card)" @change="toggleCardSelectAll(card)"
                        title="Seleccionar todas las tareas de este oficio">
                      <label :for="'card-select-all-' + card.key" class="text-xs mb-0">Seleccionar todas</label>
                    </div>

                    <div v-if="card.selectedCount > 0" class="d-flex align-items-center flex-wrap gap-2 mb-2">
                      <span class="text-xs font-weight-bold">{{ card.selectedCount }} canasta(s) · {{ card.selectedUnits }} u.</span>
                      <button v-if="cardSelectionTasks(card, 'received').length" type="button" class="btn btn-xs btn-outline-warning mb-0 task-btn"
                        @click="cardBulkAction(card, 'received')">Recibir ({{ cardSelectionTasks(card, 'received').length }})</button>
                      <button v-if="cardSelectionTasks(card, 'delivered').length" type="button" class="btn btn-xs btn-outline-primary mb-0 task-btn"
                        @click="cardBulkAction(card, 'delivered')">Entregar ({{ cardSelectionTasks(card, 'delivered').length }})</button>
                      <button v-if="cardSelectionTasks(card, 'validated').length" type="button" class="btn btn-xs btn-outline-success mb-0 task-btn"
                        title="Validar sin defectos (habilita el pago)" @click="cardBulkAction(card, 'validated')">Validar ({{ cardSelectionTasks(card, 'validated').length }})</button>
                      <argon-button v-if="cardSendableTasks(card).length" color="primary" size="sm"
                        class="mb-0" type="button" @click="openTransferModal(card, cardSendableTasks(card), { branch: true })">
                        <i class="fa fa-exchange-alt me-1"></i> Enviar ({{ cardSendableTasks(card).length }})
                      </argon-button>
                      <argon-button v-if="cardJoinableTasks(card).length" color="dark" size="sm"
                        class="mb-0" type="button" title="Reunir las canastas en paralelo (todos sus procesos validados) y enviarlas"
                        @click="openTransferModal(card, cardJoinableTasks(card))">
                        <i class="fa fa-compress-alt me-1"></i> Reunir y enviar ({{ new Set(cardJoinableTasks(card).map(t => t.basket.id)).size }})
                      </argon-button>
                    </div>

                    <ul class="list-group list-group-flush" v-if="card.tasks.length > 0">
                      <li v-for="task in card.tasks" :key="task.key" class="list-group-item px-0 py-2"
                        :class="{ 'opacity-7': task.closed }">
                        <div class="d-flex align-items-start gap-2">
                          <input v-if="task.basket && !task.closed && form.status == 1" type="checkbox" class="mt-1"
                            :checked="selectedTaskIds.includes(task.id)"
                            @change="toggleTaskSelection(task.id)"
                            title="Seleccionar para cambio de estado o envío masivo">
                          <div class="flex-grow-1" style="min-width: 0;">
                            <div class="d-flex align-items-center flex-wrap gap-1">
                              <span class="text-sm font-weight-bold">
                                {{ task.basket ? 'Canasta #' + task.basket.number : 'Tarea' }} · {{ task.quantity }} u.
                              </span>
                              <span v-if="task.basket?.home_group_id" class="badge badge-sm bg-light text-dark"
                                title="Grupo fijo de la canasta"><i class="fa fa-thumbtack me-1"></i>{{ groupNameById(task.basket.home_group_id) }}</span>
                              <span class="badge badge-sm" :class="taskStatusClass(task.status)">{{ taskStatusLabel(task.status) }}</span>
                              <span v-if="task.type === 'reproceso'" class="badge badge-sm bg-gradient-danger">Reproceso</span>
                              <span v-else-if="task.type === 'transferencia'" class="badge badge-sm bg-gradient-info"
                                :title="task.observation">De {{ task.fromOficioName }}</span>
                              <span v-if="task.finished" class="badge badge-sm bg-gradient-success"
                                :title="task.basket.finished_observation || 'Proceso terminado'">Terminada</span>
                              <span v-else-if="task.closed" class="badge badge-sm bg-light text-dark">→ {{ task.toOficioName }}</span>
                              <span v-if="task.parallel" class="badge badge-sm bg-gradient-dark"
                                :title="'Procesos validados del envío en paralelo: ' + task.parallel.allNames">
                                Paralelo {{ task.parallel.validated }}/{{ task.parallel.total }}
                              </span>
                            </div>
                            <div v-if="task.parallel && !task.closed" class="text-xs text-secondary">
                              <i class="fa fa-code-branch me-1"></i>Con {{ task.parallel.withNames }}
                            </div>
                            <div class="text-xs text-secondary text-truncate">{{ task.modelLabel }}</div>
                            <div class="text-xs">
                              <i :class="task.groupName ? 'fa fa-user-friends' : 'fa fa-user'" class="me-1"></i>
                              {{ task.groupName && task.userName ? task.groupName + ' · ' + task.userName : (task.groupName || task.userName) }}
                              <span v-if="task.value > 0" class="text-secondary"> · {{ formatMoneyShort(task.value) }}</span>
                            </div>
                            <div v-if="task.observation" class="text-xs text-secondary" style="white-space: normal; word-break: break-word;">
                              <i class="fa fa-comment me-1"></i>{{ task.observation }}
                            </div>
                          </div>
                          <div class="d-flex align-items-center flex-wrap justify-content-end gap-2 text-xs">
                            <button v-if="task.status === 'asignada'" type="button" class="btn btn-xs btn-outline-warning mb-0 task-btn"
                              @click="taskBulkAction(task, 'received')">Recibir</button>
                            <button v-if="task.status === 'recibida'" type="button" class="btn btn-xs btn-outline-primary mb-0 task-btn"
                              @click="taskBulkAction(task, 'delivered')">Entregar</button>
                            <button v-if="task.status === 'entregada'" type="button" class="btn btn-xs btn-outline-success mb-0 task-btn"
                              title="Validar (habilita el pago)" @click="taskBulkAction(task, 'validated')">Validar</button>
                            <button v-if="!task.closed && task.status === 'validada' && form.status == 1 && task.parallel"
                              type="button" class="btn btn-xs btn-outline-primary mb-0 task-btn"
                              title="Enviar solo este proceso a otro oficio; la canasta sigue en paralelo y se reúne más adelante"
                              @click="openTransferModal(card, [task], { branch: true, keepGroup: true })">Enviar</button>
                            <button v-if="!task.closed && task.status === 'validada' && form.status == 1 && (!task.parallel || task.parallel.complete)"
                              type="button" class="btn btn-xs btn-primary mb-0 task-btn"
                              :title="task.parallel ? 'Todos los procesos están validados: reunir la canasta y enviarla' : 'Enviar la canasta a otro oficio o persona'"
                              @click="openTransferModal(card, [task], { keepGroup: true })">{{ task.parallel ? 'Reunir y enviar' : 'Enviar' }}</button>
                            <a v-if="task.basket" class="text-secondary cursor-pointer" title="Historial de la canasta"
                              @click="openBasketHistory(task.basket.id)"><i class="fa fa-history"></i></a>
                            <a class="text-secondary cursor-pointer" title="Ver integrantes"
                              @click="toggleTaskExpanded(task.key)">
                              <i class="fa" :class="expandedTasks[task.key] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                            </a>
                            <a v-if="isAdmin && task.finished" class="text-secondary cursor-pointer"
                              title="Reabrir la canasta (vuelve a esta tarea)" @click="reopenBasket(task)"><i class="fa fa-undo"></i></a>
                            <a v-if="isAdmin && task.basket && !task.closed" class="text-secondary cursor-pointer"
                              :title="task.parallel ? 'Quitar este proceso' : (task.type === 'asignacion' ? 'Eliminar canasta' : 'Deshacer movimiento (regresa al oficio anterior)')"
                              @click="deleteBasketTask(task)"><i :class="task.type === 'asignacion' ? 'fa fa-trash' : 'fa fa-undo'"></i></a>
                          </div>
                        </div>

                        <!-- Integrantes: una fila de pago por persona -->
                        <div v-if="expandedTasks[task.key]" class="mt-2 ps-3 border-start">
                          <div v-for="value in task.rows" :key="value.id" class="d-flex align-items-center gap-2 py-1 text-xs">
                            <input v-if="value.validated_date == null" type="checkbox" :value="value.id"
                              :disabled="!canSelectItem(value)" @change="handleCheckboxChange(value, $event)"
                              :checked="selectedItems.includes(value.id)">
                            <span class="flex-grow-1 text-truncate">{{ value.user?.name }}</span>
                            <span title="Recibida / entregada / defectuosa">
                              {{ value.received_quantity }} / {{ value.delivered_quantity }} / {{ value.rejected_quantity }}
                            </span>
                            <span class="text-secondary">{{ formatMoneyShort(value.total) }}</span>
                            <button @click="checkReceived(value)" type="button" class="btn btn-xs btn-outline-warning mb-0 task-btn"
                              v-if="value.received_date == null">Recibir</button>
                            <button @click="checkDelivered(value)" type="button" class="btn btn-xs btn-outline-primary mb-0 task-btn"
                              v-if="(value.received_date != null && value.delivered_date == null) || (value.received_date != null && value.delivered_quantity < value.received_quantity)">
                              Entregar</button>
                            <button @click="checkValidated(value)" type="button" class="btn btn-xs btn-outline-success mb-0 task-btn"
                              title="Validar con defectos"
                              v-if="value.delivered_date != null && value.validated_date == null && value.delivered_quantity >= value.received_quantity">
                              Validar</button>
                            <span style="color: forestgreen;" v-if="value.validated_date != null"><i class="fa fa-check"></i></span>
                            <a v-if="!value.basket_task_id" @click="deleteUserRegister(value.id)" class="text-secondary cursor-pointer"
                              title="Eliminar registro"><i class="fa fa-trash"></i></a>
                            <a @click="generatePdf(value.id)" class="text-danger cursor-pointer" title="Generar PDF">
                              <i class="fa fa-file-pdf"></i></a>
                          </div>
                        </div>
                      </li>
                    </ul>
                    <div v-else class="text-center text-secondary text-xs py-2">
                      Sin canastas en este oficio
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


    <!-- Modal: editar cantidades entregadas (usuarios asignados) -->
    <div class="modal fade" id="ModalEditQuantities" tabindex="-1" aria-labelledby="modalEditQuantitiesLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalEditQuantitiesLabel">Usuarios asignados</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar" @click="closeModalEditQuantities"></button>
          </div>
          <div class="modal-body">
            <div class="row g-2 mb-3">
              <div class="col-md-4">
                <label class="form-label text-xs mb-1">Buscar usuario</label>
                <input
                  v-model.trim="modalQtyUserSearch"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Nombre del usuario"
                />
              </div>
              <div class="col-md-4">
                <label class="form-label text-xs mb-1">Filtrar por modelo</label>
                <select v-model="modalQtyModelFilter" class="form-select form-select-sm">
                  <option value="">Todos los modelos</option>
                  <option v-for="model in assignedModelOptions" :key="model.id" :value="String(model.id)">
                    {{ model.label }}
                  </option>
                </select>
              </div>
              <div class="col-md-4">
                <label class="form-label text-xs mb-1">Filtrar por oficio</label>
                <select v-model="modalQtyOficioFilter" class="form-select form-select-sm">
                  <option value="">Todos los oficios</option>
                  <option v-for="oficio in assignedOficioOptions" :key="oficio.id" :value="String(oficio.id)">
                    {{ oficio.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0 table-sm">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Usuario</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Modelo</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cant. recibida</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" style="min-width: 9rem;">Cant. entregada</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in sortedUsersDataModal" :key="value.id">
                    <td>
                      <h6 class="mb-0 text-sm">{{ value.user?.name ?? '—' }}</h6>
                    </td>
                    <td>
                      <div class="mb-1">
                        <span class="badge badge-sm bg-gradient-primary">
                          {{ value?.oficio?.name ?? 'Sin oficio' }}
                        </span>
                      </div>
                      <div class="text-secondary text-xs font-weight-bold">
                        Talla: {{ value?.model?.size?.size ?? "Full" }}
                      </div>
                      <div class="text-secondary text-xs font-weight-bold">
                        Color: {{ value?.model?.size?.color?.name ?? "Full" }}
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ value.received_quantity }}
                    </td>
                    <td class="align-middle text-center">
                      <input
                        type="number"
                        class="form-control form-control-sm text-center"
                        style="max-width: 120px; margin: 0 auto;"
                        :min="0"
                        step="1"
                        v-model.number="value.delivered_quantity"
                        :disabled="savingDeliveredRowId === value.id"
                        @blur="persistDeliveredQuantity(value, $event)"
                        @keyup.enter="blurQtyInput($event)"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <p v-if="!sortedUsersDataModal.length" class="text-center text-secondary text-sm py-4 mb-0">
                No hay registros con los filtros aplicados.
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="closeModalEditQuantities">Cerrar</button>
          </div>
        </div>
      </div>
    </div>


        <!-- Card: Factura - Resumen de Costos -->
        <div class="card mt-2" v-if="form.id != 0">
          <div class="card-header collapsible-title" :class="{ 'pb-3': collapsedCards.costos }" @click="toggleCard('costos')">
            <p class="text-uppercase mb-0">
              <i class="fas me-2" :class="collapsedCards.costos ? 'fa-chevron-right' : 'fa-chevron-down'"></i>Resumen de Costos
            </p>
          </div>
          <div class="card-body pt-0" v-show="!collapsedCards.costos">
            <div v-if="loadingInsumos" class="text-center p-4">
              <div class="spinner-border text-primary" role="status"></div>
              <p class="mt-2 text-sm text-secondary">Cargando resumen...</p>
            </div>
            <table class="table" v-if="!loadingInsumos">
              <thead>
                <tr>
                  <th>Concepto</th>
                  <th style="text-align:center">Importe</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Total Insumos</td>
                  <td style="text-align:right">{{
                    parseFloat(totalInsumos).toLocaleString('es-ES', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}</td>
                </tr>
                <tr>
                  <td>Total Pagado a Usuarios</td>
                  <td style="text-align:right">{{
                    parseFloat(totalPagadoUsuarios).toLocaleString('es-ES', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}</td>
                </tr>
                <tr>
                  <td>Costo Fijo</td>
                  <td style="text-align:right">{{
                    parseFloat(totalCostoFijo).toLocaleString('es-ES', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}</td>
                </tr>
                <tr>
                  <td><strong>Total General</strong></td>
                  <td style="text-align:right"><strong>{{
                    parseFloat(totalGeneral).toLocaleString('es-ES', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                      }}</strong></td>
                </tr>
                <tr>
                  <td>Total prendas</td>
                  <td style="text-align:right">{{
                    parseFloat(totalPrendas).toLocaleString('es-ES', {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0
                    })
                  }}</td>
                </tr>
                <tr>
                  <td>Costo por Unidad</td>
                  <td style="text-align:right">{{
                    parseFloat(costoPorUnidad).toLocaleString('es-ES', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}</td>
                </tr>

                <tr>
                  <td style="vertical-align:middle">Precio de venta</td>
                  <td style="text-align:right">
                    <input type="text" class="form-control" style="text-align:right" v-model="formattedSellingCost"
                      @blur="handleSellingCostBlur" />
                  </td>
                </tr>

                <tr hidden>
                  <td style="vertical-align:middle">Precio al mayor</td>
                  <td style="text-align:right">
                    <input type="text" class="form-control" style="text-align:right" v-model="formattedWholesalePrice"
                      @blur="handleSellingCostBlur" />
                  </td>
                </tr>

                <tr hidden>
                  <td style="vertical-align:middle">Precio al detal</td>
                  <td style="text-align:right">
                    <input type="text" class="form-control" style="text-align:right" v-model="formattedRetailPrice"
                      @blur="handleSellingCostBlur" />
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>


      </div>


    </div>





    <!-- Modal: transferir canastas a otro oficio -->
    <div class="modal fade" id="ModalTransferBaskets" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Enviar a otro oficio</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
          </div>
          <div class="modal-body">
            <p class="text-sm mb-2">
              Se envían <strong>{{ transferUnits }} u.</strong> ({{ transfer.items.length }} tarea(s)) desde <strong>{{ transfer.fromName }}</strong>
              con las mismas cantidades.
            </p>
            <div v-if="transfer.branchTaskIds.length" class="text-xs text-secondary mb-3">
              <i class="fa fa-code-branch me-1"></i>Se envía solo este proceso en paralelo. La canasta sigue en paralelo y se
              reúne más adelante con <strong>Reunir y enviar</strong> cuando todos sus procesos estén validados.
            </div>
            <div v-else class="mb-3">
              <div class="form-check form-switch d-flex align-items-center w-100 ps-0 mb-1">
                <label class="form-check-label flex-grow-1 mb-0 ms-0" for="transferParallel">Pasa por varios procesos en paralelo</label>
                <input class="form-check-input ms-2 flex-shrink-0" type="checkbox" id="transferParallel" v-model="transfer.parallel"
                  @change="transfer.parallel && transfer.processes.length === 0 && (transfer.processes = [newTransferProcess(), newTransferProcess()])">
              </div>
              <div class="text-xs text-secondary w-100">
                La canasta completa va a cada proceso con la misma cantidad. Cuando todos estén validados se reúne
                con <strong>Reunir y enviar</strong> para seguir a otro oficio.
              </div>
            </div>

            <template v-if="!transfer.parallel">
              <div class="mb-3">
                <label class="form-label">Oficio destino</label>
                <select class="form-select" v-model="transfer.oficio_id" @change="transfer.group_id = transferDefaultGroup(transfer.oficio_id); transfer.user_id = ''">
                  <option value="">Seleccionar oficio</option>
                  <option v-for="oficio in transferOficioOptions" :key="oficio.id" :value="oficio.id">
                    {{ oficio.name }}{{ oficio.passed ? ' (ya pasó)' : '' }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">Grupo</label>
                <select class="form-select" v-model="transfer.group_id" :disabled="!transfer.oficio_id" @change="transfer.user_id = ''">
                  <option value="">Sin grupo (usuario individual)</option>
                  <option v-for="group in transferGroups" :key="group.id" :value="group.id">
                    {{ group.name }} ({{ group.users_count }} integrantes)
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label class="form-label">{{ transfer.group_id ? 'Integrante' : 'Usuario' }}</label>
                <select class="form-select" v-model="transfer.user_id" :disabled="!transfer.oficio_id">
                  <option value="">{{ transfer.group_id ? 'Todo el grupo' : 'Seleccionar usuario' }}</option>
                  <option v-for="user in transferUserOptions(transfer.oficio_id, transfer.group_id)" :key="user.id" :value="user.id">{{ user.name }}</option>
                </select>
              </div>
              <div class="mb-3" v-if="transfer.homeGroupId || transfer.group_id">
                <div v-if="transfer.homeGroupId" class="text-xs mb-1">
                  <i class="fa fa-thumbtack me-1"></i>Grupo fijo de la canasta: <strong>{{ groupNameById(transfer.homeGroupId) }}</strong>
                  <a class="ms-2 cursor-pointer" @click="transfer.fixGroup = transfer.fixGroup === 'unfix' ? '' : 'unfix'">
                    {{ transfer.fixGroup === 'unfix' ? 'Se quitará · deshacer' : 'Quitar' }}
                  </a>
                </div>
                <div v-if="transfer.group_id && transfer.group_id != transfer.homeGroupId">
                  <input type="checkbox" id="transferFixGroup"
                    :checked="transfer.fixGroup === 'fix'" @change="transfer.fixGroup = $event.target.checked ? 'fix' : ''">
                  <label class="text-sm" for="transferFixGroup">
                    Fijar este grupo a la canasta{{ transfer.homeGroupId ? ' (reemplaza al actual)' : '' }}
                  </label>
                </div>
              </div>
            </template>

            <div v-else class="mb-3">
              <label class="form-label mb-1">Procesos</label>
              <div v-for="(process, pIndex) in transfer.processes" :key="pIndex" class="border rounded p-2 mb-2">
                <div class="d-flex align-items-center mb-1">
                  <span class="text-xs font-weight-bold">Proceso {{ pIndex + 1 }}</span>
                  <a v-if="transfer.processes.length > 2" class="ms-auto text-secondary cursor-pointer" title="Quitar proceso"
                    @click="transfer.processes.splice(pIndex, 1)"><i class="fa fa-times"></i></a>
                </div>
                <select class="form-select form-select-sm mb-1" v-model="process.oficio_id" @change="process.group_id = transferDefaultGroup(process.oficio_id); process.user_id = ''">
                  <option value="">Seleccionar oficio</option>
                  <option v-for="oficio in transferOficioOptions" :key="oficio.id" :value="oficio.id">
                    {{ oficio.name }}{{ oficio.passed ? ' (ya pasó)' : '' }}
                  </option>
                </select>
                <select class="form-select form-select-sm mb-1" v-model="process.group_id" :disabled="!process.oficio_id" @change="process.user_id = ''">
                  <option value="">Sin grupo (usuario individual)</option>
                  <option v-for="group in groupsForOficio(process.oficio_id)" :key="group.id" :value="group.id">
                    {{ group.name }} ({{ group.users_count }} integrantes)
                  </option>
                </select>
                <select class="form-select form-select-sm mb-1" v-model="process.user_id" :disabled="!process.oficio_id">
                  <option value="">{{ process.group_id ? 'Todo el grupo' : 'Seleccionar usuario' }}</option>
                  <option v-for="user in transferUserOptions(process.oficio_id, process.group_id)" :key="user.id" :value="user.id">{{ user.name }}</option>
                </select>
                <textarea class="form-control form-control-sm" rows="2" maxlength="255" v-model.trim="process.observation"
                  placeholder="Observación de este proceso (opcional, si no se usa la general)"></textarea>
                <div v-if="observationSuggestions(process.oficio_id).length" class="d-flex flex-wrap gap-1 mt-1">
                  <button v-for="text in observationSuggestions(process.oficio_id)" :key="text" type="button"
                    class="btn btn-xs mb-0 text-truncate observation-suggestion"
                    :class="process.observation === text ? 'btn-secondary' : 'btn-outline-secondary'"
                    :title="text" @click="process.observation = text">{{ text }}</button>
                </div>
              </div>
              <button type="button" class="btn btn-link btn-sm p-0 mb-0" @click="transfer.processes.push(newTransferProcess())">
                <i class="fa fa-plus me-1"></i>Agregar proceso
              </button>
            </div>
            <div class="mb-3">
              <label class="form-label">
                {{ transfer.parallel ? 'Observación general' : 'Observación' }}
                <span class="text-secondary text-xs">(opcional)</span>
              </label>
              <textarea class="form-control" rows="3" maxlength="255" v-model.trim="transfer.observation"
                placeholder="Motivo del traslado (ej. agilidad, error de corte)"></textarea>
              <div v-if="!transfer.parallel && observationSuggestions(transfer.oficio_id).length" class="d-flex flex-wrap gap-1 mt-2">
                <button v-for="text in observationSuggestions(transfer.oficio_id)" :key="text" type="button"
                  class="btn btn-xs mb-0 text-truncate observation-suggestion"
                  :class="transfer.observation === text ? 'btn-secondary' : 'btn-outline-secondary'"
                  :title="text" @click="transfer.observation = text">{{ text }}</button>
              </div>
            </div>
            <div class="mb-3">
              <input type="checkbox" id="transferRework" v-model="transfer.rework">
              <label class="text-sm ms-1" for="transferRework">Marcar como reproceso</label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
            <button v-if="!transfer.parallel" type="button" class="btn btn-success" @click="submitFinish" :disabled="isTransferring"
              title="Terminar la canasta: no se envía a nadie más y su proceso termina aquí">Terminar</button>
            <button type="button" class="btn btn-primary" @click="submitTransfer" :disabled="isTransferring">Enviar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: historial de movimientos de canastas -->
    <div class="modal fade" id="ModalBasketHistory" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ historyTitle }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
          </div>
          <div class="modal-body">
            <div class="table-responsive">
              <table class="table table-sm align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Canasta</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Movimiento</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7" title="Tiempo que la canasta estuvo en esta tarea hasta pasar a la siguiente">Tiempo</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Responsable</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Observación</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Registró</th>
                    <th v-if="isAdmin" class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="move in historyMoves" :key="move.id">
                    <td class="text-xs">{{ new Date(move.created_at).toLocaleString('es-ES') }}</td>
                    <td class="text-xs">
                      #{{ move.basketNumber }} · {{ move.quantity }} u.
                      <div class="text-secondary">{{ move.basket.model?.model?.name }}</div>
                      <div class="text-secondary">T: {{ move.basket.model?.size?.size ?? 'Full' }} · {{ move.basket.model?.size?.color?.name ?? 'Full' }}</div>
                    </td>
                    <td class="text-xs">
                      <span class="badge badge-sm" :class="move.type === 'reproceso' ? 'bg-gradient-danger' : (move.type === 'transferencia' ? 'bg-gradient-info' : 'bg-gradient-secondary')">
                        {{ move.type }}
                      </span>
                      <span v-if="move.split_id" class="badge badge-sm bg-gradient-dark ms-1">paralelo</span>
                      <div>{{ move.fromOficioName ? move.fromOficioName + ' → ' : '' }}{{ move.oficio?.name }}</div>
                    </td>
                    <td class="text-xs text-center">
                      <span class="badge badge-sm text-lowercase" :class="move.closed_at ? 'bg-gradient-success' : 'bg-gradient-warning'"
                        :title="move.closed_at ? 'Hasta ' + new Date(move.closed_at).toLocaleString('es-ES') : 'En curso'">
                        {{ basketTaskDuration(move) }}
                      </span>
                      <div v-if="!move.closed_at" class="text-secondary">en curso</div>
                    </td>
                    <td class="text-xs">{{ move.group?.name || move.user?.name || '—' }}</td>
                    <td class="text-xs" style="white-space: normal;">{{ move.observation || '—' }}</td>
                    <td class="text-xs">{{ move.creator?.name || '—' }}</td>
                    <td v-if="isAdmin" class="text-center">
                      <a v-if="!move.closed_at" class="text-secondary cursor-pointer"
                        :title="move.split_id ? 'Quitar este proceso' : (move.type === 'asignacion' ? 'Eliminar canasta' : 'Deshacer movimiento (regresa al oficio anterior)')"
                        @click="deleteBasketTask(move)"><i :class="move.type === 'asignacion' ? 'fa fa-trash' : 'fa fa-undo'"></i></a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p v-if="!historyMoves.length" class="text-center text-secondary text-sm py-4 mb-0">Sin movimientos.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Asignar tecnico -->
    <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Asignar usuario</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-label">Modelo</label>
                <select v-model="production_user.production_models_id" ref="modelUserSelect" id="modelsUser" class="form-select select2"
                  style="width:100%;">
                  <option value="0">Producción completa</option>
                  <option v-for="(group) in insumos" :key="group.id" :value="group.id">
                    Modelo: {{ group?.model?.name }} - Talla: {{ group?.size?.size }} - Color: {{
                      group?.size?.color?.name
                    }} ({{ group?.size?.color?.ref }}) - Cantidad: {{ group?.quantity_to_produce }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Oficio</label>
                <select v-model="oficio_id" ref="processesSelect" id="oficio" class="form-select select2"
                  style="width:100%;">
                  <option v-for="process in processes" :key="process.id" :value="process.id">
                    {{ process.name }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Usuario</label>
                <select v-model="production_user.user_id" ref="usersSelect" id="users" class="form-select select2"
                  style="width:100%;">

                  <option v-for="process in filteredUsers" :key="process.id" :value="process.id">
                    {{ process.name }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label for="group-select" class="form-label">Grupo <small class="text-muted">(opcional, reemplaza al
                    usuario)</small></label>
                <select v-model="production_user.group_id" ref="grupoSelect" id="group-select" class="form-select select2"
                  style="width:100%;">
                  <option value="0">Sin grupo</option>
                  <option v-for="group in filteredGroups" :key="group.id" :value="group.id">
                    {{ group.name }} ({{ group.users_count }} integrantes)
                  </option>
                </select>
                <small class="text-muted" v-if="selectedGroupForTask">
                  El valor total se dividirá entre {{ selectedGroupForTask.users_count }} integrante(s):
                  {{ perMemberValue }} cada uno.
                </small>
                <div class="form-check mt-1 mb-0" v-if="selectedGroupForTask">
                  <input class="form-check-input" type="checkbox" id="assignFixGroup" v-model="production_user.fix_group">
                  <label class="form-check-label text-sm" for="assignFixGroup">
                    Fijar el grupo a la(s) canasta(s): siempre vuelven a él
                  </label>
                </div>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Cantidad asignada</label>
                <input 
                  type="number" 
                  v-model.number="production_user.received_quantity" 
                  id="amount" 
                  class="form-control"
                  placeholder="Ingrese el valor"
                  :readonly="isProductionCompleteSelected"
                  :max="maxQuantityAllowed"
                  min="0"
                  step="1"
                  @input="validateQuantity"
                >
                <small class="text-muted" v-if="maxQuantityAllowed > 0">
                  Máximo permitido: {{ maxQuantityAllowed }}
                </small>
              </div>

              <div class="mb-3" v-if="!isProductionCompleteSelected">
                <label class="form-label mb-1">División en canastas</label>
                <div v-for="(division, dIndex) in basketsDivision" :key="dIndex" class="d-flex align-items-center gap-2 mb-1">
                  <input type="number" min="1" step="1" class="form-control form-control-sm" style="max-width: 80px;"
                    v-model.number="division.count" title="Cantidad de canastas">
                  <span class="text-sm">canasta(s) de</span>
                  <input type="number" min="1" step="1" class="form-control form-control-sm" style="max-width: 100px;"
                    v-model.number="division.quantity" title="Unidades por canasta">
                  <span class="text-sm">u.</span>
                  <a v-if="basketsDivision.length > 1" class="text-secondary cursor-pointer" title="Quitar"
                    @click="basketsDivision.splice(dIndex, 1)"><i class="fa fa-times"></i></a>
                </div>
                <button type="button" class="btn btn-link btn-sm p-0 mb-1" @click="basketsDivision.push({ count: 1, quantity: 0 })">
                  <i class="fa fa-plus me-1"></i>Agregar tamaño de canasta
                </button>
                <div class="text-xs" :class="basketsDivisionValid ? 'text-success' : 'text-danger'">
                  {{ basketsDivisionCount }} canasta(s) = {{ basketsDivisionTotal }} u.
                  <span v-if="!basketsDivisionValid"> · debe sumar {{ production_user.received_quantity || 0 }}</span>
                  <span v-else> · se crearán {{ basketsDivisionCount }} tarea(s) para el {{ selectedGroupForTask ? 'grupo' : 'usuario' }}: {{ basketsDivisionSummary }}</span>
                </div>
              </div>
              <div class="mb-3 text-xs text-secondary" v-else>
                En producción completa cada modelo se asigna como una canasta con lo que le falta.
              </div>

              <div class="mb-3" v-if="fieldPayment">
                <label for="amount" class="form-label">Valor a pagar por unidad</label>
                <input type="text" v-model="formattedTotalUser" class="form-control" placeholder="Ingrese el valor">
                <small class="text-muted" v-if="!Number(production_user.price)">
                  En 0 se usa el valor configurado para este oficio en cada modelo.
                </small>
              </div>

              <div class="mb-3" v-if="fieldPayment">
                <label for="amount" class="form-label">Valor total</label>
                <input type="text" v-model="totalPriceUser" class="form-control" placeholder="Ingrese el valor"
                  readonly>
              </div>

              <div class="mb-3" v-if="fieldPayment && benefitsOfTasks">
                <label for="benefit" class="form-label">Valor del beneficio por tarea</label>
                <input type="text" v-model="formattedBenefit" class="form-control" placeholder="Ingrese el valor del beneficio">
              </div>

              <div class="mb-3">
                <label for="example-text-input" class="form-control-label">Fecha de asignación</label>
                <argon-input type="date" v-model="production_user.assigned_at" />
              </div>

              <div class="mb-3">
                <label for="example-text-input" class="form-control-label">Fecha de terminación <small class="text-muted">(opcional)</small></label>
                <argon-input type="date" v-model="production_user.termination_date" />
              </div>

              <div class="mb-3">
                <div class="form-check form-switch">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="markAsReceived"
                    v-model="markAsReceived"
                  />
                  <label class="form-check-label" for="markAsReceived">Marcar tarea como recibida</label>
                </div>
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitForm" :disabled="isSavingUser">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Asignar costo adicional -->
    <div class="modal fade" id="ModalNovelty" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar costo adicional</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-label">Valor</label>
                <input type="text" v-model="formattedTotalNovelty" class="form-control" placeholder="Ingrese el valor">
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Descripción</label>
                <ArgonTextarea type="text" v-model="novelty.observation" />
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalNovelty">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitFormNovelty">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Asignar costo adicional -->
    <div class="modal fade" id="ModalDefects" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Regitrar modelos defectuosos</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-label">Valor</label>
                <input type="text" v-model="formattedTotalNovelty" class="form-control" placeholder="Ingrese el valor">
              </div>

              <div class="col-md-12">
                <label for="example-text-input" class="form-control-label">Descripción</label>
                <ArgonTextarea type="text" v-model="novelty.observation" />
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalDefects">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitFormDefects">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Asignar modelo -->
    <div class="modal fade" id="ModalModel" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Asignar Modelo</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label for="amount" class="form-label">Talla - Color (Puede seleccionar múltiples)</label>
                <select v-model="oficio_id" ref="sizesSelect" id="sizes" class="form-select select2" multiple
                  style="width:100%;">
                  <option v-for="process in sizes" :key="process.id" :value="process.id">
                    Talla: {{ process.size || 'N/A' }} - Color: {{ process.color?.name || 'N/A' }} {{ process.color?.ref ? '(' + process.color.ref + ')' : '' }}
                  </option>
                </select>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Cantidad</label>
                <input type="text" v-model="production_model.quantity_to_produce" id="amount" class="form-control"
                  placeholder="Ingrese el valor">
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Costo unitario</label>
                <input type="text" v-model="formattedPrice" class="form-control" placeholder="Ingrese el valor"
                  readonly>
              </div>

              <div class="mb-3">
                <label for="amount" class="form-label">Costo total</label>
                <input type="text" v-model="totalPrice" class="form-control" placeholder="Ingrese el valor" readonly>
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalModel">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitFormModel">Guardar</button>
          </div>
        </div>
      </div>
    </div>


    <!-- Modal Agregar insumo a producción -->
    <div class="modal fade" id="ModalInsumoProduccion" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Agregar insumo</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="mb-3">
                <label for="insumosProduccionSelect" class="form-label">Insumo</label>
                <select ref="insumosProduccionSelect" id="insumosProduccionSelect" class="form-select select2" multiple style="width:100%;">
                  <option v-for="insumo in insumosInventory" :key="insumo.name" :value="insumo.name">
                    {{ insumo.name }} - (Stock: {{ Number(insumo.stock || 0).toFixed(2) }})
                  </option>
                </select>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalInsumoProduccion">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitFormInsumoProduccion">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal: cantidad real utilizada al marcar insumos como utilizados -->
    <div class="modal fade" id="ModalCantidadUtilizada" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">Cantidad utilizada</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p class="text-xs text-secondary mb-2">
              Ingrese la cantidad real utilizada de cada insumo (a veces sobra). Esa cantidad es la que se descontará del inventario
              y quedará registrada en la producción.
            </p>
            <div class="table-responsive">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Insumo</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Modelo</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Requerido</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Stock</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cantidad utilizada</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in cantidadUtilizada.rows" :key="row.id">
                    <td class="align-middle text-sm">
                      {{ row.name }}
                      <div v-if="row.ref" class="text-xs text-secondary">{{ row.ref }}</div>
                    </td>
                    <td class="align-middle text-xs">{{ row.model }}</td>
                    <td class="align-middle text-center text-sm">{{ formatQty(row.required) }}</td>
                    <td class="align-middle text-center text-sm">
                      <span v-if="row.manage_stock">{{ formatQty(row.stock) }}</span>
                      <span v-else class="text-secondary text-xs">No maneja stock</span>
                    </td>
                    <td class="align-middle text-center">
                      <input type="number" step="0.01" min="0" class="form-control form-control-sm text-center d-inline-block"
                        style="width: 110px;" v-model.number="row.used" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
            <button type="button" class="btn btn-success" :disabled="cantidadUtilizada.saving" @click="submitCantidadUtilizada">
              Descontar del inventario
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Seleccionar inventario a usar -->
    <div class="modal fade" id="ModalSeleccionInventario" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">Seleccionar inventario: {{ seleccionInventario.detail?.inventory_name }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="seleccionInventario.loading" class="text-center p-3">
              <div class="spinner-border text-primary" role="status"></div>
            </div>
            <template v-else>
              <template v-if="seleccionInventario.extra">
                <p class="text-sm mb-2">
                  Cantidad actual: <strong>{{ Number(seleccionInventario.baseQuantity || 0).toFixed(2) }}</strong>
                  &nbsp;|&nbsp; Adicional seleccionado: <strong class="text-success">{{ seleccionTotal.toFixed(2) }}</strong>
                </p>
                <p class="text-xs text-secondary mb-2">
                  Marque los registros de inventario adicionales que hagan falta;
                  se agregarán como filas nuevas de este insumo.
                </p>
              </template>
              <template v-else>
              <p class="text-sm mb-2">
                Cantidad requerida: <strong>{{ Number(seleccionInventario.required || 0).toFixed(2) }}</strong>
                &nbsp;|&nbsp; Seleccionada:
                <strong :class="seleccionTotal > Number(seleccionInventario.required || 0) + 0.0001 ? 'text-danger' : 'text-success'">
                  {{ seleccionTotal.toFixed(2) }}
                </strong>
              </p>
              <p class="text-xs text-secondary mb-2">
                Marque los registros de inventario que se usarán. Si selecciona varios, el insumo se divide por registro;
                la cantidad no cubierta queda pendiente.
              </p>
              </template>
              <input type="text" class="form-control form-control-sm mb-2"
                v-model="seleccionInventario.search" placeholder="Buscar por nombre, código o descripción..." />
              <div v-if="seleccionInventario.searching" class="text-xs text-secondary mb-2">Buscando en insumos...</div>
              <div v-if="seleccionInventario.items.length === 0 && !seleccionInventario.search" class="text-center text-secondary text-sm p-3">
                No hay inventario con stock para este insumo.
              </div>
              <div v-else-if="seleccionInventarioFiltrados.length === 0" class="text-center text-secondary text-sm p-3">
                No hay resultados para la búsqueda.
              </div>
              <div v-else class="table-responsive">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"></th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Insumo</th>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Stock</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cantidad a usar</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in seleccionInventarioFiltrados" :key="item.id" :class="{ 'table-active': item.checked }">
                      <td class="align-middle">
                        <input type="checkbox" v-model="item.checked" @change="onSeleccionInventarioCheck(item)" />
                      </td>
                      <td class="align-middle text-sm">
                        {{ item.name }}
                        <div class="text-xs text-secondary">{{ item.ref }}</div>
                        <div v-if="item.description" class="text-xs text-secondary">{{ item.description }}</div>
                      </td>
                      <td class="align-middle text-sm">{{ new Date(item.created_at).toLocaleDateString('es-ES') }}</td>
                      <td class="align-middle text-center text-sm">
                        <span v-if="item.manage_stock">{{ Number(item.quantity || 0).toFixed(2) }}</span>
                        <span v-else class="text-secondary">No maneja stock</span>
                      </td>
                      <td class="align-middle text-center text-sm">
                        {{ parseFloat(item.price || 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                      </td>
                      <td class="align-middle text-center">
                        <input type="number" step="0.001" min="0" class="form-control form-control-sm text-center d-inline-block"
                          style="width: 100px;" v-model.number="item.use_quantity" :disabled="!item.checked" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button v-if="seleccionInventario.detail?.inventory_id && !seleccionInventario.extra" type="button" class="btn btn-outline-secondary me-auto"
              @click="unassignInventario">Quitar selección</button>
            <button type="button" class="btn btn-secondary" @click="closeModalSeleccionInventario">Cerrar</button>
            <button type="button" class="btn btn-primary" :disabled="seleccionInventario.saving" @click="submitSeleccionInventario">Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="ModalEditInsumo" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Editar insumo</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <form>

              <div class="mb-3">
                <label class="form-label">Insumo</label>
                <select ref="insumosEditSelect" id="insumosEdit" class="form-select select2" style="width:100%;">
                  <option v-for="insumo in insumosInventory" :key="insumo.name" :value="insumo.name">
                    {{ insumo.name }} - (Stock: {{ Number(insumo.stock || 0).toFixed(2) }})
                  </option>
                </select>
              </div>

            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeEditModal">Cerrar</button>
            <button type="button" class="btn btn-primary" @click="submitEditForm">Guardar</button>
          </div>
        </div>
      </div>
    </div>


  </div>

</template>



<style>
.collapsible-title { cursor: pointer; user-select: none; }
.oficio-filter-menu { max-height: 300px; overflow-y: auto; }
.carousel-container {
  position: relative;
  text-align: center;
  min-height: 300px;
  overflow: hidden;
}

.carousel-wrapper {
  position: relative;
  width: 100%;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-image {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Transiciones suaves para el carrusel */
.carousel-fade-enter-active {
  transition: opacity 0.6s ease-in-out, transform 0.6s ease-in-out;
}

.carousel-fade-leave-active {
  transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
}

.carousel-fade-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.carousel-fade-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

.carousel-fade-enter-to,
.carousel-fade-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 50% !important;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: #f9b002 !important;
  border: none;
  cursor: pointer;
  padding: 10px 15px;
  border-radius: 5px;
  z-index: 10;
  transition: all 0.3s ease;
  font-size: 18px;
}

.carousel-control-prev:hover,
.carousel-control-next:hover {
  background-color: rgba(0, 0, 0, 0.8);
  transform: translateY(-50%) scale(1.15);
}

.carousel-control-prev {
  left: 10px;
}

.carousel-control-next {
  right: 10px;
}

.task-btn {
  padding: 2px 8px;
  font-size: 0.7rem;
  line-height: 1.4;
  text-transform: none;
}
</style>


<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal, Collapse } from 'bootstrap';

import productionUsersService from "../../../services/productionUsers.service";

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_IMAGE_URL,
      showMenu: false,
      isSaving: false,
      isSavingUser: false,
      todosExpanded: false,
      collapsedCards: (() => {
        const def = { modelos: true, insumos: true, costos: true, usuarios: true };
        try { return { ...def, ...JSON.parse(localStorage.getItem('production.collapsedCards') || '{}') }; } catch (e) { return def; }
      })(),
      modalBudget: null,
      modalEditQuantities: null,
      modalQtyUserSearch: '',
      modalQtyModelFilter: '',
      modalQtyOficioFilter: '',
      modalDeliveredSnapshot: {},
      savingDeliveredRowId: null,
      modalNovelty: null,
      modalDefects: null,
      modalModel: null,
      modalInsumoProduccion: null,
      modalEdit: null,
      modalSeleccionInventario: null,
      expandedInsumoGroups: {},
      modalCantidadUtilizada: null,
      cantidadUtilizada: {
        rows: [],
        saving: false,
      },
      seleccionInventario: {
        detail: null,
        extra: false,
        mergeIds: [],
        required: 0,
        baseQuantity: 0,
        items: [],
        search: '',
        searching: false,
        loading: false,
        saving: false,
      },
      seleccionInventarioSearchTimer: null,
      selectedGroup: null,
      editingProductionModelId: null,
      oficio_id: null,
      processes: [],
      isLoadingSizes: false,
      loadingInsumos: false,
      loadingUsers: false,
      loadingNovelties: false,
      lastLoadedModelId: null,
      form: {
        id: 0,
        model_id: null,
        purchase_number: '',
        description: '',
        status: 0,
        delivery_date: '',
        selling_cost: 0,
        wholesale_price: 0,
        retail_price: 0,
        oficio_id: null,
        bodega_id: null,
        etapa: '',
        is_maquila: false
      },
      size: {
        size: '',
        color_id: '',
        model_id: '',
        quantity: 0,
        status: 1
      },
      filteredUsers: [],
      groups: [],
      bodegas: [],
      models: [],
      insumos: [],
      currentImage: 0,
      insumosInventory: [],
      sizes: [],
      users: [],
      colors: [],
      purchases: [],
      purchase: {
        id: 0,
        inventory_id: 0,
        quantity: 0,
        price: 0,
        total_price: 0,
        supplier_name: ''
      },
      production_user: {
        id: 0,
        user_id: 0,
        group_id: 0,
        fix_group: false,
        production_models_id: 0,
        oficio_id: 0,
        production_id: 0,
        received_quantity: 0,
        delivered_quantity: 0,
        price: 0,
        benefit: 0,
        assigned_at: '',
        termination_date: null,
      },
      benefitsOfTasks: false,
      production_model: {
        id: 0,
        production_id: 0,
        model_id: 0,
        size_id: 0,
        bodega_id: '',
        quantity_to_produce: 0,
        price: 0,
      },
      data: {},
      modal: {
        id: 0,
        user_id: null,
        project_id: null,
        amount: "",
        status: "active"
      },
      novelty: {
        id: 0,
        production_id: 0,
        total: 0,
        observation: ''
      },
      fieldPayment: false,
      modalEvidencia: [],
      novelties: [],
      selectedItems: [], // Array para almacenar los IDs seleccionados
      total_modal_quantity: 0,
      markAsReceived: false,
      assignedUserSearch: '',
      assignedModelFilter: '',
      assignedOficioFilter: [],
      oficioFilterOpen: false,
      // Canastas: división de la cantidad asignada y movimientos entre oficios
      baskets: [],
      basketsDivision: [{ count: 1, quantity: 0 }],
      refreshingCards: {},
      // Tareas de canasta seleccionadas en las cards (por tarea: los procesos en paralelo comparten canasta)
      selectedTaskIds: [],
      expandedTasks: {},
      modalTransfer: null,
      isTransferring: false,
      transfer: {
        defaultGroupId: '',
        branchTaskIds: [],
        items: [],
        fromName: '',
        oficio_id: '',
        group_id: '',
        user_id: '',
        observation: '',
        rework: false,
        parallel: false,
        processes: [],
      },
      modalBasketHistory: null,
      historyBasketId: null,
    };
  },
  components: { ArgonInput, ArgonTextarea, ArgonButton },
  computed: {
    seleccionTotal() {
      return this.seleccionInventario.items
        .filter(i => i.checked)
        .reduce((sum, i) => sum + Number(i.use_quantity || 0), 0);
    },
    seleccionInventarioFiltrados() {
      const term = (this.seleccionInventario.search || '').trim().toLowerCase();
      if (!term) return this.seleccionInventario.items;
      return this.seleccionInventario.items.filter(i =>
        [i.name, i.ref, i.description].some(v => String(v ?? '').toLowerCase().includes(term))
      );
    },
    isEditingProduction() {
      return parseInt(this.form.id) > 0;
    },
    formattedTotalNovelty: {
      get() {
        // Formatea el precio a punto de mil y sin decimales
        return Math.floor(this.novelty.total).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el precio sin decimales
        this.novelty.total = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    formattedTotalUser: {
      get() {
        // Formatea el precio a punto de mil y sin decimales
        return Math.floor(this.production_user.price).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el precio sin decimales
        this.production_user.price = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    totalPriceUser() {
      // Calcula el total y aplica el formateo
      const total = this.production_user.received_quantity * this.production_user.price;
      return total
        ? total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        : "0";
    },
    formattedBenefit: {
      get() {
        // Formatea el beneficio a punto de mil y sin decimales
        return Math.floor(this.production_user.benefit || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el beneficio sin decimales
        this.production_user.benefit = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    maxQuantityAllowed() {
      // Calcular la cantidad máxima permitida según el modelo seleccionado
      if (!this.$refs.modelUserSelect || !this.insumos || this.insumos.length === 0) {
        return 0;
      }
      
      try {
        const val = $(this.$refs.modelUserSelect).val();
        let maxCant = 0;

        // Con oficio seleccionado el máximo es lo que falta por asignar de ese oficio
        if (this.oficio_id && this.oficio_id != 0) {
          return this.pendingForOficio(val === null ? 0 : val, this.oficio_id);
        }
        
        if (parseInt(val) === 0 || val === '0' || val === null) {
          // Producción completa: suma de todas las cantidades
          maxCant = this.insumos.reduce((acc, item) => acc + (parseFloat(item.quantity_to_produce) || 0), 0);
        } else {
          // Talla específica seleccionada
          const selected = this.insumos.find(insumo => insumo.id === parseInt(val));
          maxCant = selected ? (parseFloat(selected.quantity_to_produce) || 0) : 0;
        }
        
        return maxCant;
      } catch (error) {
        console.error('Error calculando cantidad máxima:', error);
        return 0;
      }
    },
    isProductionCompleteSelected() {
      return parseInt(this.production_user.production_models_id) === 0;
    },
    filteredGroups() {
      if (this.oficio_id && this.oficio_id != 0) {
        return this.groups.filter(group => this.groupHasOficio(group, this.oficio_id));
      }
      return this.groups;
    },
    selectedGroupForTask() {
      return this.groups.find(group => group.id == this.production_user.group_id) || null;
    },
    perMemberValue() {
      if (!this.selectedGroupForTask || !this.selectedGroupForTask.users_count) {
        return "0";
      }
      const total = (parseFloat(this.production_user.received_quantity) || 0) * (parseFloat(this.production_user.price) || 0);
      const perMember = total / this.selectedGroupForTask.users_count;
      return perMember.toLocaleString('es-CO', { maximumFractionDigits: 2 });
    },
    formattedPrice: {
      get() {
        // Usar el precio del modelo, no del production_model
        const price = this.form.price || 0;
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
    },
    totalPrice() {
      // Calcula el total usando el precio del modelo
      // Convertir price a número (manejar formato con puntos de miles)
      let price = 0;
      if (typeof this.form.price === 'string') {
        // Si tiene punto decimal, separar parte entera y decimal
        const parts = this.form.price.split('.');
        if (parts.length > 1) {
          // El último segmento es la parte decimal, los anteriores son miles
          const decimalPart = parts[parts.length - 1];
          const integerPart = parts.slice(0, -1).join('');
          price = parseFloat(integerPart + '.' + decimalPart) || 0;
        } else {
          // Solo parte entera con puntos de miles
          price = parseFloat(this.form.price.replace(/\./g, '')) || 0;
        }
      } else {
        price = parseFloat(this.form.price) || 0;
      }
      
      // Convertir quantity a número
      let quantity = 0;
      if (typeof this.production_model.quantity_to_produce === 'string') {
        quantity = parseFloat(this.production_model.quantity_to_produce.replace(/\./g, '').replace(',', '.')) || 0;
      } else {
        quantity = parseFloat(this.production_model.quantity_to_produce) || 0;
      }
      
      const total = quantity * price;
      // Formatear el resultado con puntos de miles y mantener decimales
      if (total === 0) return "0";
      
      // Separar parte entera y decimal
      const totalStr = total.toFixed(2);
      const [integerPart, decimalPart] = totalStr.split('.');
      const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return formattedInteger + '.' + decimalPart;
    },
    formattedSellingCost: {
      get() {
        const sellingCost = Math.round(this.form.selling_cost || 0);
        return sellingCost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        const numericValue = parseFloat(value.replace(/\./g, "")) || 0;
        this.form.selling_cost = numericValue;
      }
    },
    formattedWholesalePrice: {
      get() {
        const val = Math.round(this.form.wholesale_price || 0);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        const numericValue = parseFloat(value.replace(/\./g, "")) || 0;
        this.form.wholesale_price = numericValue;
      }
    },
    formattedRetailPrice: {
      get() {
        const val = Math.round(this.form.retail_price || 0);
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        const numericValue = parseFloat(value.replace(/\./g, "")) || 0;
        this.form.retail_price = numericValue;
      }
    },
    // Suma la cantidad de insumos (elementos en el array de detalles) de todos los grupos
    totalInsumos() {
      return this.insumos.reduce((groupSum, group) => {
        return groupSum + group.details.reduce((detailSum, detail) => {
          return detailSum + parseFloat(detail.total_price);
        }, 0);
      }, 0);
    },
    // Total pagado a usuarios (valor definido en form)
    totalPagadoUsuarios() {
      return Array.isArray(this.data.data)
        ? this.data.data.reduce((sum, value) => sum + (parseFloat(value.total) || 0), 0)
        : 0;
    },
    // Total de costos fijos (tabla de costos fijos)
    totalCostosAdicionales() {
      return Array.isArray(this.novelties.data)
        ? this.novelties.data.reduce((sum, novelty) => sum + (parseFloat(novelty.total) || 0), 0)
        : 0;
    },
    totalPrendas() {
      return this.insumos.reduce((sum, group) => {
        const rawQuantity = group?.quantity_to_produce;
        const quantity = typeof rawQuantity === 'string'
          ? parseFloat(rawQuantity.replace(/\./g, '').replace(',', '.')) || 0
          : parseFloat(rawQuantity) || 0;
        return sum + quantity;
      }, 0);
    },
    // Costo Fijo: suma de la tabla de costos fijos multiplicada por el total de prendas
    totalCostoFijo() {
      return this.totalCostosAdicionales * this.totalPrendas;
    },
    // Suma de Total Insumos + Total Pagado a Usuarios + Costo Fijo
    totalGeneral() {
      return this.totalInsumos + this.totalPagadoUsuarios + this.totalCostoFijo;
    },
    // Costo por unidad: total general dividido entre el total de prendas a producir
    costoPorUnidad() {
      return this.totalPrendas ? this.totalGeneral / this.totalPrendas : 0;
    },
    // Agrupar y totalizar todos los insumos utilizados (sin necesidad de estar descontados)
    // Insumos de todos los modelos agrupados por nombre (incluye los que aún no tienen inventario seleccionado)
    insumosUtilizadosAgrupados() {
      const agrupados = {};

      this.insumos.forEach(group => {
        (group.details || []).forEach(detail => {
          const name = detail.inventory_name || detail.inventory?.name || 'N/A';
          if (!agrupados[name]) {
            agrupados[name] = {
              key: name,
              inventory_name: name,
              details: [],
              refs: [],
              inventories: {},
              quantity: 0,
              total_price: 0,
              discountedQuantity: 0,
              pendingSelection: 0,
              firstPendingDetail: null,
              stockByName: Number(detail.stockByName) || 0,
            };
          }
          const item = agrupados[name];
          const quantity = Number(detail.quantity) || 0;

          item.details.push(detail);
          item.quantity += quantity;
          item.total_price += Number(detail.total_price) || 0;

          if (this.isDiscounted(detail)) {
            item.discountedQuantity += quantity;
          }
          if (detail.inventory_id) {
            item.inventories[detail.inventory_id] = Number(detail.inventory?.quantity) || 0;
            if (detail.inventory?.ref && !item.refs.includes(detail.inventory.ref)) {
              item.refs.push(detail.inventory.ref);
            }
          } else {
            item.pendingSelection += quantity;
            item.firstPendingDetail = item.firstPendingDetail || detail;
          }
        });
      });

      return Object.values(agrupados).map(item => {
        const selectedStock = Object.values(item.inventories).reduce((sum, qty) => sum + qty, 0);
        return {
          ...item,
          price: item.quantity > 0 ? item.total_price / item.quantity : 0,
          // Si falta seleccionar inventario se muestra el stock total disponible con ese nombre
          stock: item.pendingSelection > 0 ? item.stockByName : selectedStock,
          allDiscounted: item.details.length > 0 && item.details.every(d => this.isDiscounted(d)),
          someDiscounted: item.details.some(d => this.isDiscounted(d)),
        };
      }).sort((a, b) => a.inventory_name.localeCompare(b.inventory_name));
    },
    // Total general de insumos utilizados
    totalInsumosUtilizados() {
      return this.insumosUtilizadosAgrupados.reduce((sum, item) => {
        return sum + (parseFloat(item.total_price) || 0);
      }, 0);
    },
    // Verificar si hay imágenes reales para mostrar en el carrusel
    hasImages() {
      if (!this.insumos || this.insumos.length === 0) {
        return false;
      }
      return this.insumos.some(group => {
        return group.model && 
               group.model.first_image && 
               group.model.first_image.file_path;
      });
    },
    // Computed properties para selección masiva
    selectableItemsCount() {
      // Contar solo los items que no están validados
      return Array.isArray(this.data.data) 
        ? this.data.data.filter(item => item.validated_date == null).length 
        : 0;
    },
    isAllSelected() {
      // Verificar si todos los items seleccionables están seleccionados
      if (!Array.isArray(this.data.data)) return false;
      const selectableItems = this.data.data.filter(item => item.validated_date == null);
      if (selectableItems.length === 0) {
        return false;
      }
      // Si hay items seleccionados, verificar que todos los del mismo estado estén seleccionados
      if (this.selectedItems.length === 0) {
        return false;
      }
      const state = this.selectedItemsState;
      if (!state) {
        return false;
      }
      const itemsOfSameState = selectableItems.filter(item => this.getItemState(item) === state);
      return itemsOfSameState.length > 0 && itemsOfSameState.every(item => this.selectedItems.includes(item.id));
    },
    canBulkMarkAsReceived() {
      // Solo puede marcar como recibido si hay items seleccionados que no tienen received_date
      if (!Array.isArray(this.data.data)) return false;
      return this.selectedItems.length > 0 && this.data.data.some(item => 
        this.selectedItems.includes(item.id) && item.received_date == null
      );
    },
    canBulkMarkAsDelivered() {
      // Solo puede marcar como entregado si hay items seleccionados que tienen received_date pero no delivered_date
      if (!Array.isArray(this.data.data)) return false;
      return this.selectedItems.length > 0 && this.data.data.some(item => 
        this.selectedItems.includes(item.id) && item.received_date != null && item.delivered_date == null
      );
    },
    canBulkMarkAsValidated() {
      // Solo puede marcar como validado si hay items seleccionados que tienen delivered_date pero no validated_date
      if (!Array.isArray(this.data.data)) return false;
      return this.selectedItems.length > 0 && this.data.data.some(item => 
        this.selectedItems.includes(item.id) && item.delivered_date != null && item.validated_date == null
      );
    },
    selectedItemsState() {
      // Obtener el estado del primer elemento seleccionado
      if (!Array.isArray(this.data.data) || this.selectedItems.length === 0) {
        return null;
      }
      const firstSelected = this.data.data.find(item => this.selectedItems.includes(item.id));
      if (!firstSelected) {
        return null;
      }
      return this.getItemState(firstSelected);
    },
    assignedModelOptions() {
      if (!Array.isArray(this.data?.data)) return [];

      const map = new Map();
      this.data.data.forEach((item) => {
        const productionModelId = item?.production_models_id ?? item?.model?.id;
        if (!productionModelId) return;

        const modelName = item?.model?.model?.name ?? 'Sin modelo';
        const modelRef = item?.model?.model?.ref ?? '';
        const sizeName = item?.model?.size?.size ?? 'Full';
        const colorName = item?.model?.size?.color?.name ?? 'Full';
        const colorRef = item?.model?.size?.color?.ref ?? '';
        const colorSuffix = colorRef ? ` (${colorRef})` : '';

        const label = `${modelRef ? '(' + modelRef + ') ' : ''}${modelName} - Talla: ${sizeName} - Color: ${colorName}${colorSuffix}`;

        map.set(productionModelId, {
          id: productionModelId,
          name: modelName,
          label,
        });
      });

      return Array.from(map.values()).sort((a, b) => a.label.localeCompare(b.label));
    },
    assignedOficioOptions() {
      const map = new Map();
      (this.insumos || []).forEach(pm => (pm.oficios || []).forEach(o => map.set(o.id, { id: o.id, name: o.name })));
      if (!Array.isArray(this.data?.data)) return Array.from(map.values());

      this.data.data.forEach((item) => {
        const oficioId = item?.oficio?.id;
        const oficioName = item?.oficio?.name;
        if (!oficioId || !oficioName) return;

        map.set(oficioId, {
          id: oficioId,
          name: oficioName,
        });
      });

      return Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name));
    },
    assignedOficioFilterLabel() {
      const selected = this.assignedOficioFilter;
      if (!selected.length) return 'Todos los oficios';
      const names = this.assignedOficioOptions.filter(o => selected.includes(String(o.id))).map(o => o.name);
      return names.length <= 2 ? names.join(', ') : `${names.length} oficios seleccionados`;
    },
    filteredUsersData() {
      if (!Array.isArray(this.data?.data)) return [];

      const search = (this.assignedUserSearch || '').toLowerCase().trim();
      const selectedModel = this.assignedModelFilter ? String(this.assignedModelFilter) : '';
      const selectedOficios = this.assignedOficioFilter;

      return this.data.data.filter((item) => {
        const userName = (item?.user?.name || '').toLowerCase();
        const modelId = item?.production_models_id ?? item?.model?.id ?? '';
        const oficioId = item?.oficio?.id ?? '';

        const matchesUser = !search || userName.includes(search);
        const matchesModel = !selectedModel || String(modelId) === selectedModel;
        const matchesOficio = !selectedOficios.length || selectedOficios.includes(String(oficioId));

        return matchesUser && matchesModel && matchesOficio;
      });
    },
    // Cards de usuarios asignados: una por oficio del recorrido de los modelos (más los oficios que ya tienen tareas).
    // Cada canasta que pasó por el oficio es una tarea; las filas de pago (una por integrante) van dentro.
    oficioCards() {
      const cards = new Map();
      const ensure = (id, name) => {
        const key = id ? String(id) : 'none';
        if (!cards.has(key)) {
          cards.set(key, { key, id: id || null, name: name || 'Sin oficio', tasks: [], models: [], total: 0, pending: 0 });
        }
        return cards.get(key);
      };

      (this.insumos || []).forEach(pm => {
        (pm.oficios || []).forEach(oficio => {
          const card = ensure(oficio.id, oficio.name);
          const pending = Number(oficio.pending_quantity) || 0;
          card.total += Number(pm.quantity_to_produce) || 0;
          card.pending += pending;
          if (pending > 0) {
            card.models.push({
              id: pm.id,
              label: `${pm.model?.name ?? ''} ${pm.size?.size ?? ''} ${pm.size?.color?.name ?? ''}`.trim(),
              pending,
            });
          }
        });
      });

      const visibleRowIds = new Set(this.sortedUsersData.map(r => r.id));
      const rowsByTask = {};
      (this.data?.data || []).forEach(r => {
        if (r.basket_task_id) (rowsByTask[r.basket_task_id] = rowsByTask[r.basket_task_id] || []).push(r);
      });
      const sumTotal = rows => rows.reduce((sum, r) => sum + (parseFloat(r.total) || 0), 0);

      (this.baskets || []).forEach(basket => {
        const modelLabel = this.productionModelLabel(basket.model);
        (basket.tasks || []).forEach(task => {
          const rows = rowsByTask[task.id] || [];
          if (!rows.some(r => visibleRowIds.has(r.id))) return;
          const links = this.basketTaskLinks(basket, task, rowsByTask);
          ensure(task.oficio_id, task.oficio?.name).tasks.push({
            key: 'b' + task.id,
            id: task.id,
            basket,
            type: task.type,
            observation: task.observation,
            quantity: task.quantity,
            closed: !!task.closed_at,
            // Última tarea de una canasta terminada (no sigue a ningún oficio)
            finished: !!basket.finished_at && !!task.closed_at && !links.toOficioName,
            rows,
            status: this.rowsStatus(rows),
            groupName: task.group?.name,
            groupId: task.group_id || null,
            userName: task.user?.name,
            oficioName: task.oficio?.name,
            fromOficioName: links.fromOficioName,
            toOficioName: links.toOficioName,
            parallel: links.parallel,
            modelLabel,
            value: sumTotal(rows),
          });
        });
      });

      // Tareas anteriores a las canastas: las filas de un mismo grupo se muestran como una sola tarea
      const legacy = new Map();
      this.sortedUsersData.filter(r => !r.basket_task_id).forEach(r => {
        const key = r.group_id
          ? `g${r.group_id}-${r.production_models_id}-${r.oficio_id}-${r.received_quantity}-${String(r.assigned_at).slice(0, 10)}`
          : `r${r.id}`;
        if (!legacy.has(key)) {
          legacy.set(key, { key, oficioId: r.oficio_id, oficioName: r.oficio?.name, rows: [], first: r });
        }
        legacy.get(key).rows.push(r);
      });
      legacy.forEach(item => {
        ensure(item.oficioId, item.oficioName).tasks.push({
          key: item.key,
          id: null,
          oficioId: item.oficioId,
          basket: null,
          type: null,
          observation: item.first.observation,
          quantity: item.first.received_quantity,
          closed: false,
          rows: item.rows,
          status: this.rowsStatus(item.rows),
          groupName: item.first.group?.name,
          groupId: item.first.group_id || null,
          userName: item.first.group_id ? null : item.first.user?.name,
          modelLabel: this.productionModelLabel(item.first.model),
          value: sumTotal(item.rows),
        });
      });

      const selectedOficios = this.assignedOficioFilter;

      return Array.from(cards.values())
        .filter(card => !selectedOficios.length || selectedOficios.includes(card.key))
        .map(card => {
          const tasks = [...card.tasks].sort((a, b) =>
            (a.closed - b.closed) || ((a.basket?.number ?? 0) - (b.basket?.number ?? 0)));
          const selected = tasks.filter(t => t.basket && !t.closed && this.selectedTaskIds.includes(t.id));
          return {
            ...card,
            tasks,
            assigned: card.total - card.pending,
            openCount: tasks.filter(t => !t.closed).length,
            validated: tasks.filter(t => t.status === 'validada').length,
            totalValue: tasks.reduce((sum, t) => sum + t.value, 0),
            selectedTasks: selected,
            selectedCount: selected.length,
            selectedUnits: selected.reduce((sum, t) => sum + (Number(t.quantity) || 0), 0),
          };
        });
    },
    // Opciones de etapa: los oficios por los que pasan los modelos de la producción (en orden).
    // Si la etapa guardada no es uno de ellos (etapas anteriores) se conserva como opción.
    etapaOptions() {
      const names = [];
      (this.insumos || []).forEach(pm => (pm.oficios || []).forEach(o => {
        if (o.name && !names.includes(o.name)) names.push(o.name);
      }));
      if (this.form.etapa && !names.includes(this.form.etapa)) names.push(this.form.etapa);
      return names;
    },
    basketsDivisionCount() {
      return this.basketsDivision.reduce((sum, d) => sum + (parseInt(d.count) || 0), 0);
    },
    basketsDivisionTotal() {
      return this.basketsDivision.reduce((sum, d) => sum + (parseInt(d.count) || 0) * (parseInt(d.quantity) || 0), 0);
    },
    basketsDivisionSummary() {
      return this.basketsDivision
        .filter(d => parseInt(d.count) > 0 && parseInt(d.quantity) > 0)
        .map(d => `${parseInt(d.count)} de ${parseInt(d.quantity)} u.`)
        .join(' + ');
    },
    basketsDivisionValid() {
      return this.basketsDivisionCount > 0 && this.basketsDivisionTotal === (parseInt(this.production_user.received_quantity) || 0);
    },
    transferUnits() {
      return this.transfer.items.reduce((sum, item) => sum + item.quantity, 0);
    },
    // Oficios destino: los del recorrido de los modelos de las tareas a enviar
    transferOficioOptions() {
      const modelIds = new Set(this.transfer.items.map(item => item.modelId));
      const map = new Map();
      (this.insumos || []).filter(pm => modelIds.has(pm.id)).forEach(pm => {
        (pm.oficios || []).forEach(o => map.set(o.id, { id: o.id, name: o.name }));
      });
      return Array.from(map.values()).map(o => ({
        ...o,
        passed: this.transfer.items.some(item => item.passedOficioIds.includes(o.id)),
      }));
    },
    transferGroups() {
      return this.groupsForOficio(this.transfer.oficio_id);
    },
    historyMoves() {
      const baskets = (this.baskets || []).filter(b => !this.historyBasketId || b.id === this.historyBasketId);
      return baskets
        .flatMap(basket => (basket.tasks || []).map(task => ({
          ...task,
          basket,
          basketNumber: basket.number,
          modelLabel: this.productionModelLabel(basket.model),
          fromOficioName: this.basketTaskLinks(basket, task).fromOficioName,
        })))
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at) || b.id - a.id);
    },
    isAdmin() {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        return user?.role === "1" || user?.role === 1;
      } catch {
        return false;
      }
    },
    historyTitle() {
      const basket = (this.baskets || []).find(b => b.id === this.historyBasketId);
      return basket
        ? `Historial canasta #${basket.number} · ${this.productionModelLabel(basket.model)}`
        : 'Historial de movimientos de canastas';
    },
    // Ordenar datos por estado de tarea (recibir, entregar, validar, validado)
    sortedUsersData() {
      if (!Array.isArray(this.filteredUsersData)) {
        return [];
      }
      return [...this.filteredUsersData].sort((a, b) => {
        // Función para obtener la prioridad del estado de la tarea
        const getTaskStatusPriority = (task) => {
          if (!task.received_date) {
            return 1; // Sin recibir
          } else if (!task.delivered_date) {
            return 2; // Sin entregar
          } else if (!task.validated_date) {
            return 3; // Sin validar
          } else {
            return 4; // Validado
          }
        };

        const priorityA = getTaskStatusPriority(a);
        const priorityB = getTaskStatusPriority(b);

        // Ordenar por prioridad primero
        if (priorityA !== priorityB) {
          return priorityA - priorityB;
        }

        // Si tienen la misma prioridad, ordenar por fecha de creación descendente
        const dateA = new Date(a.created_at || a.assigned_at || 0);
        const dateB = new Date(b.created_at || b.assigned_at || 0);
        if (dateB.getTime() !== dateA.getTime()) {
          return dateB.getTime() - dateA.getTime();
        }

        // Si tienen la misma fecha, ordenar por ID descendente
        return (b.id || 0) - (a.id || 0);
      });
    },

    filteredUsersDataModal() {
      if (!Array.isArray(this.data?.data)) return [];

      const search = (this.modalQtyUserSearch || '').toLowerCase().trim();
      const selectedModel = this.modalQtyModelFilter ? String(this.modalQtyModelFilter) : '';
      const selectedOficio = this.modalQtyOficioFilter ? String(this.modalQtyOficioFilter) : '';

      return this.data.data.filter((item) => {
        const userName = (item?.user?.name || '').toLowerCase();
        const modelId = item?.production_models_id ?? item?.model?.id ?? '';
        const oficioId = item?.oficio?.id ?? '';

        const matchesUser = !search || userName.includes(search);
        const matchesModel = !selectedModel || String(modelId) === selectedModel;
        const matchesOficio = !selectedOficio || String(oficioId) === selectedOficio;

        return matchesUser && matchesModel && matchesOficio;
      });
    },
    sortedUsersDataModal() {
      if (!Array.isArray(this.filteredUsersDataModal)) {
        return [];
      }
      return [...this.filteredUsersDataModal].sort((a, b) => {
        const getTaskStatusPriority = (task) => {
          if (!task.received_date) {
            return 1;
          }
          if (!task.delivered_date) {
            return 2;
          }
          if (!task.validated_date) {
            return 3;
          }
          return 4;
        };

        const priorityA = getTaskStatusPriority(a);
        const priorityB = getTaskStatusPriority(b);

        if (priorityA !== priorityB) {
          return priorityA - priorityB;
        }

        const dateA = new Date(a.created_at || a.assigned_at || 0);
        const dateB = new Date(b.created_at || b.assigned_at || 0);
        if (dateB.getTime() !== dateA.getTime()) {
          return dateB.getTime() - dateA.getTime();
        }

        return (b.id || 0) - (a.id || 0);
      });
    },

  },
  watch: {
    'seleccionInventario.search': function (value) {
      clearTimeout(this.seleccionInventarioSearchTimer);
      const term = (value || '').trim();
      // Buscar también en todos los insumos por nombre o código, aunque no estén relacionados
      if (term.length < 2) {
        this.seleccionInventario.searching = false;
        return;
      }
      this.seleccionInventarioSearchTimer = setTimeout(() => this.buscarInventarioSeleccion(term), 400);
    },
    'form.id': function () {
      this.$nextTick(() => {
        this.syncModelSelectDisabledState();
      });
    },
    'form.bodega_id': function () {
      this.handleBodegaChange();
    },
    'form.model_id': function (newVal, oldVal) {
      this.production_model.model_id = newVal || 0;
      // Solo llamar getSizes si el valor realmente cambió y no es la inicialización
      if (newVal && newVal !== oldVal && this.lastLoadedModelId !== newVal) {
        this.getSizes();
      } else if (!newVal) {
        this.sizes = [];
        this.lastLoadedModelId = null;
      }
      // Actualizar Select2 cuando cambie el valor (sin trigger para evitar loops)
      this.$nextTick(() => {
        if (this.$refs.modelSelect) {
          const currentVal = $(this.$refs.modelSelect).val();
          if (currentVal !== String(newVal)) {
            $(this.$refs.modelSelect).val(newVal);
          }
        }
      });
    },
    'production_user.received_quantity': function (newVal) {
      // Validar la cantidad asignada comparándola con total_modal_quantity
      const cantDigitada = parseFloat(newVal) || 0;
      const totalModal = parseFloat(this.total_modal_quantity) || 0;
      
      // Si la cantidad digitada es mayor que total_modal_quantity, igualar a total_modal_quantity
      if (totalModal > 0 && cantDigitada > totalModal) {
        this.production_user.received_quantity = totalModal;
        return;
      }

      // Con una sola canasta la división sigue a la cantidad asignada
      if (this.basketsDivision.length === 1 && Number(this.basketsDivision[0].count) === 1) {
        this.basketsDivision[0].quantity = cantDigitada;
      }
    },
    'oficio_id': function () {
      // Cuando cambia el modelo seleccionado, validar la cantidad
      // Nota: Este watcher se ejecuta cuando cambia oficio_id, pero el select de modelo
      // también actualiza production_user.production_models_id en el evento change de select2
      // donde ya se llama a validateQuantity()
    },
    /* oficio_id(newVal) {
      const val = parseInt(newVal);
      if (val === 0) {
        // Suma total
        //this.production_user.received_quantity = this.insumos.reduce((acc, item) => acc + item.quantity_to_produce, 0);
      } else {
        // Solo cantidad del insumo seleccionado
        //const selected = this.insumos.find(i => i.id === val);
        //this.production_user.received_quantity = selected?.quantity_to_produce || 0;
      }
    }, */
    'insumos': {
      handler(newVal) {
        // Inicializar currentImage al primer índice con imagen válida
        if (newVal && newVal.length > 0) {
          const validIndices = this.getValidImageIndices();
          if (validIndices.length > 0 && !validIndices.includes(this.currentImage)) {
            this.currentImage = validIndices[0];
          }
        }
      },
      immediate: true
    },
  },
  methods: {
    closeOficioFilterOnOutsideClick(event) {
      const el = this.$refs.oficioFilterDropdown;
      if (this.oficioFilterOpen && el && !el.contains(event.target)) this.oficioFilterOpen = false;
    },
    toggleCard(key) {
      this.collapsedCards[key] = !this.collapsedCards[key];
      try { localStorage.setItem('production.collapsedCards', JSON.stringify(this.collapsedCards)); } catch (e) { /* ignore */ }
    },
    escapeProductionClipboardCell(raw) {
      if (raw == null || raw === '') {
        return '';
      }
      return String(raw).replace(/\t/g, ' ').replace(/\r?\n/g, ' ').trim();
    },
    /** Copia Item, Producto (código del inventario) y Cantidad de los insumos utilizados, una fila por código. */
    async copyInsumosForExcel() {
      const byCode = new Map();
      (this.insumos || []).forEach(group => {
        (group.details || []).forEach(detail => {
          // Sin inventario seleccionado aún no hay código: se usa el nombre del insumo
          const code = detail.inventory?.ref || detail.inventory_name || detail.inventory?.name || 'N/A';
          const row = byCode.get(code) || { qty: 0, unit: '' };
          row.qty += Number(detail.quantity) || 0;
          row.unit = row.unit || detail.inventory?.kubapp_unidad || '';
          byCode.set(code, row);
        });
      });

      if (byCode.size === 0) {
        await Swal.fire({
          icon: 'info',
          title: 'Sin insumos',
          text: 'No hay insumos utilizados en esta producción para copiar.',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      const rows = [['Item', 'Producto', 'Cantidad', 'Unidad'].join('\t')];
      [...byCode.entries()]
        .sort(([a], [b]) => a.localeCompare(b))
        .forEach(([code, { qty, unit }], idx) => {
          rows.push([
            String(idx + 1),
            this.escapeProductionClipboardCell(code),
            qty.toFixed(2),
            this.escapeProductionClipboardCell(unit),
          ].join('\t'));
        });
      const tsv = rows.join('\n');

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(tsv);
        } else {
          const ta = document.createElement('textarea');
          ta.value = tsv;
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }
        await Swal.fire({
          icon: 'success',
          title: 'Copiado',
          text: 'Insumos listos para pegar en Excel (Ctrl+V).',
          timer: 2200,
          showConfirmButton: false,
        });
      } catch (e) {
        await Swal.fire({
          icon: 'error',
          title: 'No se pudo copiar',
          text: 'El navegador bloqueó el portapapeles.',
          confirmButtonText: 'Aceptar',
        });
      }
    },
    syncModelSelectDisabledState() {
      if (this.$refs.modelSelect) {
        $(this.$refs.modelSelect).prop('disabled', this.isEditingProduction);
      }
    },
    applyAssignedUserFiltersFromOficio(group, oficio) {
      const productionModelId = group?.id ?? group?.production_models_id ?? null;
      this.assignedModelFilter = productionModelId ? String(productionModelId) : '';

      let oficioId = oficio?.id ?? oficio?.oficio_id ?? null;
      if (!oficioId && oficio?.name) {
        const match = this.assignedOficioOptions.find((item) => item.name === oficio.name);
        oficioId = match?.id ?? null;
      }
      this.assignedOficioFilter = oficioId ? [String(oficioId)] : [];
      if (this.collapsedCards.usuarios) this.toggleCard('usuarios');

      this.$nextTick(() => {
        const section = this.$refs.assignedUsersSection;
        if (section && typeof section.scrollIntoView === 'function') {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    validateQuantity() {
      // Validar que la cantidad asignada no exceda el máximo permitido
      if (!this.$refs.modelUserSelect) {
        return;
      }
      
      const maxAllowed = this.maxQuantityAllowed;
      const currentQuantity = parseFloat(this.production_user.received_quantity) || 0;
      
      if (maxAllowed > 0 && currentQuantity > maxAllowed) {
        this.production_user.received_quantity = maxAllowed;
      }
      
      // También validar que no sea negativa
      if (currentQuantity < 0) {
        this.production_user.received_quantity = 0;
      }
    },
    isDiscounted(detail) {
      return detail.discounted === true || detail.discounted === 1 || detail.discounted === "1" ||
        String(detail.discounted).toLowerCase() === 'true';
    },
    // Agrupa los detalles de un modelo por insumo general (group_name); los que tienen varios registros se muestran desplegables
    agruparDetallesPorInsumo(group) {
      const map = new Map();
      (group.details || []).forEach(detail => {
        const name = detail.group_name || detail.inventory_name || detail.inventory?.name || 'N/A';
        if (!map.has(name)) {
          map.set(name, { key: `${group.id}-${name}`, name, details: [], quantity: 0, total_price: 0, pending: 0 });
        }
        const item = map.get(name);
        item.details.push(detail);
        item.quantity += Number(detail.quantity) || 0;
        item.total_price += Number(detail.total_price) || 0;
        if (!detail.inventory_id) item.pending += Number(detail.quantity) || 0;
      });
      // El insumo del modelo es el padre: dentro solo van los inventarios asignados,
      // la cantidad sin inventario se muestra en el padre
      return Array.from(map.values()).map(item => ({
        ...item,
        isGroup: item.details.length > 1,
        children: item.details.filter(d => d.inventory_id),
        pendingDetail: item.details.find(d => !d.inventory_id && !d.discounted) || null,
        allDiscounted: item.details.every(d => d.discounted),
      }));
    },
    toggleInsumoGroup(key) {
      this.expandedInsumoGroups = { ...this.expandedInsumoGroups, [key]: !this.expandedInsumoGroups[key] };
    },
    isInsumoGroupExpanded(key) {
      return !!this.expandedInsumoGroups[key];
    },
    formatQty(value) {
      return parseFloat(value || 0).toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    },
    toggleAllAccordions() {
      this.$nextTick(() => {
        const accordion = document.getElementById('accordionGrupos');
        if (!accordion) return;

        const collapseElements = accordion.querySelectorAll('.accordion-collapse');
        
        if (this.todosExpanded) {
          // Colapsar todos y restaurar data-bs-parent para comportamiento normal
          collapseElements.forEach((element) => {
            const collapse = Collapse.getInstance(element) || new Collapse(element, { toggle: false });
            collapse.hide();
          });
          // Restaurar data-bs-parent después de un pequeño delay
          setTimeout(() => {
            collapseElements.forEach((element) => {
              element.setAttribute('data-bs-parent', '#accordionGrupos');
            });
          }, 350);
          this.todosExpanded = false;
        } else {
          // Remover data-bs-parent para permitir múltiples acordeones abiertos
          collapseElements.forEach((element) => {
            element.removeAttribute('data-bs-parent');
          });
          // Expandir todos
          collapseElements.forEach((element) => {
            const collapse = Collapse.getInstance(element) || new Collapse(element, { toggle: false });
            collapse.show();
          });
          this.todosExpanded = true;
        }
      });
    },
    nextImage() {
      const validIndices = this.getValidImageIndices();
      if (validIndices.length === 0) return;
      
      const currentIndex = validIndices.indexOf(this.currentImage);
      const nextIndex = (currentIndex + 1) % validIndices.length;
      this.currentImage = validIndices[nextIndex];
    },
    prevImage() {
      const validIndices = this.getValidImageIndices();
      if (validIndices.length === 0) return;
      
      const currentIndex = validIndices.indexOf(this.currentImage);
      const prevIndex = (currentIndex - 1 + validIndices.length) % validIndices.length;
      this.currentImage = validIndices[prevIndex];
    },
    getValidImageIndices() {
      return this.insumos
        .map((group, index) => {
          if (group.model && 
              group.model.first_image && 
              group.model.first_image.file_path) {
            return index;
          }
          return null;
        })
        .filter(index => index !== null);
    },
    editModal(detail) {
      this.purchase = {
        id: detail.id,
        inventory_name: detail.inventory_name,
        quantity: detail.quantity,
      };

      $('#insumosEdit').val(detail.inventory_name).trigger('change');
      const modalElement = document.getElementById('ModalEditInsumo');
      this.modalEdit = new Modal(modalElement); // Guarda la instancia del modal
      this.modalEdit.show(); // Muestra el modal
    },
    closeEditModal() {
      if (this.modalEdit) {
        this.modalEdit.hide(); // Cierra el modal
      }
    },
    openSeleccionInventarioGrupo(item) {
      // Si queda cantidad pendiente se selecciona su inventario; si no, se agregan inventarios adicionales al grupo
      const pending = item.details.find(d => !d.inventory_id && !d.discounted);
      if (pending) {
        this.openModalSeleccionInventario(pending);
      } else {
        this.openModalSeleccionInventario(item.details[0], { extra: true, baseQuantity: item.quantity });
      }
    },
    async openModalSeleccionInventario(detail, { extra = false, baseQuantity = null } = {}) {
      extra = extra || !!detail.discounted;
      // Filas del mismo insumo (mismo modelo) con inventario ya seleccionado y aún sin descontar:
      // se muestran marcadas y al guardar se reemplazan junto con esta fila
      const groupName = detail.group_name || detail.inventory_name;
      const siblings = extra ? [] : (this.insumos.find(g => g.id === detail.production_model_id)?.details || [])
        .filter(d => d.id !== detail.id && d.inventory_id && !d.discounted
          && (d.group_name || d.inventory_name) === groupName);
      this.seleccionInventario = {
        detail,
        extra,
        mergeIds: siblings.map(d => d.id),
        required: [detail, ...siblings].reduce((sum, d) => sum + Number(d.quantity || 0), 0),
        baseQuantity: baseQuantity ?? Number(detail.quantity || 0),
        items: [],
        search: '',
        searching: false,
        loading: true,
        saving: false,
      };
      const modalElement = document.getElementById('ModalSeleccionInventario');
      this.modalSeleccionInventario = Modal.getOrCreateInstance(modalElement);
      this.modalSeleccionInventario.show();

      try {
        const data = await this.$store.dispatch('productionDetails/getAvailableInventory', { id: detail.id });
        // Cantidad ya seleccionada por inventario (al agregar inventario adicional no se pre-marca nada)
        const previous = new Map();
        if (!extra) {
          [detail, ...siblings].filter(d => d.inventory_id).forEach(d => {
            const id = Number(d.inventory_id);
            previous.set(id, (previous.get(id) || 0) + Number(d.quantity || 0));
          });
        }
        const items = data.inventories || [];
        // Inventarios ya seleccionados que no vinieron en la lista (p. ej. sin stock)
        [detail, ...siblings].forEach(d => {
          if (d.inventory && previous.has(Number(d.inventory_id)) && !items.some(i => Number(i.id) === Number(d.inventory_id))) {
            items.push(d.inventory);
          }
        });
        this.seleccionInventario.items = items.map(item => {
          const checked = previous.has(Number(item.id));
          return {
            ...item,
            checked,
            use_quantity: checked ? Math.round(previous.get(Number(item.id)) * 1000) / 1000 : 0,
          };
        });
      } catch (error) {
        this.closeModalSeleccionInventario();
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.data?.message || 'No se pudo cargar el inventario disponible',
        });
      } finally {
        this.seleccionInventario.loading = false;
      }
    },
    async buscarInventarioSeleccion(term) {
      const detail = this.seleccionInventario.detail;
      if (!detail) return;
      this.seleccionInventario.searching = true;
      try {
        const data = await this.$store.dispatch('productionDetails/getAvailableInventory', { id: detail.id, search: term });
        // Ignorar respuestas de búsquedas anteriores o de otro insumo
        if (this.seleccionInventario.detail !== detail || this.seleccionInventario.search.trim() !== term) return;
        const existing = new Set(this.seleccionInventario.items.map(i => i.id));
        const nuevos = (data.inventories || [])
          .filter(item => !existing.has(item.id))
          .map(item => ({ ...item, checked: false, use_quantity: 0 }));
        this.seleccionInventario.items.push(...nuevos);
        this.seleccionInventario.items.sort((a, b) => b.id - a.id);
      } catch (error) {
        console.error('Error buscando inventario:', error);
      } finally {
        if (this.seleccionInventario.detail === detail) {
          this.seleccionInventario.searching = false;
        }
      }
    },
    closeModalSeleccionInventario() {
      if (this.modalSeleccionInventario) {
        this.modalSeleccionInventario.hide();
      }
    },
    onSeleccionInventarioCheck(item) {
      if (!item.checked) {
        item.use_quantity = 0;
        return;
      }
      // Inventario adicional: la cantidad la ingresa el usuario
      if (this.seleccionInventario.extra) {
        return;
      }
      // Proponer lo que falta por cubrir, limitado al stock del registro
      const required = Number(this.seleccionInventario.required || 0);
      const others = this.seleccionInventario.items
        .filter(i => i.checked && i.id !== item.id)
        .reduce((sum, i) => sum + Number(i.use_quantity || 0), 0);
      let remaining = Math.max(0, required - others);
      if (item.manage_stock) {
        remaining = Math.min(remaining, Number(item.quantity || 0));
      }
      item.use_quantity = Math.round(remaining * 1000) / 1000;
    },
    async submitSeleccionInventario() {
      const selections = this.seleccionInventario.items
        .filter(i => i.checked)
        .map(i => ({ inventory_id: i.id, quantity: Number(i.use_quantity || 0) }))
        // Los marcados sin cantidad no generan filas vacías
        .filter(s => this.seleccionInventario.extra || s.quantity !== 0);

      if (selections.length === 0) {
        await Swal.fire({ icon: 'warning', title: 'Atención', text: 'Debe marcar al menos un inventario.' });
        return;
      }
      if (selections.some(s => s.quantity < 0)) {
        await Swal.fire({ icon: 'warning', title: 'Atención', text: 'La cantidad de cada inventario marcado no puede ser negativa.' });
        return;
      }
      if (this.seleccionInventario.extra && selections.some(s => s.quantity <= 0)) {
        await Swal.fire({ icon: 'warning', title: 'Atención', text: 'Ingrese la cantidad adicional de cada inventario marcado.' });
        return;
      }

      this.seleccionInventario.saving = true;
      try {
        const response = await this.$store.dispatch('productionDetails/assignInventory', {
          id: this.seleccionInventario.detail.id,
          selections,
          extra: this.seleccionInventario.extra,
          mergeIds: this.seleccionInventario.mergeIds,
        });
        if (!response || response.status >= 400) {
          throw new Error(response?.data?.message || 'Error al asignar el inventario');
        }
        this.closeModalSeleccionInventario();
        await this.getInsumos();
        await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: 'Inventario asignado correctamente.',
          confirmButtonText: 'Aceptar',
        });
      } catch (error) {
        await Swal.fire({ icon: 'error', title: 'Error', text: error.message });
      } finally {
        this.seleccionInventario.saving = false;
      }
    },
    async unassignInventario() {
      const response = await this.$store.dispatch('productionDetails/unassignInventory', this.seleccionInventario.detail.id);
      if (!response || response.status >= 400) {
        await Swal.fire({ icon: 'error', title: 'Error', text: response?.data?.message || 'Error al quitar la selección' });
        return;
      }
      this.closeModalSeleccionInventario();
      await this.getInsumos();
    },
    openModalInsumoProduccion(group) {
      this.selectedGroup = group;
      const modalElement = document.getElementById('ModalInsumoProduccion');
      this.modalInsumoProduccion = new Modal(modalElement);
      this.modalInsumoProduccion.show();
      
      // Inicializar Select2 después de abrir el modal
      this.$nextTick(() => {
        if (this.$refs.insumosProduccionSelect) {
          if ($(this.$refs.insumosProduccionSelect).hasClass('select2-hidden-accessible')) {
            $(this.$refs.insumosProduccionSelect).select2('destroy');
          }
          $(this.$refs.insumosProduccionSelect).select2({
            placeholder: 'Seleccionar insumos',
            allowClear: true,
            dropdownParent: $('#ModalInsumoProduccion .modal-body'),
            width: '100%'
          });
        }
      });
    },
    closeModalInsumoProduccion() {
      if (this.modalInsumoProduccion) {
        this.modalInsumoProduccion.hide();
      }
      this.selectedGroup = null;
      if (this.$refs.insumosProduccionSelect) {
        $(this.$refs.insumosProduccionSelect).val(null).trigger('change');
      }
    },
    async submitFormInsumoProduccion() {
      try {
        const selectedInsumos = $(this.$refs.insumosProduccionSelect).val() || [];
        
        if (selectedInsumos.length === 0) {
          await Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: 'Debe seleccionar al menos un insumo.',
          });
          return;
        }

        if (!this.selectedGroup || !this.selectedGroup.id) {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se pudo identificar el grupo de producción.',
          });
          return;
        }

        Swal.fire({
          icon: 'info',
          title: 'Cargando...',
          text: 'Estamos guardando los insumos, por favor espera.',
          didOpen: () => {
            Swal.showLoading();
          },
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });

        // Guardar cada insumo seleccionado
        const promises = selectedInsumos.map(async (inventoryName) => {
          // Precio de referencia: el del registro más reciente con ese nombre
          const selectedInventory = this.insumosInventory.find(inv => inv.name === inventoryName);
          const inventoryPrice = selectedInventory ? parseFloat(selectedInventory.price || 0) : 0;
          
          const purchaseData = {
            id: 0, // Importante: id debe ser 0 para crear un nuevo registro
            production_id: this.form.id, // ID de la producción principal (requerido por el backend)
            production_model_id: this.selectedGroup.id,
            inventory_name: inventoryName, // El inventario concreto se selecciona después
            quantity: 1, // Cambiar a 1 para cumplir con la validación del backend
            price: inventoryPrice, // Precio del inventario seleccionado
            total_price: inventoryPrice * 1, // Precio total = precio * cantidad
          };
          return await this.$store.dispatch("productionDetails/save", purchaseData);
        });

        const responses = await Promise.all(promises);
        
        // Verificar si todas las respuestas fueron exitosas
        const allSuccess = responses.every(response => 
          response && response.status >= 200 && response.status < 300
        );

        if (allSuccess) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'Los insumos han sido asignados correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.getInsumos();
            this.closeModalInsumoProduccion();
          });
        } else {
          throw new Error('Error al asignar algunos insumos');
        }

      } catch (error) {
        Swal.close();
        console.error("Error al asignar insumos:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al asignar los insumos',
        });
      }
    },
    async submitEditForm() {
      try {
        const response = await this.$store.dispatch("productionDetails/save", this.purchase);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then(() => {
            this.getInsumos();
            this.closeEditModal();
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async onBodegaChange(data) {

      await this.$store.dispatch('productionModels/save', data);

      await Swal.fire({
        icon: 'success',
        title: '¡Éxito!',
        text: 'Bodega asignada',
        confirmButtonText: 'Aceptar',
        backdrop: true,
      });

    },
    async onOficioChange(data) {
      try {
        // Guardar el oficio asignado
        await this.$store.dispatch('productionModels/save', data);
        
        await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: 'Oficio asignado correctamente',
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });
      } catch (error) {
        console.error('Error al guardar oficio:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al asignar el oficio',
          confirmButtonText: 'Aceptar',
        });
      }
    },
    async updateQuantity(detail, event) {
      console.log('updateQuantity llamado', { detail, status: this.form.status, statusType: typeof this.form.status });
      
      // Permitir actualizar si la producción está en estado pendiente (status = 0) o en proceso (status = 1)
      const canUpdate = Number(this.form.status) === 0 || Number(this.form.status) === 1;
      if (!canUpdate) {
        console.log('Producción no permite actualizar cantidad, status:', this.form.status);
        return;
      }
      
      console.log('Producción permite actualizar cantidad, procediendo con actualización...');

      const inputElement = event.target;
      const inputValue = inputElement.value.trim();
      const newQuantity = parseFloat(inputValue);
      const originalQuantity = parseFloat(detail.quantity || 0);

      console.log('Valores:', { inputValue, newQuantity, originalQuantity });

      // Validar que la cantidad sea válida
      if (!inputValue || isNaN(newQuantity) || newQuantity <= 0) {
        // Restaurar el valor original si es inválido
        inputElement.value = originalQuantity.toString();
        await Swal.fire({
          icon: 'warning',
          title: 'Advertencia',
          text: 'Debe ingresar una cantidad válida mayor a 0',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      // Si la cantidad no cambió, no hacer nada
      if (newQuantity === originalQuantity) {
        console.log('La cantidad no cambió, no se actualiza');
        return;
      }

      try {
        console.log('Iniciando actualización de cantidad...');
        
        // Calcular el nuevo total_price basado en la nueva cantidad
        const newTotalPrice = newQuantity * parseFloat(detail.price || 0);
        
        const updateData = {
          id: detail.id,
          production_model_id: detail.production_model_id,
          inventory_id: detail.inventory_id,
          quantity: newQuantity,
          price: detail.price,
          total_price: newTotalPrice,
          discounted: detail.discounted ? 1 : 0,
          user_id: detail.user_id || null
        };
        
        console.log('Datos a actualizar:', updateData);
        
        const response = await this.$store.dispatch('productionDetails/save', updateData);
        
        console.log('Respuesta del servidor:', response);
        
        // Verificar si la respuesta es un error
        if (response && response.status && response.status >= 400) {
          const errorMessage = response.data?.message || response.data?.error || 'Error al actualizar la cantidad';
          // Restaurar el valor original en caso de error
          inputElement.value = originalQuantity.toString();
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
            confirmButtonText: 'Aceptar',
          });
          return;
        }
        
        // También verificar si response es null o undefined (error en la petición)
        if (!response || !response.data) {
          console.error('Respuesta inválida:', response);
          // Restaurar el valor original en caso de error
          inputElement.value = originalQuantity.toString();
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error al actualizar la cantidad',
            confirmButtonText: 'Aceptar',
          });
          return;
        }
        
        console.log('Actualización exitosa, actualizando datos locales...');
        
        // Actualizar el valor local inmediatamente para reflejar el cambio en la vista
        // Usar Object.assign para actualizar de forma atómica y evitar warnings del linter
        Object.assign(detail, {
          quantity: newQuantity,
          total_price: newTotalPrice
        });
        
        // Actualizar el input para reflejar el nuevo valor
        inputElement.value = newQuantity.toString();
        
        // Los computed (insumosUtilizadosAgrupados, totalInsumosUtilizados) 
        // se recalcularán automáticamente cuando Vue detecte el cambio en detail
        
        // Recargar datos para asegurar sincronización completa con el backend
        await this.getInsumos();
        
        console.log('Datos actualizados exitosamente');
        
      } catch (error) {
        console.error('Error al actualizar cantidad:', error);
        const errorMessage = error.response?.data?.message || error.message || 'Error al actualizar la cantidad';
        // Restaurar el valor original en caso de error
        inputElement.value = originalQuantity.toString();
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: errorMessage,
          confirmButtonText: 'Aceptar',
        });
      }
    },
    async updatePrice(detail, event) {
      // Permitir actualizar si la producción está en estado pendiente (status = 0) o en proceso (status = 1)
      const canUpdate = Number(this.form.status) === 0 || Number(this.form.status) === 1;
      if (!canUpdate) return;

      const inputElement = event.target;
      const inputValue = inputElement.value.trim();
      const newPrice = parseFloat(inputValue);
      const originalPrice = parseFloat(detail.price || 0);

      // Validar que el precio sea válido (se permite 0)
      if (inputValue === '' || isNaN(newPrice) || newPrice < 0) {
        inputElement.value = originalPrice.toString();
        await Swal.fire({
          icon: 'warning',
          title: 'Advertencia',
          text: 'Debe ingresar un precio válido mayor o igual a 0',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      // Si el precio no cambió, no hacer nada
      if (newPrice === originalPrice) return;

      const newTotalPrice = parseFloat(detail.quantity || 0) * newPrice;

      try {
        // No se envía quantity: el backend, al recibir quantity, sobrescribe el precio con el del inventario
        const response = await this.$store.dispatch('productionDetails/save', {
          id: detail.id,
          production_model_id: detail.production_model_id,
          inventory_id: detail.inventory_id,
          price: newPrice,
          total_price: newTotalPrice,
          discounted: detail.discounted ? 1 : 0,
          user_id: detail.user_id || null
        });

        if (!response || !response.data || (response.status && response.status >= 400)) {
          const errorMessage = response?.data?.message || response?.data?.error || 'Error al actualizar el precio';
          inputElement.value = originalPrice.toString();
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
            confirmButtonText: 'Aceptar',
          });
          return;
        }

        Object.assign(detail, {
          price: newPrice,
          total_price: newTotalPrice
        });
        inputElement.value = newPrice.toString();

        // Recargar datos para asegurar sincronización completa con el backend
        await this.getInsumos();
      } catch (error) {
        console.error('Error al actualizar precio:', error);
        const errorMessage = error.response?.data?.message || error.message || 'Error al actualizar el precio';
        inputElement.value = originalPrice.toString();
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: errorMessage,
          confirmButtonText: 'Aceptar',
        });
      }
    },
    async updateInsumoTotalQuantity(insumo, event) {
      const canUpdate = Number(this.form.status) === 0 || Number(this.form.status) === 1;
      if (!canUpdate) return;

      const inputElement = event.target;
      const inputValue = inputElement.value.trim();
      const newTotalQuantity = parseFloat(inputValue);
      const originalTotalQuantity = parseFloat(insumo.quantity || 0);

      if (!inputValue || isNaN(newTotalQuantity) || newTotalQuantity <= 0) {
        inputElement.value = originalTotalQuantity.toFixed(2);
        await Swal.fire({
          icon: 'warning',
          title: 'Advertencia',
          text: 'Debe ingresar una cantidad válida mayor a 0',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      if (newTotalQuantity === originalTotalQuantity) return;

      // Todos los detalles que usan este insumo (por nombre)
      const details = insumo.details || [];

      if (details.length === 0) return;

      if (details.some(d => this.isDiscounted(d))) {
        inputElement.value = originalTotalQuantity.toFixed(2);
        await Swal.fire({
          icon: 'warning',
          title: 'Insumo ya utilizado',
          text: 'Revierta el uso del insumo antes de cambiar la cantidad.',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      try {
        // Distribuir la nueva cantidad total proporcionalmente entre los detalles
        const factor = newTotalQuantity / originalTotalQuantity;

        // Actualizar cada detalle
        for (const detail of details) {
          const newQuantity = parseFloat(detail.quantity) * factor;
          const newTotalPrice = newQuantity * parseFloat(detail.price || 0);

          const updateData = {
            id: detail.id,
            production_model_id: detail.production_model_id,
            inventory_id: detail.inventory_id,
            quantity: parseFloat(newQuantity.toFixed(4)),
            price: detail.price,
            total_price: parseFloat(newTotalPrice.toFixed(4)),
            discounted: detail.discounted ? 1 : 0,
            user_id: detail.user_id || null,
          };

          const response = await this.$store.dispatch('productionDetails/save', updateData);
          if (response && response.status && response.status >= 400) {
            const errorMessage = response.data?.message || response.data?.error || 'Error al actualizar';
            inputElement.value = originalTotalQuantity.toFixed(2);
            await Swal.fire({
              icon: 'error',
              title: 'Error',
              text: errorMessage,
              confirmButtonText: 'Aceptar',
            });
            return;
          }
        }

        // Recargar datos para sincronizar con el backend
        await this.getInsumos();
      } catch (error) {
        console.error('Error al actualizar cantidad total del insumo:', error);
        inputElement.value = originalTotalQuantity.toFixed(2);
        const errorMessage = error.response?.data?.message || error.message || 'Error al actualizar la cantidad';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: errorMessage,
          confirmButtonText: 'Aceptar',
        });
      }
    },
    async toggleDiscount(detail) {
      if (!detail.discounted && !detail.inventory_id) {
        await Swal.fire({
          icon: 'info',
          title: 'Seleccione el inventario',
          text: `Antes de descontar, seleccione qué inventario de "${detail.inventory_name}" se usará.`,
          confirmButtonText: 'Seleccionar',
        });
        this.openModalSeleccionInventario(detail);
        return;
      }
      if (!detail.discounted) {
        this.openModalCantidadUtilizada([detail]);
        return;
      }
      try {
        // Guardar el valor actual antes de hacer la actualización
        const currentDiscountedValue = Boolean(detail.discounted);
        const newDiscountedValue = !currentDiscountedValue;
        
        // Obtener el user_id desde el localStorage
        let user = JSON.parse(localStorage.getItem('user'));
        let userId = null;
        if (user && user.id) {
          userId = user.id;
        }
        
        const updateData = {
          id: detail.id,
          production_model_id: detail.production_model_id,
          inventory_id: detail.inventory_id,
          quantity: detail.quantity,
          price: detail.price,
          total_price: detail.total_price,
          discounted: newDiscountedValue ? 1 : 0,
          user_id: newDiscountedValue ? userId : null // Solo enviar user_id cuando se marca como descontado
        };
        
        const response = await this.$store.dispatch('productionDetails/save', updateData);
        
        // Verificar si la respuesta es un error
        if (response && response.status && response.status >= 400) {
          // El mensaje puede estar en response.data.message o response.data.error
          const errorMessage = response.data?.message || response.data?.error || 'Error al actualizar el descuento';
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: errorMessage,
            confirmButtonText: 'Aceptar',
          });
          return;
        }
        
        // También verificar si response es null o undefined (error en la petición)
        if (!response || !response.data) {
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error al actualizar el descuento',
            confirmButtonText: 'Aceptar',
          });
          return;
        }
        
        // Recargar datos para actualizar la vista (esto actualizará todos los estados)
        await this.getInsumos();
        
        await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: newDiscountedValue 
            ? 'Insumo marcado como descontado del inventario'
            : 'Insumo desmarcado como descontado',
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });
      } catch (error) {
        console.error('Error al actualizar descuento:', error);
        const errorMessage = error.response?.data?.message || error.message || 'Error al actualizar el descuento';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: errorMessage,
          confirmButtonText: 'Aceptar',
        });
      }
    },
    async markAllInsumosAsUtilized() {
      const insumos = this.insumosUtilizadosAgrupados;
      if (!insumos || insumos.length === 0) return;

      const pendientes = insumos.flatMap(i => i.details.filter(d => !this.isDiscounted(d)));
      if (pendientes.length === 0) {
        await Swal.fire({
          icon: 'info',
          title: 'Información',
          text: 'Todos los insumos ya están marcados como utilizados.',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      const sinInventario = insumos.filter(i => i.pendingSelection > 0);
      if (sinInventario.length > 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Falta seleccionar inventario',
          html: 'Antes de marcar todos como utilizados, seleccione qué inventario se usará para:<br><br><strong>'
            + sinInventario.map(i => i.inventory_name).join('<br>') + '</strong>',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      this.openModalCantidadUtilizada(pendientes);
    },
    async markAllInsumoAsDiscounted(insumo) {
      const allDiscounted = insumo.allDiscounted;

      if (!allDiscounted && insumo.pendingSelection > 0) {
        await Swal.fire({
          icon: 'info',
          title: 'Seleccione el inventario',
          text: `Antes de descontar, seleccione qué inventario de "${insumo.inventory_name}" se usará.`,
          confirmButtonText: 'Seleccionar',
        });
        this.openModalSeleccionInventario(insumo.firstPendingDetail);
        return;
      }

      const details = insumo.details.filter(d => allDiscounted ? this.isDiscounted(d) : !this.isDiscounted(d));
      if (details.length === 0) return;

      if (!allDiscounted) {
        this.openModalCantidadUtilizada(details);
        return;
      }
      const ids = details.map(d => d.id);

      const result = await Swal.fire({
        icon: 'question',
        title: allDiscounted ? '¿Revertir uso?' : '¿Marcar como utilizado?',
        html: allDiscounted
          ? `Se devolverá al inventario todo el insumo <strong>${insumo.inventory_name}</strong> de esta producción.<br><br>¿Deseas continuar?`
          : `Se descontará del inventario el insumo <strong>${insumo.inventory_name}</strong> en todos los modelos de esta producción.<br><br>¿Deseas continuar?`,
        showCancelButton: true,
        confirmButtonText: allDiscounted ? 'Sí, revertir' : 'Sí, marcar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: allDiscounted ? '#dc3545' : '#28a745',
        cancelButtonColor: '#6c757d',
      });

      if (!result.isConfirmed) return;

      await this.bulkDiscount(ids, !allDiscounted);
    },
    // Pide la cantidad real utilizada de cada insumo antes de descontarlo del inventario
    openModalCantidadUtilizada(details) {
      this.cantidadUtilizada = {
        saving: false,
        rows: details.map(detail => {
          const group = this.insumos.find(g => (g.details || []).some(d => d.id === detail.id));
          return {
            id: detail.id,
            name: detail.inventory?.name || detail.inventory_name,
            ref: detail.inventory?.ref || '',
            model: group
              ? [group.model?.name, group.size?.size && `Talla ${group.size.size}`, group.size?.color?.name].filter(Boolean).join(' - ')
              : '',
            required: Number(detail.quantity) || 0,
            stock: Number(detail.inventory?.quantity) || 0,
            manage_stock: detail.inventory ? !!Number(detail.inventory.manage_stock) : true,
            used: Number(detail.quantity) || 0,
          };
        }),
      };
      const modalElement = document.getElementById('ModalCantidadUtilizada');
      this.modalCantidadUtilizada = Modal.getOrCreateInstance(modalElement);
      this.modalCantidadUtilizada.show();
    },
    async submitCantidadUtilizada() {
      const rows = this.cantidadUtilizada.rows;
      if (rows.some(r => r.used === '' || r.used === null || isNaN(Number(r.used)) || Number(r.used) < 0)) {
        await Swal.fire({ icon: 'warning', title: 'Atención', text: 'Ingrese una cantidad utilizada válida (0 o mayor) para cada insumo.' });
        return;
      }
      const quantities = {};
      rows.forEach(r => { quantities[r.id] = Number(r.used); });

      this.cantidadUtilizada.saving = true;
      this.modalCantidadUtilizada.hide();
      try {
        await this.bulkDiscount(rows.map(r => r.id), true, quantities);
      } finally {
        this.cantidadUtilizada.saving = false;
      }
    },
    // Descuenta (o revierte) varios insumos en una sola operación: si uno falla no se aplica ninguno
    async bulkDiscount(ids, discounted, quantities = null) {
      Swal.fire({
        title: 'Procesando...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await this.$store.dispatch('productionDetails/bulkDiscount', { ids, discounted, quantities });
      await this.getInsumos();

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: response.data.message,
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }

      const errors = response?.data?.errors;
      await Swal.fire({
        icon: 'error',
        title: response?.data?.message || 'Error al actualizar los insumos',
        html: Array.isArray(errors) ? errors.join('<br>') : (response?.data?.error || ''),
        confirmButtonText: 'Aceptar',
      });
    },
    async handleStatusChange() {
      if (this.form.status === '1') {
        const result = await Swal.fire({
          title: 'Confirmar cambio de estado',
          text: 'Al cambiar el estado a Producción, ya no será posible agregar nuevos modelos. A partir de este momento, se habilitarán las opciones necesarias para asignar operarios y dar inicio a la ejecución de las tareas correspondientes.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, confirmar',
          cancelButtonText: 'Cancelar',
        });

        if (result.isConfirmed) {
          this.handleStatusChangeSave();
          this.getInsumos();
        } else {
          this.form.status = 0;
        }
      } else {
        this.handleStatusChangeSave();
      }

    },
    async handleStatusChangeSave() {
      const response = await this.$store.dispatch("production/save", this.form);
      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: 'El estado cambio correctamente',
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });
      } else {
        await Swal.fire({
          icon: 'error',
          title: '¡Insumos insufiecientes!',
          text: 'Verifica la cantidad y stock disponible en la tabla de insumos.',
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });

        if (this.form.status === '1') {
          this.form.status = 0;
        }


      }
    },
    async handleOficioChange() {
      if (this.form.id != 0) {
        try {
          const payload = {
            ...this.form,
            model_id: this.form.model_id ? parseInt(this.form.model_id) : null,
            oficio_id: this.form.oficio_id ? parseInt(this.form.oficio_id) : null,
            bodega_id: this.form.bodega_id ? parseInt(this.form.bodega_id) : null,
          };
          const response = await this.$store.dispatch("production/save", payload);
          if (response && response.status >= 200 && response.status < 300) {
            // Actualizar el form con la respuesta del servidor
            this.form.oficio_id = response.data.oficio_id ? parseInt(response.data.oficio_id) : null;
          }
        } catch (error) {
          console.error("Error al guardar oficio:", error);
        }
      }
    },
    async handleBodegaChange() {
      if (this.form.id != 0) {
        try {
          const payload = {
            ...this.form,
            model_id: this.form.model_id ? parseInt(this.form.model_id) : null,
            oficio_id: this.form.oficio_id ? parseInt(this.form.oficio_id) : null,
            bodega_id: this.form.bodega_id ? parseInt(this.form.bodega_id) : null,
          };
          const response = await this.$store.dispatch("production/save", payload);
          if (response && response.status >= 200 && response.status < 300) {
            // Actualizar el form con la respuesta del servidor
            this.form.bodega_id = response.data.bodega_id ? parseInt(response.data.bodega_id) : null;
          }
        } catch (error) {
          console.error("Error al guardar bodega:", error);
        }
      }
    },
    async handleEtapaChange() {
      if (this.form.id != 0) {
        try {
          const payload = {
            ...this.form,
            model_id: this.form.model_id ? parseInt(this.form.model_id) : null,
            oficio_id: this.form.oficio_id ? parseInt(this.form.oficio_id) : null,
            bodega_id: this.form.bodega_id ? parseInt(this.form.bodega_id) : null,
          };
          const response = await this.$store.dispatch("production/save", payload);
          if (response && response.status >= 200 && response.status < 300) {
            this.form.etapa = response.data.etapa || '';
          }
        } catch (error) {
          console.error("Error al guardar etapa:", error);
        }
      }
    },
    async handleMaquilaChange() {
      if (this.form.id != 0) {
        try {
          const payload = {
            ...this.form,
            model_id: this.form.model_id ? parseInt(this.form.model_id) : null,
            oficio_id: this.form.oficio_id ? parseInt(this.form.oficio_id) : null,
            bodega_id: this.form.bodega_id ? parseInt(this.form.bodega_id) : null,
          };
          const response = await this.$store.dispatch("production/save", payload);
          if (response && response.status >= 200 && response.status < 300) {
            this.form.is_maquila = Boolean(response.data.is_maquila);
          }
        } catch (error) {
          console.error("Error al guardar producción de maquila:", error);
        }
      }
    },
    async getBodegas() {
      this.bodegas = await this.$store.dispatch('bodegas/getAll');
    },
    async getNovelties() {
      this.loadingNovelties = true;
      try {
        this.novelties = await this.$store.dispatch('productionNovelty/getData', this.form.id);
      } finally {
        this.loadingNovelties = false;
      }
    },
    async getOficios() {
      this.processes = await this.$store.dispatch('users/getOficios');
    },
    async getGroups() {
      try {
        this.groups = await this.$store.dispatch('groups/getAll');
      } catch (error) {
        console.error("Error al cargar los grupos:", error);
        this.groups = [];
      }
    },
    onGroupSelected() {
      const val = $(this.$refs.grupoSelect).val();
      if (!val || val == '0') {
        return;
      }
      // Al elegir grupo se descarta la selección individual
      this.production_user.group_id = val;
      this.production_user.user_id = 0;
      if (this.$refs.usersSelect) {
        $(this.$refs.usersSelect).val(null).trigger('change.select2');
      }
      this.fieldPayment = true;
    },
    // Con oficio seleccionado se propone lo que falta por asignar de ese oficio
    applyPendingQuantity() {
      if (!this.oficio_id || this.oficio_id == 0) return;
      const pending = this.pendingForOficio(this.production_user.production_models_id, this.oficio_id);
      this.production_user.received_quantity = pending;
      this.total_modal_quantity = pending;
    },
    filterUsersByOficio() {
      if (this.oficio_id != 0) {
        this.filteredUsers = this.users.filter(user => {
          // Asegúrate de que processes sea un arreglo
          const processes = Array.isArray(user.processes)
            ? user.processes
            : JSON.parse(user.processes || "[]");
          return processes.map(Number).includes(Number(this.oficio_id));
        });
      } else {
        this.filteredUsers = []; // Mostrar todos los usuarios si no hay oficio seleccionado
      }
      // Precarga el precio a pagar configurado para este proceso en el modelo
      this.applyPendingQuantity();
      this.prefillProcessPrice();
    },
    prefillProcessPrice() {
      const oficioId = parseInt(this.oficio_id);
      if (!oficioId) {
        return;
      }
      // Producción completa: si todos los modelos pagan igual se precarga ese valor;
      // si no, se deja en 0 y el servidor usa el precio configurado en cada modelo
      const models = parseInt(this.production_user.production_models_id) === 0
        ? this.insumos
        : this.insumos.filter(i => i.id === parseInt(this.production_user.production_models_id));
      const prices = [...new Set(models.map(pm => {
        const found = (pm?.model?.process_prices || []).find(p => Number(p.oficio_id) === oficioId);
        return found ? parseFloat(found.price) || 0 : 0;
      }))];
      this.production_user.price = prices.length === 1 ? prices[0] : 0;
    },
    isValidDate(date) {
      if (!date) {
        return false;
      }
      const parsedDate = new Date(date);
      return !isNaN(parsedDate.getTime());
    },
    async getModels() {
      this.models = await this.$store.dispatch('models/getAll');
      // Actualizar Select2 después de cargar los modelos
      this.$nextTick(() => {
        if (this.$refs.modelSelect) {
          // Si Select2 ya está inicializado, solo actualizar el valor
          if ($(this.$refs.modelSelect).hasClass('select2-hidden-accessible')) {
            if (this.form.model_id) {
              $(this.$refs.modelSelect).val(this.form.model_id).trigger('change');
            }
          }
        }
      });
    },
    async getSizes() {
      const modelId = this.form.model_id || this.production_model.model_id;
      if (!modelId) {
        this.sizes = [];
        this.lastLoadedModelId = null;
        return;
      }
      
      // Evitar llamadas duplicadas para el mismo modelo
      if (this.isLoadingSizes || this.lastLoadedModelId === modelId) {
        return;
      }
      
      this.isLoadingSizes = true;
      try {
        // Obtener tallas y colores desde models_model
        let response = await this.$store.dispatch('modelsModel/getData', modelId);
        this.production_model.model_id = modelId;
        // response.data contiene el array de models_model
        let tallasData = response.data || [];
        
        // Eliminar duplicados basándose en la combinación de size y color_id
        const uniqueSizes = [];
        const seen = new Set();
        
        tallasData.forEach(item => {
          const key = `${item.size}_${item.color_id}`;
          if (!seen.has(key)) {
            seen.add(key);
            uniqueSizes.push(item);
          }
        });
        
        this.sizes = uniqueSizes;
        this.lastLoadedModelId = modelId;
        console.log('Tallas obtenidas (sin duplicados):', this.sizes);
      } finally {
        this.isLoadingSizes = false;
      }
    },
    async getUsers() {

      this.users = await this.$store.dispatch('users/getAll', 'all');
      //this.users =this.$store.state.users.users;

    },
    getIconClass(status) {
      if (status === 0) {
        return 'fa fa-circle'; // Ícono de clic
      } else if (status === 1) {
        return 'fa fa-check-circle text-success'; // Ícono de check verde
      } else if (status === 2) {
        return 'fa fa-times-circle text-danger'; // Ícono de X roja
      }
      return ''; // Devuelve una cadena vacía si no coincide con ningún estado
    },
    editRegisterNovelty(params) {
      this.novelty = params;
      this.openModalNovelty();
    },
    async deleteRegisterNovelty(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionNovelty/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getNovelties();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    openModalNovelty() {
      const modalElement = document.getElementById('ModalNovelty');
      this.modalNovelty = new Modal(modalElement); // Guarda la instancia del modal
      this.modalNovelty.show(); // Muestra el modal
    },
    closeModalNovelty() {
      if (this.modalNovelty) {
        this.modalNovelty.hide(); // Cierra el modal
      }
    },
    async submitFormNovelty() {
      try {
        this.novelty.production_id = this.form.id;
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("productionNovelty/save", this.novelty);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.novelty.total = 0;
              this.novelty.observation = '';

              this.closeModalNovelty();
              this.getNovelties();

            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    // preset: { oficioId, groupId, productionModelId } para abrir el modal desde la card de un oficio
    openModal(preset = {}) {
      this.production_user.assigned_at = new Date().toISOString().slice(0, 10);
      this.basketsDivision = [{ count: 1, quantity: parseInt(this.production_user.received_quantity) || 0 }];
      this.production_user.group_id = 0;
      this.production_user.fix_group = false;
      if (this.$refs.grupoSelect) {
        $(this.$refs.grupoSelect).val(0).trigger('change.select2');
      }
      this.fieldPayment = true;

      if (preset && (preset.oficioId || preset.productionModelId)) {
        const modelId = preset.productionModelId ?? 0;
        $(this.$refs.modelUserSelect).val(String(modelId)).trigger('change');
        if (preset.oficioId) {
          $(this.$refs.processesSelect).val(String(preset.oficioId)).trigger('change');
        }
        this.$nextTick(() => {
          if (preset.groupId && this.$refs.grupoSelect) {
            $(this.$refs.grupoSelect).val(String(preset.groupId)).trigger('change');
          }
        });
      }

      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
    },
    async getBaskets() {
      try {
        const response = await productionUsersService.getBaskets(this.form.id);
        this.baskets = response.data || [];
        // Se conservan solo las tareas que siguen abiertas
        const open = new Set(this.baskets.flatMap(b => (b.tasks || []).filter(t => !t.closed_at).map(t => t.id)));
        this.selectedTaskIds = this.selectedTaskIds.filter(id => open.has(id));
      } catch (error) {
        console.error("Error al cargar las canastas:", error);
        this.baskets = [];
      }
    },
    // Tiempo que la canasta estuvo en la tarea: desde que se creó hasta que pasó a la siguiente (o hasta ahora)
    basketTaskDuration(task) {
      const start = new Date(task.created_at);
      const end = task.closed_at ? new Date(task.closed_at) : new Date();
      if (isNaN(start.getTime()) || isNaN(end.getTime())) return '—';
      const total = Math.max(0, Math.round((end - start) / 60000));
      const days = Math.floor(total / 1440);
      const hours = Math.floor((total % 1440) / 60);
      const mins = total % 60;
      if (days) return `${days}d ${hours}h ${mins}m`;
      if (hours) return `${hours}h ${mins}m`;
      return `${mins}m`;
    },
    productionModelLabel(pm) {
      if (!pm) return '';
      return `${pm.model?.name ?? ''} · T: ${pm.size?.size ?? 'Full'} · ${pm.size?.color?.name ?? 'Full'}`;
    },
    // Estado de una tarea según sus filas de pago (todas deben avanzar para cambiar de estado)
    rowsStatus(rows) {
      if (!rows.length) return 'asignada';
      if (rows.every(r => r.validated_date)) return 'validada';
      if (rows.every(r => r.delivered_date)) return 'entregada';
      if (rows.every(r => r.received_date)) return 'recibida';
      return 'asignada';
    },
    taskStatusLabel(status) {
      return { asignada: 'Asignada', recibida: 'Recibida', entregada: 'Entregada', validada: 'Validada' }[status] || status;
    },
    taskStatusClass(status) {
      return {
        asignada: 'bg-gradient-warning',
        recibida: 'bg-gradient-primary',
        entregada: 'bg-gradient-info',
        validada: 'bg-gradient-success',
      }[status] || 'bg-gradient-secondary';
    },
    toggleTaskExpanded(key) {
      this.expandedTasks = { ...this.expandedTasks, [key]: !this.expandedTasks[key] };
    },
    toggleTaskSelection(taskId) {
      this.selectedTaskIds = this.selectedTaskIds.includes(taskId)
        ? this.selectedTaskIds.filter(id => id !== taskId)
        : [...this.selectedTaskIds, taskId];
    },
    // Recibir / entregar / validar todas las filas de la tarea (todos los integrantes)
    async taskBulkAction(task, action) {
      const config = {
        received: { title: 'Recibir tarea', call: 'bulkMarkAsReceived' },
        delivered: { title: 'Entregar tarea', call: 'bulkMarkAsDelivered' },
        validated: {
          title: 'Validar tarea',
          call: 'bulkMarkAsValidated',
          text: 'Se valida sin defectos y queda lista para pago. Para registrar defectos valide por integrante.',
        },
      }[action];
      const result = await Swal.fire({
        title: config.title,
        text: config.text || `${task.basket ? 'Canasta #' + task.basket.number : 'Tarea'} · ${task.quantity} u. · ${task.groupName || task.userName}`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, aceptar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      try {
        const response = await productionUsersService[config.call](task.rows.map(r => r.id));
        await Swal.fire({ icon: 'success', title: '¡Listo!', text: response.data?.message, timer: 1500, showConfirmButton: false });
        await this.refreshCards(task.rows);
      } catch (error) {
        await Swal.fire({ icon: 'error', title: 'Error', text: error.response?.data?.message || error.message });
      }
    },
    // Canastas seleccionadas en la card cuyo siguiente paso es la acción indicada
    // (asignada → recibir, recibida → entregar, entregada → validar)
    cardSelectionTasks(card, action) {
      const status = { received: 'asignada', delivered: 'recibida', validated: 'entregada' }[action];
      return card.selectedTasks.filter(t => t.status === status);
    },
    // Canastas seleccionadas listas para enviar a otro oficio (validadas); los procesos en paralelo
    // se envían cada uno por su lado, sin reunir la canasta
    cardSendableTasks(card) {
      return card.selectedTasks.filter(t => t.status === 'validada');
    },
    // Procesos en paralelo seleccionados cuya canasta ya se puede reunir (todos sus procesos validados)
    cardJoinableTasks(card) {
      return card.selectedTasks.filter(t => t.status === 'validada' && t.parallel?.complete);
    },
    // Canastas de la card que se pueden marcar con el check
    cardSelectableTasks(card) {
      return card.tasks.filter(t => t.basket && !t.closed);
    },
    isCardAllSelected(card) {
      const tasks = this.cardSelectableTasks(card);
      return tasks.length > 0 && tasks.every(t => this.selectedTaskIds.includes(t.id));
    },
    toggleCardSelectAll(card) {
      const ids = this.cardSelectableTasks(card).map(t => t.id);
      this.selectedTaskIds = this.isCardAllSelected(card)
        ? this.selectedTaskIds.filter(id => !ids.includes(id))
        : [...new Set([...this.selectedTaskIds, ...ids])];
    },
    // Cambio masivo de estado: solo avanza las canastas que están en el paso anterior
    async cardBulkAction(card, action) {
      const baskets = this.cardSelectionTasks(card, action);
      const pending = baskets.flatMap(t => t.rows);
      if (pending.length === 0) return;

      const config = {
        received: { title: `Por recibir ${baskets.length} tarea(s)`, steps: ['bulkMarkAsReceived'] },
        delivered: { title: `Por entregar ${baskets.length} tarea(s)`, steps: ['bulkMarkAsDelivered'] },
        validated: {
          title: `Por validar ${baskets.length} tarea(s)`,
          steps: ['bulkMarkAsValidated'],
          text: 'Se validan sin defectos y quedan listas para pago. Para registrar defectos valide por integrante.',
        },
      }[action];
      const result = await Swal.fire({
        title: config.title,
        html: `<strong>${baskets.length}</strong> canasta(s) · ${baskets.reduce((sum, t) => sum + (Number(t.quantity) || 0), 0)} u. en ${card.name}.`
          + (config.text ? `<div class="text-sm mt-2">${config.text}</div>` : ''),
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, aceptar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      const ids = pending.map(r => r.id);
      try {
        for (const step of config.steps) {
          await productionUsersService[step](ids);
        }
        const taskIds = baskets.map(t => t.id);
        this.selectedTaskIds = this.selectedTaskIds.filter(id => !taskIds.includes(id));
        await Swal.fire({ icon: 'success', title: '¡Listo!', text: `${baskets.length} canasta(s) actualizada(s).`, timer: 1500, showConfirmButton: false });
      } catch (error) {
        await Swal.fire({ icon: 'error', title: 'Error', text: error.response?.data?.message || error.message });
      } finally {
        await this.refreshCards(pending, { insumos: action === 'validated' });
      }
    },
    // tasks: tareas a enviar; sin tasks se usan las canastas seleccionadas en la card.
    // Una tarea anterior a las canastas se envía con sus filas y el servidor la convierte en canasta.
    // branch: los procesos en paralelo de la lista se envían cada uno a otro oficio, sin reunir la canasta.
    // keepGroup: (envío de una sola tarea) el grupo de la tarea queda preseleccionado al elegir el oficio.
    openTransferModal(card, tasks = null, { branch = false, keepGroup = false } = {}) {
      const list = tasks || card.selectedTasks;
      const isBranch = task => branch && !!task.parallel;
      // Grupo fijo común a todas las canastas (si difieren no se preselecciona ninguno)
      const homeGroupIds = [...new Set(list.map(task => task.basket?.home_group_id || null))];
      const homeGroupId = homeGroupIds.length === 1 ? homeGroupIds[0] || '' : '';
      this.transfer = {
        homeGroupId,
        fixGroup: '', // '' no cambia el grupo fijo · 'fix' fija el grupo elegido · 'unfix' lo quita
        defaultGroupId: homeGroupId || (keepGroup ? (list[0]?.groupId || '') : ''),
        branchTaskIds: list.filter(isBranch).map(t => t.id),
        items: list
          .filter((task, i) => isBranch(task) || !task.basket
            || list.findIndex(o => !isBranch(o) && o.basket?.id === task.basket.id) === i)
          .map(task => task.basket
          ? {
            branchTaskId: isBranch(task) ? task.id : null,
            basketId: task.basket.id,
            rowIds: [],
            modelId: task.basket.production_models_id,
            quantity: Number(task.basket.quantity) || 0,
            passedOficioIds: (task.basket.tasks || []).map(t => t.oficio_id),
          }
          : {
            basketId: null,
            rowIds: task.rows.map(r => r.id),
            modelId: task.rows[0]?.production_models_id,
            quantity: Math.max(...task.rows.map(r => (Number(r.received_quantity) || 0) - (Number(r.rejected_quantity) || 0))),
            passedOficioIds: [Number(task.oficioId)],
          }),
        fromName: list[0]?.parallel && !branch ? `procesos en paralelo (${list[0].parallel.allNames})` : card.name,
        oficio_id: '',
        group_id: '',
        user_id: '',
        observation: '',
        rework: false,
        parallel: false,
        processes: [],
      };
      this.modalTransfer = new Modal(document.getElementById('ModalTransferBaskets'));
      this.modalTransfer.show();
    },
    async submitTransfer() {
      if (this.isTransferring) return;
      const t = this.transfer;
      const missing = t.parallel
        ? (t.processes.length < 2 ? 'Agregue al menos dos procesos.'
          : t.processes.some(p => !p.oficio_id) ? 'Seleccione el oficio de cada proceso.'
          : t.processes.some(p => !p.group_id && !p.user_id) ? 'Seleccione un grupo o un usuario en cada proceso.'
          : null)
        : (!t.oficio_id ? 'Seleccione el oficio destino.'
          : (!t.group_id && !t.user_id) ? 'Seleccione un grupo o un usuario.'
          : null);
      if (missing) {
        await Swal.fire({ icon: 'warning', title: 'Faltan datos', text: missing });
        return;
      }

      this.isTransferring = true;
      try {
        const target = t.parallel
          ? {
            processes: t.processes.map(p => ({
              oficio_id: p.oficio_id,
              group_id: p.group_id || null,
              user_id: p.user_id || null,
              observation: p.observation || null,
            })),
            observation: t.observation || null,
            rework: !!t.rework,
          }
          : {
            oficio_id: t.oficio_id,
            group_id: t.group_id || null,
            user_id: t.user_id || null,
            observation: t.observation || null,
            rework: !!t.rework,
            ...(t.fixGroup === 'fix' && t.group_id && t.group_id != t.homeGroupId ? { fix_group: true }
              : t.fixGroup === 'unfix' ? { fix_group: false } : {}),
          };
        const requests = [];
        if (t.branchTaskIds.length) requests.push({ ...target, branch_task_ids: t.branchTaskIds });
        const others = t.items.filter(item => !item.branchTaskId);
        const basketIds = others.filter(item => item.basketId).map(item => item.basketId);
        requests.push(...others.filter(item => !item.basketId).map(item => ({ ...target, task_row_ids: item.rowIds })));
        if (basketIds.length) requests.push({ ...target, basket_ids: basketIds });

        let response;
        for (const payload of requests) {
          response = await productionUsersService.transferBaskets(payload);
        }
        this.modalTransfer?.hide();
        this.selectedTaskIds = [];
        await Swal.fire({
          icon: 'success',
          title: '¡Enviadas!',
          text: requests.length > 1 ? `Se enviaron ${t.items.length} tarea(s).` : response.data?.message,
        });
        // Solo se marca la card del oficio destino; los demás datos se actualizan en silencio
        const targetOficios = t.parallel ? t.processes.map(p => p.oficio_id) : [t.oficio_id];
        await this.refreshCardKeys(targetOficios.map(String), { insumos: true });
      } catch (error) {
        await Swal.fire({ icon: 'error', title: 'Error', text: error.response?.data?.message || error.message });
      } finally {
        this.isTransferring = false;
      }
    },
    async submitFinish() {
      if (this.isTransferring) return;
      const t = this.transfer;
      const count = t.items.length;
      const result = await Swal.fire({
        title: '¿Terminar canasta?',
        text: `${count > 1 ? `Las ${count} tareas seleccionadas quedan entregadas` : 'La tarea queda entregada'} y la canasta ya no se envía a ningún oficio: su proceso termina aquí.`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sí, terminar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      this.isTransferring = true;
      try {
        const base = { observation: t.observation || null };
        const requests = [];
        if (t.branchTaskIds.length) requests.push({ ...base, branch_task_ids: t.branchTaskIds });
        const others = t.items.filter(item => !item.branchTaskId);
        requests.push(...others.filter(item => !item.basketId).map(item => ({ ...base, task_row_ids: item.rowIds })));
        const basketIds = others.filter(item => item.basketId).map(item => item.basketId);
        if (basketIds.length) requests.push({ ...base, basket_ids: basketIds });

        let response;
        for (const payload of requests) {
          response = await productionUsersService.finishBaskets(payload);
        }
        this.modalTransfer?.hide();
        this.selectedTaskIds = [];
        await Swal.fire({ icon: 'success', title: '¡Terminada!', text: response?.data?.message });
        await Promise.all([this.getData({ silent: true }), this.getInsumos({ silent: true })]);
      } catch (error) {
        await Swal.fire({ icon: 'error', title: 'Error', text: error.response?.data?.message || error.message });
      } finally {
        this.isTransferring = false;
      }
    },
    async reopenBasket(task) {
      const result = await Swal.fire({
        title: '¿Reabrir canasta?',
        text: `La canasta #${task.basket.number} vuelve a ${task.oficioName || 'esta tarea'} y se puede enviar de nuevo.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, reabrir',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      try {
        await productionUsersService.reopenBasket(task.basket.id);
        await Promise.all([this.getData(), this.getInsumos()]);
      } catch (error) {
        await Swal.fire({ icon: 'error', title: 'Error', text: error.response?.data?.message || error.message });
      }
    },
    async deleteBasketTask(task) {
      const isAssignment = task.type === 'asignacion';
      const isProcess = !!task.split_id || !!task.parallel;
      const result = await Swal.fire({
        title: isProcess ? '¿Quitar proceso?' : (isAssignment ? '¿Eliminar canasta?' : '¿Deshacer movimiento?'),
        text: (isProcess
          ? `Se quita el proceso ${task.oficioName || task.oficio?.name || ''} de la canasta #${task.basket.number}. Si es el último proceso, la canasta regresa a ${task.fromOficioName || 'su oficio anterior'}.`
          : isAssignment
          ? `Se elimina la canasta #${task.basket.number} y sus tareas.`
          : `La canasta #${task.basket.number} regresa a ${task.fromOficioName || 'su oficio anterior'}.`)
          + (task.status === 'validada' ? ' La tarea ya está validada.' : ''),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Sí, continuar',
        cancelButtonText: 'Cancelar',
      });
      if (!result.isConfirmed) return;

      try {
        await productionUsersService.deleteBasketTask(task.id);
        await Promise.all([this.getData(), this.getInsumos()]);
      } catch (error) {
        await Swal.fire({ icon: 'error', title: 'Error', text: error.response?.data?.message || error.message });
      }
    },
    // Observaciones ya usadas en esta producción para el oficio (las más recientes primero)
    observationSuggestions(oficioId) {
      if (!oficioId) return [];
      const rows = (this.data?.data || [])
        .filter(r => r.oficio_id == oficioId && r.observation && r.observation.trim())
        .sort((a, b) => b.id - a.id);
      const texts = [...new Set(rows.map(r => r.observation.trim()))]
        .filter(text => text !== 'Tarea existente convertida en canasta');
      return texts.slice(0, 12);
    },
    // Usuarios para el envío: con grupo, sus integrantes activos (vacío = todo el grupo); sin grupo, los del oficio
    transferUserOptions(oficioId, groupId) {
      if (!groupId) return this.usersForOficio(oficioId);
      const group = (this.groups || []).find(g => g.id == groupId);
      return (group?.users || []).filter(u => u.status == 1);
    },
    // Grupo preseleccionado al elegir el oficio destino: el de la tarea, si trabaja en ese oficio
    transferDefaultGroup(oficioId) {
      const groupId = this.transfer.defaultGroupId;
      return groupId && this.groupsForOficio(oficioId).some(g => g.id == groupId) ? groupId : '';
    },
    newTransferProcess() {
      return { oficio_id: '', group_id: '', user_id: '', observation: '' };
    },
    groupNameById(groupId) {
      return (this.groups || []).find(g => g.id == groupId)?.name || 'Grupo';
    },
    groupsForOficio(oficioId) {
      if (!oficioId) return [];
      return (this.groups || []).filter(g => this.groupHasOficio(g, oficioId) && g.status != 0);
    },
    // Un grupo puede tener varios oficios (oficios); oficio_id es el primero (datos anteriores)
    groupHasOficio(group, oficioId) {
      const ids = group.oficios?.length ? group.oficios.map(o => o.id) : [group.oficio_id];
      return ids.some(id => id == oficioId);
    },
    usersForOficio(oficioId) {
      if (!oficioId) return [];
      const byOficio = (this.users || []).filter(user => {
        const processes = Array.isArray(user.processes) ? user.processes : JSON.parse(user.processes || "[]");
        return processes.map(Number).includes(Number(oficioId));
      });
      return byOficio.length ? byOficio : (this.users || []);
    },
    // Recorrido de una tarea de canasta: de dónde viene, a dónde fue y, si es un proceso
    // de un envío en paralelo, con qué otros procesos va y cuántos están validados.
    basketTaskLinks(basket, task, rowsByTask = {}) {
      const tasks = basket.tasks || [];
      const names = list => list.map(t => t.oficio?.name).filter(Boolean).join(' + ');
      const splitTasks = splitId => tasks.filter(t => t.split_id === splitId);

      // Un envío en paralelo que salió de otro ya reunido viene de todos sus procesos
      const fromSplitId = task.from_split_id
        || (task.split_id && !task.from_task_id ? (basket.splits || []).find(sp => sp.id === task.split_id)?.from_split_id : null);
      const fromOficioName = fromSplitId
        ? names(splitTasks(fromSplitId))
        : tasks.find(t => t.id === task.from_task_id)?.oficio?.name;

      // Proceso en paralelo enviado a otro oficio sin reunir: sigue en el proceso que salió de él
      const branchNext = task.split_id
        ? tasks.filter(t => t.split_id === task.split_id && t.from_task_id === task.id)
        : [];

      // Un proceso en paralelo sigue en lo que salió al reunirse; una tarea normal, en lo que salió de ella
      let next;
      if (branchNext.length) {
        next = branchNext;
      } else if (task.split_id) {
        const childSplits = (basket.splits || []).filter(sp => sp.from_split_id === task.split_id).map(sp => sp.id);
        next = tasks.filter(t => t.from_split_id === task.split_id || childSplits.includes(t.split_id));
      } else {
        next = tasks.filter(t => t.from_task_id === task.id);
      }

      let parallel = null;
      if (task.split_id) {
        // Procesos donde está la canasta ahora: los que no se enviaron a otro proceso del mismo envío
        const siblings = splitTasks(task.split_id)
          .filter(t => !tasks.some(o => o.split_id === t.split_id && o.from_task_id === t.id));
        const validated = siblings.filter(t => this.rowsStatus(rowsByTask[t.id] || []) === 'validada').length;
        parallel = {
          withNames: names(siblings.filter(t => t.id !== task.id)),
          allNames: names(siblings),
          validated,
          total: siblings.length,
          complete: validated === siblings.length,
        };
      }

      return { fromOficioName, toOficioName: names(next), parallel };
    },
    openBasketHistory(basketId) {
      this.historyBasketId = basketId;
      this.modalBasketHistory = new Modal(document.getElementById('ModalBasketHistory'));
      this.modalBasketHistory.show();
    },
    formatMoneyShort(value) {
      return '$' + Math.round(value || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    // Unidades pendientes de un oficio en el modelo seleccionado (o en toda la producción)
    pendingForOficio(productionModelId, oficioId) {
      const models = parseInt(productionModelId) === 0
        ? this.insumos
        : this.insumos.filter(i => i.id === parseInt(productionModelId));
      return models.reduce((sum, pm) => {
        const oficio = (pm.oficios || []).find(o => Number(o.id) === Number(oficioId));
        return sum + (oficio ? Number(oficio.pending_quantity) || 0 : 0);
      }, 0);
    },
    async openModalEditQuantities() {
      await this.getData();
      this.modalQtyUserSearch = '';
      this.modalQtyModelFilter = '';
      this.modalQtyOficioFilter = '';
      this.modalDeliveredSnapshot = {};
      (this.data?.data || []).forEach((r) => {
        this.modalDeliveredSnapshot[r.id] = parseInt(r.delivered_quantity, 10) || 0;
      });
      const modalElement = document.getElementById('ModalEditQuantities');
      this.modalEditQuantities = new Modal(modalElement);
      this.modalEditQuantities.show();
    },
    closeModalEditQuantities() {
      if (this.modalEditQuantities) {
        this.modalEditQuantities.hide();
      }
    },
    blurQtyInput(ev) {
      if (ev?.target && typeof ev.target.blur === 'function') {
        ev.target.blur();
      }
    },

    normalizeDeliveredQtyFromInput(ev, fallbackRowQty) {
      let raw = '';
      if (
        ev != null &&
        typeof ev.target === 'object' &&
        Object.prototype.hasOwnProperty.call(ev.target, 'value')
      ) {
        raw = ev.target.value;
      }
      const trimmed = raw === null || raw === undefined ? '' : String(raw).trim();
      if (trimmed === '') {
        const fb = parseInt(String(fallbackRowQty), 10);
        return Number.isNaN(fb) ? 0 : fb;
      }

      let qty = parseInt(trimmed, 10);
      if (Number.isNaN(qty)) {
        qty = parseInt(String(fallbackRowQty), 10);
      }
      if (Number.isNaN(qty)) {
        qty = 0;
      }
      return qty;
    },

    async persistDeliveredQuantity(row, ev) {
      if (this.savingDeliveredRowId === row.id) {
        return;
      }

      const rowSync = Array.isArray(this.data?.data)
        ? this.data.data.find((r) => String(r.id) === String(row.id))
        : null;
      const targetRow = rowSync || row;

      const snapKey = String(row.id);
      const prevSaved = this.modalDeliveredSnapshot[row.id];
      const prevNormalized =
        prevSaved !== undefined && prevSaved !== null ? Number(prevSaved) : undefined;

      const hasEvValue =
        ev != null &&
        typeof ev.target === 'object' &&
        Object.prototype.hasOwnProperty.call(ev.target, 'value');
      const trimmedEv = hasEvValue ? String(ev.target.value).trim() : '';

      // Vacío en blur: no enviar 0 al API (valor vacío típico con type=number antes de sincronizar el modelo)
      if (hasEvValue && trimmedEv === '') {
        const restore =
          prevNormalized !== undefined && !Number.isNaN(prevNormalized)
            ? prevNormalized
            : (parseInt(String(targetRow.delivered_quantity), 10) ||
               parseInt(String(row.delivered_quantity), 10) ||
               0);
        targetRow.delivered_quantity = restore;
        ev.target.value = String(restore);
        return;
      }

      let qty = this.normalizeDeliveredQtyFromInput(ev, row.delivered_quantity);
      qty = Math.max(0, qty);

      targetRow.delivered_quantity = qty;
      if (ev?.target && typeof ev.target === 'object' && Object.prototype.hasOwnProperty.call(ev.target, 'value')) {
        ev.target.value = qty === null || qty === undefined ? '' : String(qty);
      }

      if (prevNormalized !== undefined && qty === prevNormalized) {
        return;
      }

      this.savingDeliveredRowId = row.id;
      try {
        const response = await productionUsersService.updateDeliveredQuantity(row.id, {
          delivered_quantity: qty,
        });
        if (response.status >= 200 && response.status < 300) {
          this.modalDeliveredSnapshot[row.id] = qty;
          const updated = response.data;
          const idx = this.data?.data?.findIndex((r) => String(r.id) === snapKey);
          if (idx >= 0 && updated && typeof updated === 'object') {
            this.data.data[idx] = { ...this.data.data[idx], ...updated };
            const dq = Number(this.data.data[idx].delivered_quantity);
            this.data.data[idx].delivered_quantity = Number.isNaN(dq) ? qty : dq;
          } else if (idx >= 0) {
            this.data.data[idx].delivered_quantity = qty;
          }
        }
      } catch (error) {
        const msg = error.response?.data?.message || error.message || 'No se pudo guardar la cantidad entregada.';
        const revertTo =
          prevNormalized !== undefined && !Number.isNaN(prevNormalized) ? prevNormalized : 0;

        const synced = Array.isArray(this.data?.data)
          ? this.data.data.find((r) => String(r.id) === snapKey)
          : null;

        if (synced) {
          synced.delivered_quantity = revertTo;
        }

        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: msg,
        });

        await this.getData();

        (this.data?.data || []).forEach((r) => {
          this.modalDeliveredSnapshot[r.id] = parseInt(String(r.delivered_quantity), 10) || 0;
        });
      } finally {
        this.savingDeliveredRowId = null;
      }
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
      this.markAsReceived = false;
    },
    async openModalModel() {
      this.editingProductionModelId = null;
      if (!this.form.model_id) {
        await Swal.fire({
          icon: 'warning',
          title: 'Selecciona un modelo',
          text: 'Debes elegir un modelo en el formulario principal antes de asignar tallas.',
          confirmButtonText: 'Entendido',
        });
        return;
      }
      this.production_model.model_id = this.form.model_id;
      await this.getSizes();
      
      const modalElement = document.getElementById('ModalModel');
      this.modalModel = new Modal(modalElement); // Guarda la instancia del modal
      this.modalModel.show(); // Muestra el modal
      
      // Reinicializar Select2 después de cargar los datos
      this.$nextTick(() => {
        if (this.$refs.sizesSelect) {
          // Destruir Select2 si ya existe
          if ($(this.$refs.sizesSelect).hasClass('select2-hidden-accessible')) {
            $(this.$refs.sizesSelect).select2('destroy');
          }
          
          // Inicializar Select2 con los nuevos datos (múltiple)
          $(this.$refs.sizesSelect).select2({
            placeholder: 'Seleccione una o más tallas y colores',
            allowClear: true,
            multiple: true,
            dropdownParent: $('#ModalModel .modal-body'),
            width: '100%'
          }).on('change', () => {
            // Los size_id ahora son un array de IDs de models_model (múltiple)
            // El precio del costo unitario viene del modelo (form.price), no del models_model
            // Se mantiene el precio del modelo para el costo unitario
          });
        }
      });
    },
    closeModalModel() {
      this.editingProductionModelId = null;
      if (this.modalModel) {
        this.modalModel.hide(); // Cierra el modal
      }
    },
    async duplicateProductionModel(group) {
      if (!group?.id) {
        return;
      }
      try {
        const result = await Swal.fire({
          title: '¿Duplicar modelo?',
          text: 'Se creará una copia con los mismos insumos y cantidades. Cantidad enviada en remisiones quedará en cero.',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#6c757d',
          confirmButtonText: 'Duplicar',
          cancelButtonText: 'Cancelar',
        });

        if (!result.isConfirmed) {
          return;
        }

        const response = await this.$store.dispatch('productionModels/duplicate', group.id);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: 'Modelo duplicado',
            text: 'Se agregó el registro copiado a la lista.',
            confirmButtonText: 'Aceptar',
          });
          await this.getInsumos();
        } else {
          throw new Error(response?.data?.message || 'No se pudo duplicar el modelo');
        }
      } catch (error) {
        console.error('Error al duplicar modelo:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || error?.message || 'Error al duplicar el modelo',
        });
      }
    },
    async openModalEditModel(group) {
      this.editingProductionModelId = group.id;
      this.production_model.quantity_to_produce = group.quantity_to_produce;
      this.production_model.model_id = group.model_id;
      this.production_model.production_id = this.form.id;
      this.production_model.price = this.form.price || 0;
      if (!this.form.model_id) {
        this.form.model_id = group.model_id;
      }
      await this.getSizes();
      const modalElement = document.getElementById('ModalModel');
      this.modalModel = new Modal(modalElement);
      this.modalModel.show();
      this.$nextTick(() => {
        if (this.$refs.sizesSelect) {
          if ($(this.$refs.sizesSelect).hasClass('select2-hidden-accessible')) {
            $(this.$refs.sizesSelect).select2('destroy');
          }
          $(this.$refs.sizesSelect).select2({
            placeholder: 'Seleccione una o más tallas y colores',
            allowClear: true,
            multiple: true,
            dropdownParent: $('#ModalModel .modal-body'),
            width: '100%'
          }).on('change', () => {});
          this.$nextTick(() => {
            const sizeId = group.size_id || group.size?.id;
            if (sizeId) {
              $(this.$refs.sizesSelect).val([String(sizeId)]).trigger('change');
              this.oficio_id = [sizeId];
            }
          });
        }
      });
    },
    openModalDefects() {
      const modalElement = document.getElementById('ModalDefects');
      this.modalDefects = new Modal(modalElement); // Guarda la instancia del modal
      this.modalDefects.show(); // Muestra el modal
    },
    closeModalDefects() {
      if (this.modalDefects) {
        this.modalDefects.hide(); // Cierra el modal
      }
    },
    // silent: recarga sin ocultar todas las asignaciones (el spinner va en la card que cambió)
    async getData({ silent = false } = {}) {
      if (!silent) this.loadingUsers = true;
      try {
        await Promise.all([
          this.$store.dispatch('productionUsers/getData', this.form.id),
          this.getBaskets(),
        ]);
        this.data = this.$store.state.productionUsers.getData;
      } finally {
        if (!silent) this.loadingUsers = false;
      }
    },
    // Refresca las asignaciones mostrando el spinner solo en las cards de los oficios de esas filas
    async refreshCards(rows = [], { insumos = false } = {}) {
      await this.refreshCardKeys(rows.map(r => (r.oficio_id ? String(r.oficio_id) : 'none')), { insumos });
    },
    async refreshCardKeys(cardKeys, { insumos = false } = {}) {
      const keys = [...new Set(cardKeys)];
      keys.forEach(key => { this.refreshingCards[key] = true; });
      try {
        await Promise.all([
          this.getData({ silent: true }),
          insumos ? this.getInsumos({ silent: true }) : null,
        ]);
      } finally {
        keys.forEach(key => { delete this.refreshingCards[key]; });
      }
    },
    async getInsumos({ silent = false } = {}) {
      if (!silent) this.loadingInsumos = true;
      try {
        const data = await this.$store.dispatch('productionModels/getData', this.form.id);
        this.insumos = data.data;
      } finally {
        if (!silent) this.loadingInsumos = false;
      }
    },
    async getAllInsumos() {
      this.insumosInventory = await this.$store.dispatch('inventory/getNames');
    },
    async save() {
      // Evitar doble guardado
      if (this.isSaving) {
        return;
      }

      try {
        // Activar estado de guardado
        this.isSaving = true;

        // Mostrar modal de carga
        Swal.fire({
          title: 'Guardando...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        const payload = {
          ...this.form,
          model_id: this.form.model_id ? parseInt(this.form.model_id) : null,
          oficio_id: this.form.oficio_id ? parseInt(this.form.oficio_id) : null,
          bodega_id: this.form.bodega_id ? parseInt(this.form.bodega_id) : null,
        };

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("production/save", payload);
        
        // Cerrar modal de carga
        Swal.close();

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El proyecto ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {

              this.form = {
                ...response.data,
                model_id: response.data.model_id ?? null,
                selling_cost: response.data.selling_cost || 0,
                wholesale_price: response.data.wholesale_price || 0,
                retail_price: response.data.retail_price || 0,
                oficio_id: response.data.oficio_id ? parseInt(response.data.oficio_id) : null,
                bodega_id: response.data.bodega_id ? parseInt(response.data.bodega_id) : null,
                is_maquila: Boolean(response.data.is_maquila),
              };
              this.form.id = response.data.id || 0;
              this.modal.project_id = response.data.id || 0;

              // Actualizar URL con el id de la producción
              if (response.data.id) {
                this.$router.replace({ query: { id: response.data.id } });
              }

              this.production_model.production_id = response.data.id || 0;
              this.production_model.model_id = this.form.model_id || 0;
              this.production_user.production_id = response.data.id || 0;

              this.getInsumos();
              this.getModels();
              this.getOficios();
              this.getBodegas();
              this.getSizes();
              this.getUsers();

              // Actualizar Select2 después de guardar
              this.$nextTick(() => {
                if (this.$refs.modelSelect && this.form.model_id) {
                  $(this.$refs.modelSelect).val(this.form.model_id).trigger('change');
                }
              });
            }
          });

        } else {
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        // Cerrar modal de carga en caso de error
        Swal.close();
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el proyecto',
        });
      } finally {
        // Desactivar estado de guardado
        this.isSaving = false;
      }
    },
    async submitForm() {
      if (this.isSavingUser) {
        return;
      }

      try {
        this.isSavingUser = true;
        this.production_user.oficio_id = this.oficio_id;
        // Envía grupo o usuario, nunca ambos
        if (this.production_user.group_id && this.production_user.group_id != 0) {
          this.production_user.user_id = null;
        } else {
          this.production_user.group_id = null;
        }
        if (this.markAsReceived) {
          this.production_user.received_date = new Date().toISOString().slice(0, 10);
        } else {
          this.production_user.received_date = null;
        }
        // División en canastas (en producción completa el servidor arma una canasta por modelo)
        if (this.isProductionCompleteSelected) {
          this.production_user.baskets = [];
        } else if (!this.basketsDivisionValid) {
          await Swal.fire({
            icon: 'warning',
            title: 'División en canastas',
            text: `Las canastas suman ${this.basketsDivisionTotal} y la cantidad asignada es ${this.production_user.received_quantity || 0}.`,
          });
          return;
        } else {
          this.production_user.baskets = this.basketsDivision
            .filter(d => parseInt(d.count) > 0 && parseInt(d.quantity) > 0)
            .map(d => ({ count: parseInt(d.count), quantity: parseInt(d.quantity) }));
        }
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("productionUsers/save", this.production_user);

        if (response && response.status >= 200 && response.status < 300) {
          const successMessage = response?.data?.message || 'El registro ha sido guardado correctamente.';

          const escapeHtml = (value) => String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');

          const lines = String(successMessage)
            .split('\n')
            .map(line => line.trim())
            .filter(Boolean);

          let successHtml = '';
          const firstBulletIndex = lines.findIndex(line => line.startsWith('- '));

          if (firstBulletIndex >= 0) {
            const headerLines = lines.slice(0, firstBulletIndex);
            const bulletLines = lines.slice(firstBulletIndex).filter(line => line.startsWith('- '));

            successHtml = headerLines.map(line => `<div>${escapeHtml(line)}</div>`).join('');
            successHtml += `
              <ul style="text-align: left; margin: 8px 0 0 0; padding-left: 20px; list-style-type: disc; list-style-position: outside;">
                ${bulletLines.map(line => `<li>${escapeHtml(line.replace(/^-\\s*/, ''))}</li>`).join('')}
              </ul>
            `;
          } else {
            successHtml = lines.map(line => `<div>${escapeHtml(line)}</div>`).join('');
          }

          successHtml = `<div style="text-align: left;">${successHtml}</div>`;

          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            html: successHtml,
            confirmButtonText: 'Aceptar',
            backdrop: true,
          });

          // Descarga automática del PDF al asignar usuario (deshabilitada)
          // if (productionUserId) {
          //   try {
          //     const pdfResponse = await this.$store.dispatch("productionUsers/getPdf", productionUserId);
          //
          //     const url = window.URL.createObjectURL(new Blob([pdfResponse.data]));
          //
          //     const link = document.createElement("a");
          //     link.href = url;
          //     link.setAttribute("download", `formato_entrega_corte_${productionUserId}.pdf`);
          //     document.body.appendChild(link);
          //     link.click();
          //
          //     document.body.removeChild(link);
          //     window.URL.revokeObjectURL(url);
          //   } catch (error) {
          //     console.error("Error al generar el PDF:", error);
          //   }
          // }

          this.getData();
          this.getInsumos();
          this.closeModal();

          this.production_user.production_models_id = 0;
          this.production_user.oficio_id = 0;
          this.production_user.user_id = 0;
          this.production_user.group_id = 0;
          this.production_user.received_quantity = 0;
          this.production_user.price = 0;
          this.production_user.benefit = 0;
          this.production_user.delivered_quantity = 0;
          this.production_user.received_date = null;
          this.production_user.termination_date = null;
          this.production_user.baskets = [];
          this.basketsDivision = [{ count: 1, quantity: 0 }];
          this.markAsReceived = false;

          $(this.$refs.modelUserSelect).val(null).trigger('change');
          $(this.$refs.processesSelect).val(null).trigger('change');
          $(this.$refs.usersSelect).val(null).trigger('change');
          $(this.$refs.grupoSelect).val(0).trigger('change');
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      } finally {
        this.isSavingUser = false;
      }

    },
    async submitFormModel() {
      try {
        // Modo edición: actualizar solo cantidad y precio del modelo existente
        if (this.editingProductionModelId) {
          const quantity = typeof this.production_model.quantity_to_produce === 'string'
            ? parseFloat(String(this.production_model.quantity_to_produce).replace(/\./g, '').replace(',', '.')) || 0
            : parseFloat(this.production_model.quantity_to_produce) || 0;
          if (!quantity || quantity <= 0) {
            await Swal.fire({
              icon: 'warning',
              title: 'Cantidad requerida',
              text: 'Debe ingresar una cantidad válida para producir.',
              confirmButtonText: 'Aceptar',
            });
            return;
          }
          const price = this.form.price || 0;
          const data = {
            id: this.editingProductionModelId,
            production_id: this.production_model.production_id,
            model_id: this.production_model.model_id,
            size_id: $(this.$refs.sizesSelect).val()?.[0] || null,
            quantity_to_produce: quantity,
            price: price,
            bodega_id: this.production_model.bodega_id || null,
          };
          const response = await this.$store.dispatch('productionModels/save', data);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El modelo se actualizó correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
            });
            this.production_model.quantity_to_produce = 0;
            this.production_model.price = 0;
            $(this.$refs.sizesSelect).val(null).trigger('change');
            this.getInsumos();
            this.closeModalModel();
          } else {
            throw new Error(response?.data?.message || 'Error al actualizar');
          }
          return;
        }

        // Obtener los IDs seleccionados del Select2 múltiple
        const selectedSizeIds = $(this.$refs.sizesSelect).val() || [];
        
        if (selectedSizeIds.length === 0) {
          await Swal.fire({
            icon: 'warning',
            title: 'Seleccione al menos una talla',
            text: 'Debe seleccionar al menos una talla y color para continuar.',
            confirmButtonText: 'Aceptar',
          });
          return;
        }

        // Validar que haya una cantidad
        if (!this.production_model.quantity_to_produce || this.production_model.quantity_to_produce <= 0) {
          await Swal.fire({
            icon: 'warning',
            title: 'Cantidad requerida',
            text: 'Debe ingresar una cantidad válida para producir.',
            confirmButtonText: 'Aceptar',
          });
          return;
        }

        // Asignar el precio del modelo al production_model antes de guardar
        const price = this.form.price || 0;
        
        // Crear un registro para cada talla seleccionada
        const promises = selectedSizeIds.map(sizeId => {
          const productionModel = {
            id: 0,
            production_id: this.production_model.production_id,
            model_id: this.production_model.model_id,
            size_id: sizeId,
            quantity_to_produce: this.production_model.quantity_to_produce,
            price: price,
            bodega_id: this.production_model.bodega_id || null,
          };
          
          return this.$store.dispatch("productionModels/save", productionModel);
        });

        // Ejecutar todas las peticiones en paralelo
        const responses = await Promise.all(promises);
        
        // Verificar que todas las respuestas sean exitosas
        const allSuccess = responses.every(response => response && response.status >= 200 && response.status < 300);
        
        if (allSuccess) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: `Se crearon ${selectedSizeIds.length} registro(s) correctamente.`,
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              // Limpiar el formulario
              this.production_model.size_id = 0;
              this.production_model.quantity_to_produce = 0;
              this.production_model.price = 0;

              // Limpiar el select2 múltiple
              $(this.$refs.sizesSelect).val(null).trigger('change');

              // Refrescar los datos
              this.getInsumos();
              this.closeModalModel();
            }
          });
        } else {
          throw new Error('Algunos registros no se pudieron guardar correctamente');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }

    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionModels/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getInsumos();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async deleteRegisterDetail(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionDetails/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getInsumos();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    viewObservation(observation) {
      // Mostramos el mensaje en un SweetAlert
      Swal.fire({
        title: 'Observación',
        text: observation || 'No hay observaciones disponibles.',
        icon: 'info',  // Puedes cambiar el icono a info, success, warning, etc.
        confirmButtonText: 'Aceptar'
      });
    },
    async checkReceived(value) {

      try {
        const result = await Swal.fire({
          title: 'Recibir Tarea',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, aceptar',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {

          value.received_date = new Date().toISOString().slice(0, 10);

          const response = await this.$store.dispatch("productionUsers/save", value);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Tarea aceptada!',
              'Recuerda realizar la entrega.',
              'success'
            );

            this.refreshCards([value]);
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async handleDeliveredInput(value) {
      const deliveredQty = Number(value.delivered_quantity);
      const receivedQty = Number(value.received_quantity);

      if (isNaN(deliveredQty) || deliveredQty <= 0) {
        return;
      }

      if (deliveredQty > receivedQty) {
        await Swal.fire({
          icon: 'warning',
          title: 'Cantidad excedida',
          text: 'La cantidad entregada no puede ser mayor a la recibida.',
        });
        return;
      }

      const { value: formValues } = await Swal.fire({
        title: 'Entregar Tarea',
        html: `
        <div style="text-align: left;">
          <div class="mb-3">
            <label class="form-label" style="font-weight: bold;">Cantidad entregada: ${deliveredQty}</label>
          </div>
          <div class="mb-3">
            <label for="swal-input-obs-deliver" class="form-label" style="font-weight: bold;">Observación:</label>
            <textarea id="swal-input-obs-deliver" class="form-control" placeholder="Agregue una observación" rows="3"></textarea>
          </div>
        </div>`,
        focusConfirm: false,
        preConfirm: () => {
          const obs = document.getElementById('swal-input-obs-deliver').value;
          return { obs };
        },
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'sí, aceptar',
        cancelButtonText: 'Cancelar',
      });

      if (!formValues) return;

      const updatedValue = { ...value };
      updatedValue.delivered_date = new Date().toISOString().slice(0, 10);
      updatedValue.delivered_quantity = deliveredQty;
      updatedValue.observation = formValues.obs;

      try {
        const response = await this.$store.dispatch("productionUsers/save", updatedValue);

        if (response && response.status >= 200 && response.status < 300) {
          if (deliveredQty < receivedQty) {
            const remaining = receivedQty - deliveredQty;
            await this.checkValidated(updatedValue, remaining);
          } else {
            await Swal.fire('Tarea Entregada!', 'Excelente trabajo.', 'success');
            this.refreshCards([value]);
          }
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async checkDelivered(value) {

      const updatedValue = { ...value };

      try {

        let cantt = Number(updatedValue.received_quantity) - Number(updatedValue.delivered_quantity);


        const { value: formValues } = await Swal.fire({
          title: 'Entregar Tarea',
          html: `
          <div style="text-align: left;">
          <div class="mb-3">
                <label for="swal-input-cant" class="form-label" style="font-weight: bold;">Si entregas una cantidad menor a la recibida, tendreas que volver a realizar la entrega del restante</label>
              </div>
              <div class="mb-3" hidden>
                <label for="swal-input-cant" class="form-label" style="font-weight: bold;">Cantidad entregada:</label>
                <input id="swal-input-cant" type="number" class="form-control" placeholder="Cantidad entregada" min="1" value="${cantt}">
              </div>
              <div class="mb-3">
                <label for="swal-input-obs" class="form-label" style="font-weight: bold;">Observación:</label>
                <textarea id="swal-input-obs" class="form-control" placeholder="Agregue una observación" rows="3"></textarea>
              </div>
            </div>`,
          focusConfirm: false,
          preConfirm: () => {
            const cant = document.getElementById('swal-input-cant').value;
            const obs = document.getElementById('swal-input-obs').value;


            return { cant: parseInt(cant, 10), obs };
          },
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'sí, aceptar',
          cancelButtonText: 'Cancelar',
        });

        if (formValues) {
          updatedValue.delivered_date = new Date().toISOString().slice(0, 10);
          updatedValue.delivered_quantity = formValues.cant;
          updatedValue.observation = formValues.obs;

          const response = await this.$store.dispatch("productionUsers/save", updatedValue);

          if (response && response.status >= 200 && response.status < 300) {
            await Swal.fire(
              'Tarea Entregada!',
              'Excelente trabajo.',
              'success'
            );
            this.refreshCards([value]);
          } else {
            throw new Error(response.data.message || 'Error al guardar el registro');
          }
        }
      } catch (error) {
        console.error("Error al guardar el registro:", error);


        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });



      }
    },
    async checkValidated(value, prefilledDefects = null) {
  try {
    // Asegurarse de que oficios esté cargado
    if (!this.processes || this.processes.length === 0) {
      await this.getOficios();
    }
    if (!this.users || this.users.length === 0) {
      await this.getUsers();
    }

    const { value: formValues } = await Swal.fire({
      title: 'Validar Tarea',
      html: `
        <div style="text-align: left;">
          <!-- Defectos -->
          <div class="mb-3">
            <label for="swal-input-defect" class="form-label" style="font-weight: bold;">Cantidad con defectos (Imperfectos):</label>
            <input id="swal-input-defect" type="number" class="form-control" placeholder="Cantidad con defectos" min="0" value="${prefilledDefects !== null ? prefilledDefects : ''}">
          </div>

          <!-- Campos para nueva tarea cuando hay imperfectos (se muestran cuando hay imperfectos) -->
          <div id="swal-nueva-tarea-section" style="display:none;">
            <div class="mb-3">
              <label for="swal-select-oficio-nueva" class="form-label" style="font-weight: bold;">Oficio para nueva tarea:</label>
              <select id="swal-select-oficio-nueva" class="form-control">
                <option value="">Seleccionar oficio</option>
                ${this.processes.map(o => `<option value="${o.id}">${o.name}</option>`).join("")}
              </select>
            </div>
            <div class="mb-3">
              <label for="swal-user-nueva" class="form-label" style="font-weight: bold;">Seleccionar usuario de tarea:</label>
              <select id="swal-user-nueva" class="form-control">
                <option value="">Seleccionar usuario</option>
                ${this.users.map(u => `<option value="${u.id}">${u.name}</option>`).join("")}
              </select>
            </div>
            <div class="mb-3">
              <label for="swal-observacion-nueva" class="form-label" style="font-weight: bold;">Observación:</label>
              <textarea id="swal-observacion-nueva" class="form-control" rows="3" placeholder="Agregar observación"></textarea>
            </div>
          </div>

        </div>
      `,
      didOpen: () => {
        const defectInput = document.getElementById('swal-input-defect');
        const nuevaTareaSection = document.getElementById('swal-nueva-tarea-section');
        const popup = Swal.getPopup();
        const oficioSelect = document.getElementById('swal-select-oficio-nueva');
        const userSelect = document.getElementById('swal-user-nueva');

        // Si viene con defectos pre-llenados (entrega parcial), mostrar sección nueva tarea
        if (prefilledDefects !== null && prefilledDefects > 0) {
          defectInput.value = String(prefilledDefects);
          defectInput.readOnly = true;
          nuevaTareaSection.style.display = 'block';
        }

        // Autoseleccionar el oficio del registro actual en "Oficio para nueva tarea"
        const currentOficioId = value?.oficio_id ?? value?.oficio?.id ?? '';
        if (oficioSelect && currentOficioId) {
          oficioSelect.value = String(currentOficioId);

          // Fallback por nombre si el ID no coincide exactamente con las opciones cargadas
          if (!oficioSelect.value && value?.oficio?.name) {
            const matchedOficio = this.processes.find(
              (item) => String(item?.name || '').trim().toLowerCase() === String(value.oficio.name).trim().toLowerCase()
            );
            if (matchedOficio?.id) {
              oficioSelect.value = String(matchedOficio.id);
            }
          }
        }

        const getUsersByOficio = (oficioId) => {
          if (!oficioId) return [];
          return this.users.filter((user) => {
            try {
              const processes = Array.isArray(user.processes)
                ? user.processes
                : JSON.parse(user.processes || '[]');
              return processes.map(Number).includes(Number(oficioId));
            } catch (error) {
              return false;
            }
          });
        };

        const renderUsersByOficio = (oficioId) => {
          if (!userSelect) return;

          const usersByOficio = getUsersByOficio(oficioId);
          userSelect.innerHTML = `
            <option value="">Seleccionar usuario</option>
            ${usersByOficio.map((u) => `<option value="${u.id}">${u.name}</option>`).join('')}
          `;

          if ($('#swal-user-nueva').hasClass('select2-hidden-accessible')) {
            $('#swal-user-nueva').off('change').select2('destroy');
          }

          $('#swal-user-nueva').select2({
            placeholder: 'Seleccionar usuario',
            allowClear: true,
            width: '100%',
            dropdownParent: $(popup),
          });
        };

        // Cargar usuarios filtrados según el oficio autoseleccionado
        renderUsersByOficio(oficioSelect?.value || '');

        // Cuando cambie el oficio, recargar usuarios permitidos
        if (oficioSelect) {
          oficioSelect.addEventListener('change', () => {
            renderUsersByOficio(oficioSelect.value || '');
          });
        }

        // Función para actualizar la visibilidad basada en imperfectos
        const updateVisibility = () => {
          const cant = Number(defectInput.value) || 0;
          
          if (cant > 0) {
            // Si hay imperfectos, mostrar campos de nueva tarea
            nuevaTareaSection.style.display = 'block';
          } else {
            // Si no hay imperfectos, ocultar campos de nueva tarea
            nuevaTareaSection.style.display = 'none';
          }
        };

        // Actualizar visibilidad cuando cambia la cantidad de imperfectos
        defectInput.addEventListener('input', updateVisibility);
      },
      focusConfirm: false,
      preConfirm: () => {
        const defectInput = document.getElementById('swal-input-defect').value;

        if (defectInput === '' || isNaN(defectInput)) {
          Swal.showValidationMessage('Debe ingresar una cantidad válida de defectos.');
          return false;
        }
        const cant = Number(defectInput);
        if (cant > Number(value.received_quantity)) {
          Swal.showValidationMessage('La cantidad con defectos supera la asignada.');
          return false;
        }

        // Si hay imperfectos, validar y retornar datos de nueva tarea
        if (cant > 0) {
          const oficioNueva = document.getElementById('swal-select-oficio-nueva')?.value || '';
          const userNueva = document.getElementById('swal-user-nueva')?.value || '';
          const obsNueva = document.getElementById('swal-observacion-nueva')?.value || '';

          if (!oficioNueva) {
            Swal.showValidationMessage('Debe seleccionar un oficio para la nueva tarea.');
            return false;
          }
          if (!userNueva) {
            Swal.showValidationMessage('Debe seleccionar un usuario para la nueva tarea.');
            return false;
          }

          // Usar la cantidad de defectos como cantidad para la nueva tarea
          return {
            defectos: cant,
            selected_option: 'new_task',
            nueva_tarea: {
              oficio_id: parseInt(oficioNueva),
              user_id: parseInt(userNueva),
              cantidad: cant, // Usar la cantidad de defectos
              observacion: obsNueva.trim()
            },
            oficio_id: parseInt(oficioNueva)
          };
        }

        // Si no hay imperfectos, solo retornar defectos
        return {
          defectos: cant,
          selected_option: null
        };
      },
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
    });

    if (formValues) {
      // CREAR NUEVA TAREA ANTES DE VALIDAR LA TAREA ACTUAL
      console.log('formValues:', formValues);
      console.log('formValues.nueva_tarea:', formValues.nueva_tarea);
      console.log('formValues.oficio_id:', formValues.oficio_id);
      
      // Manejar nueva tarea cuando hay imperfectos
      if (formValues.selected_option === 'new_task' && formValues.nueva_tarea) {
        try {
          // Fecha de asignación: fecha actual del día
          const today = new Date().toISOString().slice(0, 10);
          
          const newTask = {
            id: 0,
            production_id: value.production_id,
            production_models_id: value.production_models_id,
            oficio_id: formValues.nueva_tarea.oficio_id,
            user_id: formValues.nueva_tarea.user_id,
            received_quantity: formValues.nueva_tarea.cantidad,
            observation: formValues.nueva_tarea.observacion || `Tarea creada automáticamente desde defectuosos de tarea #${value.id}`,
            status: 0,
            assigned_at: today,
            check_defects: true,
          };
          
          console.log('Creando nueva tarea ANTES de validar:', newTask);
          const newTaskResponse = await this.$store.dispatch("productionUsers/save", newTask);
          console.log('Respuesta creación nueva tarea:', newTaskResponse);
          
          if (newTaskResponse && newTaskResponse.status >= 200 && newTaskResponse.status < 300) {
            console.log('Nueva tarea creada exitosamente');
          } else {
            console.error('Error al crear nueva tarea - respuesta:', newTaskResponse);
            throw new Error('Error al crear la nueva tarea');
          }
        } catch (error) {
          console.error("Error al crear nueva tarea:", error);
          await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error al crear la nueva tarea: ' + (error.message || 'Error desconocido') + '. La tarea no se validará.',
          });
          return; // No continuar con la validación si falla la creación de la nueva tarea
        }
      }

      // AHORA SÍ VALIDAR LA TAREA ACTUAL
      // Crear un nuevo objeto para evitar race conditions
      const updatedValue = {
        ...value,
        validated_date: new Date().toISOString().slice(0, 10),
        rejected_quantity: formValues.defectos,
        finish: 1,
        selected_option: formValues.selected_option, // 🔹 Ya viene en inglés
      };

      if (formValues.corte) {
        Object.assign(updatedValue, {
          corte_user_id: formValues.corte.user_id,
          corte_cantidad: formValues.corte.cantidad,
          laundry_observation: formValues.corte.observacion
        });
      }

      if (formValues.lavanderia) {
        Object.assign(updatedValue, {
          laundry_observation: formValues.lavanderia.observacion
        });
      }

      if (formValues.arreglos) {
        Object.assign(updatedValue, {
          arreglo_user_id: formValues.arreglos.user_id,
          arreglo_cantidad: formValues.arreglos.cantidad,
          laundry_observation: formValues.arreglos.observacion,
        });
      }

      const response = await this.$store.dispatch("productionUsers/save", updatedValue);
      if (response && response.status >= 200 && response.status < 300) {

        // Mensaje de éxito
        let successMessage = 'Excelente trabajo.';
        if (formValues.corte || formValues.arreglos) {
          if (formValues.oficio_id) {
            successMessage = 'Tarea validada y nueva tarea creada.';
          } else {
            successMessage = 'Tarea validada.';
          }
        } else if (formValues.lavanderia) {
          successMessage = 'Tarea validada. Observación de lavandería guardada.';
        }

        await Swal.fire('Tarea Validada!', successMessage, 'success');
        await this.refreshCards([value], { insumos: true });
      } else {
        throw new Error(response.data.message || 'Error al guardar el registro');
      }
    }
  } catch (error) {
    console.error("Error al validar el registro:", error);
    await Swal.fire({
      icon: 'error',
      title: 'Error',
      text: error.message || 'Error al validar el registro',
    });
  }
},
    async handleSellingCostBlur() {
      try {
        // Remover puntos de mil y convertir a número
        const numericValue = parseFloat(this.formattedSellingCost.replace(/\./g, "")) || 0;
        this.form.selling_cost = numericValue;
        this.form.wholesale_price = parseFloat(this.formattedWholesalePrice.replace(/\./g, "")) || 0;
        this.form.retail_price = parseFloat(this.formattedRetailPrice.replace(/\./g, "")) || 0;
        
        // Solo guardar si hay un ID (registro existente)
        if (this.form.id && this.form.id !== 0) {
          const response = await this.$store.dispatch("production/save", this.form);
          
          if (response && response.status >= 200 && response.status < 300) {
            // Actualizar el formulario con la respuesta
            this.form = {
              ...this.form,
              ...response.data,
              selling_cost: response.data.selling_cost || 0,
              wholesale_price: response.data.wholesale_price || 0,
              retail_price: response.data.retail_price || 0,
              oficio_id: response.data.oficio_id ? parseInt(response.data.oficio_id) : null,
              bodega_id: response.data.bodega_id ? parseInt(response.data.bodega_id) : null,
            };
          }
        }
      } catch (error) {
        console.error('Error al guardar precio de venta:', error);
      }
    },
    async handleReceivedQuantityChange(value) {
      try {
        // Validar que la cantidad sea válida
        if (!value.received_quantity || value.received_quantity <= 0) {
          await Swal.fire({
            icon: 'warning',
            title: 'Cantidad inválida',
            text: 'La cantidad recibida debe ser mayor a 0.',
          });
          // Recargar datos para restaurar el valor anterior
          this.getData();
          return;
        }

        // Guardar el cambio
        const response = await this.$store.dispatch("productionUsers/save", value);
        
        if (response && response.status >= 200 && response.status < 300) {
          // Actualizar los datos localmente sin recargar toda la tabla
          const index = this.data.data.findIndex(item => item.id === value.id);
          if (index !== -1) {
            this.data.data[index] = { ...this.data.data[index], ...response.data };
          }
          
          // Mostrar mensaje de éxito
          await Swal.fire({
            icon: 'success',
            title: 'Cantidad cambiada',
            text: 'La cantidad recibida ha sido actualizada correctamente.',
            timer: 2000,
            showConfirmButton: false,
          });
        } else {
          throw new Error(response.data?.message || 'Error al actualizar la cantidad');
        }
      } catch (error) {
        console.error("Error al actualizar la cantidad recibida:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al actualizar la cantidad recibida',
        });
        // Recargar datos para restaurar el valor anterior
        this.getData();
      }
    },
    async deleteUserRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("productionUsers/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async generatePdf(id) {
      try {
        // Generar el PDF
        const response = await this.$store.dispatch("productionUsers/getPdf", id);
        
        // Crear una URL del archivo recibido
        const url = window.URL.createObjectURL(new Blob([response.data]));
        
        // Crear un enlace para descargar el archivo
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `formato_entrega_corte_${id}.pdf`);
        document.body.appendChild(link);
        link.click();
        
        // Limpiar la URL creada
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        await Swal.fire({
          icon: 'success',
          title: '¡Éxito!',
          text: 'El PDF se ha generado correctamente.',
          timer: 2000,
          showConfirmButton: false
        });
      } catch (error) {
        console.error("Error al generar el PDF:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || 'Error al generar el PDF',
        });
      }
    },
    // Métodos para selección masiva
    getItemState(item) {
      // Determinar el estado del registro: 'receive', 'deliver', 'validate', 'validated'
      if (item.validated_date != null) {
        return 'validated';
      }
      if (item.delivered_date != null && item.validated_date == null) {
        return 'validate';
      }
      if (item.received_date != null && item.delivered_date == null) {
        return 'deliver';
      }
      if (item.received_date == null) {
        return 'receive';
      }
      return null;
    },
    canSelectItem(item) {
      // Si no hay items seleccionados, permitir seleccionar
      if (this.selectedItems.length === 0) {
        return true;
      }
      // Si el item ya está validado, no se puede seleccionar
      if (item.validated_date != null) {
        return false;
      }
      // Verificar que el estado del item coincida con el estado de los items seleccionados
      const itemState = this.getItemState(item);
      return itemState === this.selectedItemsState;
    },
    handleCheckboxChange(item, event) {
      const isChecked = event.target.checked;
      const itemState = this.getItemState(item);
      
      // Si el item está validado, no permitir seleccionar
      if (item.validated_date != null) {
        event.target.checked = false;
        return;
      }
      
      if (isChecked) {
        // Si es el primer item seleccionado, agregarlo
        if (this.selectedItems.length === 0) {
          this.selectedItems.push(item.id);
        } else {
          // Obtener el estado del primer item seleccionado
          const firstSelected = Array.isArray(this.data.data) 
            ? this.data.data.find(i => this.selectedItems.includes(i.id))
            : null;
          const firstSelectedState = firstSelected ? this.getItemState(firstSelected) : null;
          
          // Verificar que el estado coincida
          if (itemState === firstSelectedState) {
            this.selectedItems.push(item.id);
          } else {
            // Si no coincide, mostrar mensaje y no seleccionar
            event.target.checked = false;
            Swal.fire({
              icon: 'warning',
              title: 'Atención',
              text: 'Solo puede seleccionar registros del mismo estado. Deseleccione los actuales para seleccionar otros.',
              timer: 2000,
              showConfirmButton: false,
            });
          }
        }
      } else {
        // Deseleccionar
        const index = this.selectedItems.indexOf(item.id);
        if (index > -1) {
          this.selectedItems.splice(index, 1);
        }
      }
    },
    toggleSelectAll() {
      if (!Array.isArray(this.data.data)) return;
      
      if (this.isAllSelected) {
        this.selectedItems = [];
      } else {
        // Solo seleccionar los items que no estén validados y que coincidan con el estado del primer item seleccionado
        if (this.selectedItems.length === 0) {
          // Si no hay nada seleccionado, seleccionar todos los que pueden recibir tarea
          this.selectedItems = this.data.data
            .filter(item => item.validated_date == null && item.received_date == null)
            .map(item => item.id);
        } else {
          // Si ya hay algo seleccionado, seleccionar todos los del mismo estado
          const state = this.selectedItemsState;
          if (state) {
            this.selectedItems = this.data.data
              .filter(item => this.getItemState(item) === state)
              .map(item => item.id);
          }
        }
      }
    },
    clearSelection() {
      this.selectedItems = [];
    },
    async bulkMarkAsReceived() {
      if (!Array.isArray(this.data.data) || this.selectedItems.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe seleccionar al menos un registro.',
        });
        return;
      }

      // Filtrar solo los que pueden ser marcados como recibidos
      const validIds = this.data.data
        .filter(item => this.selectedItems.includes(item.id) && item.received_date == null)
        .map(item => item.id);

      if (validIds.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Los registros seleccionados ya están marcados como recibidos o no pueden ser marcados.',
        });
        return;
      }

      try {
        const result = await Swal.fire({
          title: 'Marcar como Recibido',
          text: `¿Está seguro de marcar ${validIds.length} registro(s) como recibido(s)?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, marcar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          // Marcar cada registro como recibido
          const promises = validIds.map(id => {
            const item = this.data.data.find(i => i.id === id);
            if (item) {
              item.received_date = new Date().toISOString().slice(0, 10);
              return this.$store.dispatch("productionUsers/save", item);
            }
            return Promise.resolve();
          });

          await Promise.all(promises);
          
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: `${validIds.length} registro(s) marcado(s) como recibido(s) correctamente.`,
          });
          this.clearSelection();
          this.refreshCards(this.data.data.filter(item => validIds.includes(item.id)));
        }
      } catch (error) {
        console.error("Error al marcar como recibido:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al marcar los registros como recibidos',
        });
      }
    },
    async bulkMarkAsDelivered() {
      if (!Array.isArray(this.data.data) || this.selectedItems.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe seleccionar al menos un registro.',
        });
        return;
      }

      // Filtrar solo los que pueden ser marcados como entregados
      const validIds = this.data.data
        .filter(item => this.selectedItems.includes(item.id) && item.received_date != null && item.delivered_date == null)
        .map(item => item.id);

      if (validIds.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Los registros seleccionados ya están marcados como entregados o no pueden ser marcados.',
        });
        return;
      }

      try {
        const result = await Swal.fire({
          title: 'Marcar como Entregado',
          text: `¿Está seguro de marcar ${validIds.length} registro(s) como entregado(s)?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, marcar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          // Marcar cada registro como entregado
          const promises = validIds.map(id => {
            const item = this.data.data.find(i => i.id === id);
            if (item) {
              // La cantidad entregada por defecto es igual a la cantidad recibida
              const updatedItem = {
                ...item,
                delivered_date: new Date().toISOString().slice(0, 10),
                delivered_quantity: Number(item.received_quantity) || 0,
                observation: item.observation || '',
              };
              return this.$store.dispatch("productionUsers/save", updatedItem);
            }
            return Promise.resolve();
          });

          await Promise.all(promises);
          
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: `${validIds.length} registro(s) marcado(s) como entregado(s) correctamente.`,
          });
          this.clearSelection();
          this.refreshCards(this.data.data.filter(item => validIds.includes(item.id)));
        }
      } catch (error) {
        console.error("Error al marcar como entregado:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al marcar los registros como entregados',
        });
      }
    },
    async bulkMarkAsValidated() {
      if (!Array.isArray(this.data.data) || this.selectedItems.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe seleccionar al menos un registro.',
        });
        return;
      }

      // Filtrar solo los que pueden ser marcados como validados
      const validIds = this.data.data
        .filter(item => this.selectedItems.includes(item.id) && item.delivered_date != null && item.validated_date == null)
        .map(item => item.id);

      if (validIds.length === 0) {
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Los registros seleccionados ya están marcados como validados o no pueden ser marcados.',
        });
        return;
      }

      try {
        const result = await Swal.fire({
          title: 'Marcar como Validado',
          text: `¿Está seguro de marcar ${validIds.length} registro(s) como validado(s)? Se marcarán con 0 defectos.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, marcar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          // Marcar cada registro como validado
          const promises = validIds.map(id => {
            const item = this.data.data.find(i => i.id === id);
            if (item) {
              item.validated_date = new Date().toISOString().slice(0, 10);
              item.rejected_quantity = 0;
              item.finish = 1;
              return this.$store.dispatch("productionUsers/save", item);
            }
            return Promise.resolve();
          });

          await Promise.all(promises);
          
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: `${validIds.length} registro(s) marcado(s) como validado(s) correctamente.`,
          });
          this.clearSelection();
          this.refreshCards(this.data.data.filter(item => validIds.includes(item.id)));

          this.getModels();
          this.getOficios();
          this.getBodegas()
          this.getInsumos();
          
        }
      } catch (error) {
        console.error("Error al marcar como validado:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.response?.data?.message || error.message || 'Error al marcar los registros como validados',
        });
      }
    },
    async loadSettings() {
      try {
        const response = await this.$store.dispatch("settings/get");
        if (response && response.data) {
          this.benefitsOfTasks = response.data.benefits_of_tasks || false;
        }
      } catch (error) {
        console.error("Error al cargar la configuración:", error);
      }
    },

  },
  async mounted() {
    document.addEventListener('click', this.closeOficioFilterOnOutsideClick);

    const route = useRoute();
    const dataEdit = route.params.data;
    const queryId = route.query.id;

    (async () => {
      // Mostrar el modal de "Cargando"
      Swal.fire({
        icon: 'info',
        title: 'Cargando...',
        text: 'Estamos obteniendo los datos, por favor espera.',
        didOpen: () => {
          Swal.showLoading();
        },
        confirmButtonText: 'Aceptar',
        backdrop: true,
      });

      try {
        let isEditing = false;
        let params = null;

        // Determinar si es edición: por query param ?id= o por route.params.data
        if (queryId) {
          // Cargar producción desde la API usando el id de la URL
          const response = await this.$store.dispatch('production/getData', queryId);
          if (response && response.data) {
            params = response.data;
            isEditing = true;
          }
        } else if (dataEdit) {
          params = JSON.parse(dataEdit);
          isEditing = true;
        }

        // Configurar Select2 del modal de edición de insumos
        $(this.$refs.insumosEditSelect).select2({
          placeholder: 'Seleccione un insumo',
          allowClear: false,
          dropdownParent: $('#ModalEditInsumo .modal-body')
        });
        $(this.$refs.insumosEditSelect).on('change', () => {
          this.purchase.inventory_name = $(this.$refs.insumosEditSelect).val();
        });

        // === FASE 1: Cargar datos del card principal "Crear Produccion de Modelo" ===
        if (isEditing && params && params.id) {
          this.data = params;
          this.purchase.inventory_id = params.id || 0;
          this.size.model_id = params.id || 0;
          this.production_user.production_id = params.id || 0;
          this.production_model.production_id = params.id || 0;

          this.form.id = params.id || 0;
          this.form.model_id = params.model_id ?? null;
          this.form.purchase_number = params.purchase_number || '';
          this.form.description = params.description || '';
          this.form.status = params.status || 0;
          this.form.delivery_date = params.delivery_date || '';
          this.form.price = params.price || params.model?.price || 0;
          this.form.selling_cost = params.selling_cost || 0;
          this.form.wholesale_price = params.wholesale_price || 0;
          this.form.retail_price = params.retail_price || 0;
          this.form.oficio_id = params.oficio_id ? parseInt(params.oficio_id) : null;
          this.form.bodega_id = params.bodega_id ? parseInt(params.bodega_id) : null;
          this.form.etapa = params.etapa || '';
          this.form.is_maquila = Boolean(params.is_maquila);
          this.modal.project_id = params.id || 0;
        }

        // Cargar datos base del card principal (modelos, oficios, bodegas, insumos, grupos)
        await Promise.all([
          this.getModels(),
          this.getOficios(),
          this.getBodegas(),
          this.getAllInsumos(),
          this.getGroups(),
        ]);

        // Solo cargar tallas si hay un modelo seleccionado
        if (this.form.model_id) {
          await this.getSizes();
        }

        // Configurar Select2 una vez que los datos estén cargados
        this.$nextTick(() => {
          $(this.$refs.modelSelect).select2({
            placeholder: 'Seleccione un modelo',
            allowClear: false,
          }).on('change', () => {
            const selectedModelId = $(this.$refs.modelSelect).val();
            this.form.model_id = selectedModelId;
            
            if (selectedModelId) {
              const selectedModel = this.models.find(model => model.id == selectedModelId);
              if (selectedModel && selectedModel.price) {
                this.form.price = selectedModel.price;
              } else {
                this.form.price = 0;
              }
            } else {
              this.form.price = 0;
            }
          });

          if (this.form.model_id) {
            $(this.$refs.modelSelect).val(this.form.model_id).trigger('change');
          }
          this.syncModelSelectDisabledState();

          $(this.$refs.modelUserSelect).select2({
            placeholder: 'Seleccione un modelo',
            allowClear: false,
            dropdownParent: $('#ModalBudget .modal-body'),
          }).on('change', () => {
            this.production_user.production_models_id = $(this.$refs.modelUserSelect).val();

            this.$nextTick(() => {


              let modelo = this.insumos.filter(insumo =>
                insumo.id === parseInt(this.production_user?.production_models_id)
              );


              if (parseInt(this.production_user.production_models_id) === 0) {
                this.production_user.received_quantity = this.insumos.reduce((acc, item) => acc + item.quantity_to_produce, 0);
                this.total_modal_quantity = this.production_user.received_quantity;
              } else {

                if (modelo[0] && modelo[0].quantity_to_produce) {

                  console.log(modelo);
                  console.log(modelo[0]);
                  console.log(modelo[0].quantity_to_produce);

                  this.production_user.received_quantity = modelo[0].quantity_to_produce;
                  this.total_modal_quantity = this.production_user.received_quantity;
                }
              }

              this.applyPendingQuantity();
              this.prefillProcessPrice();
              this.validateQuantity();

            });
          });

          $(this.$refs.sizesSelect).select2({
            placeholder: 'Seleccione una o más tallas y colores',
            allowClear: true,
            multiple: true,
            dropdownParent: $('#ModalModel .modal-body'),
          }).on('change', () => {
          });

          $(this.$refs.usersSelect).select2({
            placeholder: 'Seleccione un usuario',
            allowClear: false,
            dropdownParent: $('#ModalBudget .modal-body'),
          }).on('change', () => {
            this.production_user.user_id = $(this.$refs.usersSelect).val();

            this.fieldPayment = true;

            // Al elegir usuario individual se descarta el grupo
            if (this.production_user.user_id && this.production_user.group_id && this.production_user.group_id != 0) {
              this.production_user.group_id = 0;
              if (this.$refs.grupoSelect) {
                $(this.$refs.grupoSelect).val(0).trigger('change.select2');
              }
            }
          });

          $(this.$refs.grupoSelect).select2({
            placeholder: 'Seleccione un grupo',
            allowClear: false,
            dropdownParent: $('#ModalBudget .modal-body'),
          }).on('change', () => {
            this.onGroupSelected();
          });

          $(this.$refs.processesSelect).select2({
            placeholder: 'Filtrar por oficio',
            dropdownParent: $('#ModalBudget .modal-body'),
          }).on('change', (event) => {
            this.oficio_id = $(event.target).val();
            this.filterUsersByOficio();
          });

          // Inicializar Select2 para etapa
          if (this.$refs.etapaSelect) {
            $(this.$refs.etapaSelect).select2({
              placeholder: 'Seleccionar etapa',
              allowClear: true,
            }).on('change', () => {
              const etapa = $(this.$refs.etapaSelect).val() || '';
              if (etapa === (this.form.etapa || '')) return;
              this.form.etapa = etapa;
              this.handleEtapaChange();
            });
            if (this.form.etapa) {
              $(this.$refs.etapaSelect).val(this.form.etapa).trigger('change.select2');
            }
          }

        });

        // === Cerrar el modal de carga: el card principal ya está listo ===
        Swal.close();

        // === FASE 2: Cargar cards secundarios con spinners ===
        if (isEditing && this.form.id) {
          // Cargar en paralelo: insumos, usuarios asignados, novedades
          // Cada card muestra su propio spinner mientras carga
          this.getInsumos();
          this.getData();
          this.getNovelties();
          this.getUsers();
        }

      } catch (error) {
        console.error("Error al cargar los datos:", error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un problema al cargar los datos. Por favor, inténtalo nuevamente.',
        });
      }
    })();

    // Cargar configuración de beneficios
    await this.loadSettings();

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {

    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeOficioFilterOnOutsideClick);
    // Destruir Select2 del select de modelo
    if (this.$refs.modelSelect && $(this.$refs.modelSelect).hasClass('select2-hidden-accessible')) {
      $(this.$refs.modelSelect).select2('destroy');
    }
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.observation-suggestion {
  max-width: 100%;
  text-transform: none;
  font-weight: 500;
}
.disabled-link {
  color: gray;
  pointer-events: none;
  /* Impide la interacción */
  cursor: not-allowed;
  /* Cambia el cursor para indicar que está deshabilitado */
}

/* Quitar el borde inferior de las filas de la tabla */
.accordion-body .table > :not(caption) > * > * {
  border-bottom-width: 0 !important;
}
</style>
